  (function() {
    const pricingConfig = window.__PDP_PRICING_EXPERIMENT_CONFIG__;
    if (!pricingConfig) return;

    function initPdpPricingExperiment() {
      const root = document.querySelector('[data-pdp-pricing-experiment]');
      if (!root) return;
      if (root.dataset.pdpPricingInit === 'true' || root.dataset.pdpPricingBootstrap === 'true') return;
      root.dataset.pdpPricingBootstrap = 'true';

      const state = window.__PDP_PRICING_EXPERIMENT__ = window.__PDP_PRICING_EXPERIMENT__ || {};
      state.active = false;
      const triggerClass = root.dataset.pdpPricingTriggerClass || 'pdp-pricing-experiment-trigger';
      const moneyFormat = root.dataset.moneyFormat || theme.settings.moneyFormat;
      const stripTrailingZeros = root.dataset.pdpStripTrailingZeros === 'true';
      const localizedMapPrintLabel = pricingConfig.localizedMapPrintLabel;
      const localizedMapPrintsLabel = pricingConfig.localizedMapPrintsLabel;
      const localizedArtPrintLabel = pricingConfig.localizedArtPrintLabel;
      const localizedFramedMapLabel = pricingConfig.localizedFramedMapLabel;
      const localizedFramedArtPrintLabel = pricingConfig.localizedFramedArtPrintLabel;
      const localizedFramedCanvasLabel = pricingConfig.localizedFramedCanvasLabel;
      const localizedPushPinMapLabel = pricingConfig.localizedPushPinMapLabel;
      const localizedFramedPushPinMapLabel = pricingConfig.localizedFramedPushPinMapLabel;
      const localizedPdpLabels = pricingConfig.localizedPdpLabels || {};
      const localizedSummaryLabels = pricingConfig.localizedSummaryLabels || {};
      const isMetaFineArtTraffic = pricingConfig.productType === 'Fine art' && !!(
        window.UMMetaReferral && window.UMMetaReferral.detected
      );
      const summaryBaseNoun = String(root.dataset.pdpSummaryBaseNoun || localizedMapPrintLabel).trim() || localizedMapPrintLabel;
      // Reversible summary presentation switch. Set to false to restore the
      // separate base-print and framing-price rows.
      const combineMainProductSummaryLine = true;
      const htmlEl = document.documentElement;
      const finishFirstModeEnabled =
        root.dataset.pdpPricingExperimentFinishFirst === 'true' ||
        htmlEl.classList.contains('pdp-pricing-finish-first-trigger');

      function shouldShowSummary() {
        return true;
      }
      function syncSummaryVisibility() {
        const show = shouldShowSummary();
        document.querySelectorAll('[data-pdp-pricing-summary-card]').forEach(function(node) {
          node.hidden = !show;
        });
      }

      const canonicalProductData = window.__THEME_PRODUCT_DATA__;
      const productSection = root.closest('[data-product-id]');
      // Product-specific multi-piece summary copy. Add future sets here without
      // changing the standard summary renderer.
      const multiPieceSummaryConfigs = {
        '6537661317182': {
          summaryTitle: 'Your complete set',
          productTitle: 'Old London Map Triptych',
          panelCount: 3,
          pieceCountLabel: 'Three',
          frameNoun: 'frames'
        },
        '4403399786558': {
          summaryTitle: 'Your complete set',
          productTitle: '24-panel Rocque Map of London',
          panelCount: 24,
          finishMatch: '24 pieces',
          panelDescription: '24 numbered panels \u00b7 8 \u00d7 3 arrangement',
          unframedDetail: 'Ready to frame',
          frameNoun: 'frames'
        }
      };
      const currentProductId = String(
        (canonicalProductData && canonicalProductData.productId) ||
        (productSection && productSection.dataset.productId) ||
        ''
      );
      const multiPieceProductConfig = multiPieceSummaryConfigs[currentProductId] || null;
      function getActiveMultiPieceConfig(rawFinishValue, rawFinishLabel) {
        if (!multiPieceProductConfig) return null;
        const finishText = String(rawFinishValue || '') + ' ' + String(rawFinishLabel || '');
        if (
          multiPieceProductConfig.finishMatch &&
          !finishText.toLowerCase().includes(String(multiPieceProductConfig.finishMatch).toLowerCase())
        ) {
          return null;
        }
        return multiPieceProductConfig;
      }
      const variants = canonicalProductData &&
        productSection &&
        String(canonicalProductData.productId) === String(productSection.dataset.productId) &&
        Array.isArray(canonicalProductData.variants)
        ? canonicalProductData.variants
        : [];
      const addonsEl = root.querySelector('[data-pdp-pricing-addons]');
      const mainPriceEl = root.querySelector('[data-pdp-main-price]');
      const mainComparePriceEl = root.querySelector('[data-compare-price]');
      const mainComparePriceWrapEl = root.querySelector('[data-product-price-wrap]');
      const mainRegularPriceA11yEl = root.querySelector('[data-a11y-price]');
      const pseudoSaleSavingsEl = root.querySelector('[data-pdp-pseudo-sale-savings]');
      const pseudoSaleSavingsAmountEl = root.querySelector('[data-pdp-pseudo-sale-savings-amount]');
      const mainPriceRowEl = root.querySelector('.pdp-price-row__top');
      let mainPriceBadgeLayoutRaf = null;

      function syncMainPriceBadgeLayout() {
        mainPriceBadgeLayoutRaf = null;
        if (!mainPriceRowEl || !pseudoSaleSavingsEl) return;

        mainPriceRowEl.classList.remove('pdp-price-row__top--compact-savings');
        if (pseudoSaleSavingsEl.classList.contains('hide')) return;

        const availableWidth = root.getBoundingClientRect().width;
        const expandedWidth = mainPriceRowEl.scrollWidth;
        mainPriceRowEl.classList.toggle(
          'pdp-price-row__top--compact-savings',
          expandedWidth > Math.max(0, availableWidth - 6)
        );
      }

      function scheduleMainPriceBadgeLayout() {
        if (mainPriceBadgeLayoutRaf !== null) return;
        mainPriceBadgeLayoutRaf = window.requestAnimationFrame(syncMainPriceBadgeLayout);
      }

      const pseudoSaleActive = mainPriceEl?.dataset.pdpPseudoSaleActive === 'true';
      const pseudoSaleFeaturedBandActive = mainPriceEl?.dataset.pdpPseudoSaleFeaturedBandActive === 'true';
      const pseudoSalePercent = Math.min(99, Math.max(0, Number(mainPriceEl?.dataset.pdpPseudoSalePercent || 0)));
      const pseudoSaleMinPrice = Math.max(0, Number(mainPriceEl?.dataset.pdpPseudoSaleMinPrice || 5900));
      const pseudoSaleMaxPrice = Math.max(pseudoSaleMinPrice, Number(mainPriceEl?.dataset.pdpPseudoSaleMaxPrice || 8900));
      const pseudoSalePercentageOnly = String(mainPriceEl?.dataset.pdpPseudoSaleMarket || '').trim().toLowerCase() === 'eurozone';
      let featuredBandSaleSizeHandles = new Set();
      const sizeFieldset = document.querySelector('.variant-input-wrap[data-handle="size"], fieldset.variant-input-wrap[data-handle="size"]');
      const finishFieldset = document.querySelector('.variant-input-wrap[data-handle="finish"], fieldset.variant-input-wrap[data-handle="finish"], .variant-input-wrap[data-handle="finition"], fieldset.variant-input-wrap[data-handle="finition"]');
      const allOptionFieldsets = Array.from(document.querySelectorAll('.variant-input-wrap[data-index], fieldset.variant-input-wrap[data-index]'));
      const summaryCardEl = document.querySelector('[data-pdp-pricing-summary-card]');
      const summaryTitleEl = document.querySelector('[data-pdp-summary-title]');
      const defaultSummaryTitle = String(summaryTitleEl?.textContent || '').trim();
      const baseLabelEl = document.querySelector('[data-pdp-summary-base-label]');
      const baseValueEl = document.querySelector('[data-pdp-summary-base-value]');
      const framedDetailEl = document.querySelector('[data-pdp-summary-framed-detail]');
      const variantArtworkRowEl = document.querySelector('[data-pdp-summary-variant-artwork]');
      const variantArtworkValueEl = document.querySelector('[data-pdp-summary-variant-artwork-value]');
      const designRowEl = document.querySelector('[data-pdp-summary-design]');
      const frameRowEl = document.querySelector('[data-pdp-summary-finish]');
      const frameLabelEl = document.querySelector('[data-pdp-summary-finish-label]');
      const frameValueEl = document.querySelector('[data-pdp-summary-frame-value]');
      const finishItemsEl = document.querySelector('[data-pdp-summary-finish-items]');
      const personalisationRowEl = document.querySelector('[data-pdp-summary-personalisation]');
      const personalisationValueEl = document.querySelector('[data-pdp-summary-personalisation-value]');
      const addonsListEl = document.querySelector('[data-pdp-summary-personalisation-items]');
      const totalRowEl = document.querySelector('[data-pdp-summary-total-row]');
      const totalCompareEl = document.querySelector('[data-pdp-summary-total-compare]');
      const totalEl = document.querySelector('[data-pdp-summary-total]');
      const totalSaleNameEl = document.querySelector('[data-pdp-summary-sale-name]');
      const pseudoSaleEndsDate = String(totalSaleNameEl?.dataset.pdpSummarySaleEndsDate || '').trim();
      function isFinishFirstMode() {
        return finishFirstModeEnabled;
      }
      const finishFirstLayout = document.querySelector('[data-pdp-pricing-finish-first-layout]');
      const finishFirstFinishSlot = document.querySelector('[data-pdp-pricing-finish-first-finish-slot]');
      const finishFirstFrameSlot = document.querySelector('[data-pdp-pricing-finish-first-frame-slot]');
      const finishFirstSizeSlot = document.querySelector('[data-pdp-pricing-finish-first-size-slot]');
      const pricingSizeSection = document.querySelector('[data-pdp-pricing-size-section]');
      const sizePosition = parseInt(root.dataset.sizeOptionPosition || '0', 10);
      const finishPosition = parseInt(root.dataset.finishOptionPosition || '0', 10);
      const finishSection = document.querySelector('[data-pdp-pricing-finish-first-finish-section]');
      const hostBlock = finishSection ? finishSection.closest('.product-block') : null;
      const searchRoot =
        (finishSection && (
          finishSection.closest('[data-product-blocks]') ||
          finishSection.closest('[data-section-id]') ||
          hostBlock
        )) ||
        document;

      if (!variants.length || !mainPriceEl || !sizePosition || !finishPosition || !sizeFieldset || !finishSection || !hostBlock) return;
      root.dataset.pdpPricingInit = 'true';
      root.dataset.pdpPricingBootstrap = 'false';
      root.dataset.pdpSummaryCombinedMainProduct = combineMainProductSummaryLine ? 'true' : 'false';
      state.active = true;
      state.finishFirstSizePreserveVersion = 'v2';
      root.dataset.pdpFinishFirstSizePreserveVersion = 'v2';

      root.classList.add('pdp-pricing-experiment--active');
      syncSummaryVisibility();
      document.querySelectorAll('.size-help').forEach(function(node) {
        node.hidden = true;
        node.style.display = 'none';
      });
      sizeFieldset.classList.add('pdp-pricing-experiment--size-fieldset');
      if (finishFieldset) {
        finishFieldset.classList.add('pdp-pricing-experiment--finish-fieldset');
      }
      document.querySelectorAll('.um-featured-sizes-card, .um-summary-card').forEach(function(node) {
        node.remove();
      });
      sizeFieldset.querySelectorAll('.variant-input-group-subheader').forEach(function(node) {
        node.remove();
      });

      function handleize(value) {
        return String(value || '')
          .toLowerCase()
          .trim()
          .replace(/['"]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      function getLocalizedFrameColourLabel(value) {
        const colourHandle = handleize(value).replace(/-standard$/, '');
        const colourLabels = {
          'black': localizedPdpLabels.frameColourBlack,
          'dark-brown': localizedPdpLabels.frameColourDarkBrown,
          'antique-gold': localizedPdpLabels.frameColourAntiqueGold,
          'antique-silver': localizedPdpLabels.frameColourAntiqueSilver,
          'dark-grey': localizedPdpLabels.frameColourDarkGrey,
          'dark-gray': localizedPdpLabels.frameColourDarkGrey,
          'oak': localizedPdpLabels.frameColourOak,
          'solid-oak': localizedPdpLabels.frameColourOak,
          'white': localizedPdpLabels.frameColourWhite,
          'custom': localizedPdpLabels.frameColourCustom
        };
        return String(colourLabels[colourHandle] || value || '').trim();
      }

      function formatLocalizedFrameColour(colourValue, frameLabel) {
        const colourLabel = getLocalizedFrameColourLabel(colourValue);
        if (!colourLabel) return '';
        return String(localizedPdpLabels.frameColourFrameTemplate || '[colour] [frame]')
          .replace('[colour]', colourLabel)
          .replace('[frame]', String(frameLabel || localizedSummaryLabels.frame || '').trim())
          .replace(/\s+/g, ' ')
          .trim();
      }

      function localizeFrameColourControls() {
        document.querySelectorAll('.option_frame_colour_new').forEach(function(block) {
          const title = block.querySelector('.spb-label-tooltip > label, :scope > label');
          if (title && localizedPdpLabels.frameColourTitle) {
            const titleTextNode = Array.from(title.childNodes).find(function(node) {
              return node.nodeType === Node.TEXT_NODE && String(node.nodeValue || '').trim();
            });
            if (titleTextNode) {
              titleTextNode.nodeValue = localizedPdpLabels.frameColourTitle;
            } else {
              title.insertBefore(document.createTextNode(localizedPdpLabels.frameColourTitle), title.firstChild);
            }
          }

          block.querySelectorAll('label.spb-productoptionswatchwrapper').forEach(function(wrapper) {
            const input = wrapper.querySelector('input[type="radio"], input[type="checkbox"]');
            if (!input) return;
            const displayLabel = getLocalizedFrameColourLabel(input.value);
            if (!displayLabel) return;

            let labelNode = wrapper.querySelector(':scope > .pdp-localized-frame-colour-label, :scope > .spb-swatchlabel');
            if (!labelNode) {
              const directTextNode = Array.from(wrapper.childNodes).find(function(node) {
                return node.nodeType === Node.TEXT_NODE && String(node.nodeValue || '').trim();
              });
              if (directTextNode) {
                labelNode = document.createElement('span');
                labelNode.className = 'pdp-localized-frame-colour-label';
                directTextNode.parentNode.replaceChild(labelNode, directTextNode);
              } else {
                labelNode = document.createElement('span');
                labelNode.className = 'pdp-localized-frame-colour-label';
                wrapper.appendChild(labelNode);
              }
            }
            labelNode.classList.add('pdp-localized-frame-colour-label');
            labelNode.textContent = displayLabel;
          });
        });
      }

      function calculatePseudoSalePrice(cents) {
        return theme.Currency.calculatePseudoSalePrice(cents, pseudoSalePercent);
      }

      function applyPseudoSale(cents) {
        if (!pseudoSaleActive) return Number(cents || 0);
        return calculatePseudoSalePrice(cents);
      }

      function parseJson(el, fallback) {
        if (!el) return fallback;
        try {
          return JSON.parse(el.textContent || '');
        } catch (error) {
          console.error('PDP pricing experiment: could not parse JSON', error);
          return fallback;
        }
      }

      function toCents(value) {
        if (typeof value === 'number' && !Number.isNaN(value)) return Math.round(value);
        if (typeof value === 'string' && /^-?\d+$/.test(value.trim())) return parseInt(value.trim(), 10);
        return null;
      }

      function normalizeAddonConfig(rawConfig) {
        const source = rawConfig && typeof rawConfig === 'object' && rawConfig.options ? rawConfig.options : rawConfig;
        const normalized = {};

        Object.entries(source || {}).forEach(function(entry) {
          const rawHandle = entry[0];
          const rawEntries = entry[1];
          const handle = handleize(rawHandle);
          if (!handle || !rawEntries || typeof rawEntries !== 'object') return;

          normalized[handle] = {};
          Object.entries(rawEntries).forEach(function(rawEntryPair) {
            const rawValue = rawEntryPair[0];
            const rawEntry = rawEntryPair[1];
            const valueKey = handleize(rawValue);
            if (!valueKey) return;

            if (typeof rawEntry === 'number' || typeof rawEntry === 'string') {
              const cents = toCents(rawEntry);
              if (cents === null) return;
              normalized[handle][valueKey] = { label: rawValue, price: cents };
              return;
            }

            if (rawEntry && typeof rawEntry === 'object') {
              const cents =
                toCents(rawEntry.cents) ??
                toCents(rawEntry.price) ??
                toCents(rawEntry.amount);

              normalized[handle][valueKey] = {
                label: rawEntry.label || rawValue,
                price: cents,
                productHandle: rawEntry.productHandle || rawEntry.handle || '',
                requiresApproval: typeof rawEntry.requiresApproval === 'boolean' ? rawEntry.requiresApproval : undefined,
                productId: toCents(rawEntry.productId)
              };
            }
          });
        });

        return normalized;
      }

      function mergeAddonConfig(baseConfig, overrideConfig) {
        const merged = {};

        [baseConfig, overrideConfig].forEach(function(config) {
          Object.entries(config || {}).forEach(function(handleEntry) {
            const handle = handleEntry[0];
            const values = handleEntry[1];
            if (!merged[handle]) merged[handle] = {};
            Object.assign(merged[handle], values || {});
          });
        });

        return merged;
      }

      const sharedDefaultAddonConfig = parseJson(document.getElementById('um-addon-config-json'), {});
      const defaultAddonConfig = normalizeAddonConfig(sharedDefaultAddonConfig);
      const addonConfig = mergeAddonConfig(defaultAddonConfig, normalizeAddonConfig(parseJson(addonsEl, {})));
      const baseFinishHandles = new Set(['map', 'art-print', 'unframed', 'map-only', 'print-only', 'push-pin-map']);
      const addonProductCache = new Map();
      const originalSizeOrder = new Map(
        Array.from(sizeFieldset.querySelectorAll('.variant-input[data-value]')).map(function(node, index) {
          return [node.dataset.value || '', index];
        })
      );
      const optionPositions = allOptionFieldsets
        .map(function(fieldset) {
          return parseInt(String(fieldset.dataset.index || '').replace('option', ''), 10);
        })
        .filter(function(position, index, array) {
          return Number.isInteger(position) && array.indexOf(position) === index;
        })
        .sort(function(a, b) {
          return a - b;
        });
      function getUrlVariantState() {
        try {
          const searchParams = new URL(window.location.href).searchParams;
          const hasVariantParam = searchParams.has('variant');
          const rawVariantId = hasVariantParam ? searchParams.get('variant') : null;
          const normalizedVariantId = rawVariantId == null ? '' : String(rawVariantId).trim();

          if (!hasVariantParam) {
            return {
              hasVariantParam: false,
              isExplicitEmpty: false,
              variant: null
            };
          }

          if (!normalizedVariantId) {
            return {
              hasVariantParam: true,
              isExplicitEmpty: true,
              variant: null
            };
          }

          const matchedVariant = variants.find(function(variant) {
            return String(variant.id) === String(normalizedVariantId);
          }) || null;

          return {
            hasVariantParam: true,
            isExplicitEmpty: false,
            variant: matchedVariant
          };
        } catch (error) {
          return {
            hasVariantParam: false,
            isExplicitEmpty: false,
            variant: null
          };
        }
      }

      const initialVariantUrlState = getUrlVariantState();
      const initialUrlVariant = initialVariantUrlState.variant;
      const hasExplicitEmptyUrlVariant = !!initialVariantUrlState.isExplicitEmpty;
      const hasMissingUrlVariantParam = !initialVariantUrlState.hasVariantParam;
      const shouldAutoFramedClassicFromUrl = hasExplicitEmptyUrlVariant || hasMissingUrlVariantParam;
      const pendingAutoClassicTraceEvents = [];
      function queueAutoClassicTrace(step, payload) {
        pendingAutoClassicTraceEvents.push({
          step: step,
          payload: payload || {}
        });
      }
      function bootstrapAutoClassicUrlTrace() {
        queueAutoClassicTrace('url-state', {
          hasVariantParam: initialVariantUrlState.hasVariantParam,
          isExplicitEmpty: initialVariantUrlState.isExplicitEmpty,
          isMissingVariantParam: hasMissingUrlVariantParam,
          shouldAutoFramedClassicFromUrl: shouldAutoFramedClassicFromUrl,
          hasInitialVariant: !!initialUrlVariant,
          initialVariantId: initialUrlVariant ? initialUrlVariant.id : null
        });
      }
      bootstrapAutoClassicUrlTrace();
      const useUsGrandSizeRule = pricingConfig.useUsGrandSizeRule === true;
      let hasVariantOptionInteraction = window.__UMC_EARLY_VARIANT_INTERACTION__ === true;
      let hasFinishOptionInteraction = false;
      let hasAppliedBareUrlStatementDefault = false;
      const activeSelectionStorageKey = 'um_pdp_active_selections_v1';
      const activeSelectionPageLoadId = window.__UM_PDP_ACTIVE_SELECTION_PAGE_LOAD_ID__ ||
        (String(Date.now()) + '-' + Math.random().toString(36).slice(2));
      window.__UM_PDP_ACTIVE_SELECTION_PAGE_LOAD_ID__ = activeSelectionPageLoadId;
      let activeSessionSelections = readActiveSessionSelections();
      let hasAttemptedSessionSelectionRestore = false;
      let hasRestoredSessionVariantSelection = false;
      let hasRestoredSessionFrameColour = false;
      let currentVariant = initialUrlVariant || null;
      let lastKnownSizeValue = currentVariant ? getVariantOptionValue(currentVariant, sizePosition) : '';
      let intendedSizeValue = lastKnownSizeValue;
      let renderRaf = null;
      let pendingVariant = null;
      let pricingRenderRevision = 0;
      let lastVariantConfirmation = null;
      let settledRenderTimeout = null;
      let settledSanitizeTimeout = null;
      let sizeMutationObserver = null;
      let visibilityCache = new WeakMap();
      let isSyncingExpandedList = false;
      let refreshQueued = false;
      let lastLayoutSignature = '';
      let observerCooldownUntil = 0;
      let swatchSyncCooldownUntil = 0;
      let frameColourSyncQueued = false;
      let hasLoggedAutoClassicGateState = false;
      const hasSummaryUi = !!(baseLabelEl || baseValueEl || frameRowEl || finishItemsEl || addonsListEl || totalEl || personalisationRowEl || personalisationValueEl);
      state.cashbackBridgeEnabled = false;

      function readActiveSessionSelections() {
        try {
          const parsed = JSON.parse(window.sessionStorage.getItem(activeSelectionStorageKey) || '{}');
          if (!parsed || typeof parsed !== 'object') return {};
          const selections = ['size', 'finish', 'frameColour'].reduce(function(result, key) {
            const value = typeof parsed[key] === 'string' ? parsed[key].trim() : '';
            if (value) result[key] = value;
            return result;
          }, {});
          const sourcePageLoadId = typeof parsed.sourcePageLoadId === 'string'
            ? parsed.sourcePageLoadId.trim()
            : '';
          if (sourcePageLoadId) selections.sourcePageLoadId = sourcePageLoadId;
          return selections;
        } catch (error) {
          return {};
        }
      }

      function rememberActiveSessionSelection(key, value) {
        if (['size', 'finish', 'frameColour'].indexOf(key) === -1) return;
        const normalizedValue = String(value || '').trim();
        if (!normalizedValue) return;
        const isAlreadyCurrent =
          activeSessionSelections[key] === normalizedValue &&
          activeSessionSelections.sourcePageLoadId === activeSelectionPageLoadId;
        if (isAlreadyCurrent) return;

        activeSessionSelections[key] = normalizedValue;
        activeSessionSelections.sourcePageLoadId = activeSelectionPageLoadId;
        if (key === 'frameColour') {
          window.__UM_PDP_ACTIVE_FRAME_COLOUR_PREFERENCE__ = normalizedValue;
        }
        try {
          window.sessionStorage.setItem(activeSelectionStorageKey, JSON.stringify(activeSessionSelections));
        } catch (error) {
          // Storage can be unavailable in private or restricted browser contexts.
        }
      }

      function syncCashbackPlacement() {}
      function applyPricingSizeFirstLayout() {
        if (!pricingSizeSection || !finishSection) return true;

        const targetParent = finishSection.parentNode;
        if (!targetParent) return false;

        if (pricingSizeSection.parentNode !== targetParent || pricingSizeSection.nextElementSibling !== finishSection) {
          targetParent.insertBefore(pricingSizeSection, finishSection);
        }

        hostBlock.classList.add('pdp-pricing-experiment--size-first');
        return true;
      }

      function forceFinishFirstDomOrder() {
        if (!pricingSizeSection || !finishSection) return false;
        const parent = finishSection.parentNode;
        if (!parent || pricingSizeSection.parentNode !== parent) return false;
        if (finishSection.nextElementSibling !== pricingSizeSection) {
          parent.insertBefore(finishSection, pricingSizeSection);
        }
        hostBlock.classList.remove('pdp-pricing-experiment--size-first');
        hostBlock.classList.add('pdp-pricing-experiment--finish-first-active');
        return true;
      }

      function applyFinishFirstLayout() {
        if (!isFinishFirstMode()) return true;
        if (!finishFirstLayout || !finishFirstFinishSlot || !finishFirstFrameSlot || !finishFirstSizeSlot) {
          if (!pricingSizeSection || !finishSection) return false;
          const targetParent = finishSection.parentNode;
          if (!targetParent || pricingSizeSection.parentNode !== targetParent) return false;
          if (finishSection.nextElementSibling !== pricingSizeSection) {
            targetParent.insertBefore(finishSection, pricingSizeSection);
          }
          hostBlock.classList.remove('pdp-pricing-experiment--size-first');
          hostBlock.classList.add('pdp-pricing-experiment--finish-first-active');
          return true;
        }

        const sizeSection = document.querySelector('[data-pdp-pricing-finish-first-size-section]');
        const finishSectionNode = document.querySelector('[data-pdp-pricing-finish-first-finish-section]');
        const frameColourBlock =
          document.querySelector('[data-pdp-pricing-finish-first-finish-section] > .option_frame_colour_new') ||
          document.querySelector('#infiniteoptions-container .option_frame_colour_new') ||
          document.querySelector('.option_frame_colour_new');
        const customFrameBlock =
          document.querySelector('[data-pdp-pricing-finish-first-finish-section] > .option_custom_frame_colour_new') ||
          (
            frameColourBlock?.nextElementSibling &&
            frameColourBlock.nextElementSibling.classList.contains('option_custom_frame_colour_new')
              ? frameColourBlock.nextElementSibling
              : null
          ) ||
          document.querySelector('#infiniteoptions-container .option_custom_frame_colour_new') ||
          document.querySelector('.option_custom_frame_colour_new');

        if (!sizeSection || !finishSectionNode || !frameColourBlock) return false;

        if (!finishFirstFinishSlot.contains(finishSectionNode)) {
          finishFirstFinishSlot.appendChild(finishSectionNode);
        }

        const finishCard =
          finishSectionNode.querySelector('.variant-wrapper[data-handle="finish"]') ||
          finishSectionNode.querySelector('.variant-wrapper.io-card') ||
          null;
        const finishBridgeTarget = finishCard || finishSectionNode.lastElementChild;

        if (finishCard) {
          finishCard.classList.add('io-card', 'io-bridge-top');
        }

        frameColourBlock.classList.add('io-card', 'io-bridge-follow');
        frameColourBlock.setAttribute('data-pdp-finish-first-frame-colour', 'true');

        if (!finishSectionNode.contains(frameColourBlock)) {
          if (finishBridgeTarget && finishBridgeTarget.parentNode === finishSectionNode) {
            finishBridgeTarget.insertAdjacentElement('afterend', frameColourBlock);
          } else {
            finishSectionNode.appendChild(frameColourBlock);
          }
        }

        if (customFrameBlock) {
          customFrameBlock.classList.add('io-card');
          customFrameBlock.setAttribute('data-pdp-finish-first-custom-frame', 'true');
        }

        if (customFrameBlock && !finishSectionNode.contains(customFrameBlock)) {
          frameColourBlock.insertAdjacentElement('afterend', customFrameBlock);
        }

        if (!finishFirstSizeSlot.contains(sizeSection)) {
          finishFirstSizeSlot.appendChild(sizeSection);
        }

        if (finishFirstFrameSlot) {
          finishFirstFrameSlot.hidden = true;
        }

        finishFirstLayout.hidden = false;
        root.classList.add('pdp-pricing-experiment--finish-first-active');
        ensureAgedToneProxy();
        return true;
      }

      function waitForFinishFirstLayout() {
        if (!isFinishFirstMode()) return;
        if (applyFinishFirstLayout() || forceFinishFirstDomOrder()) return;

        const observer = new MutationObserver(function() {
          if (!(applyFinishFirstLayout() || forceFinishFirstDomOrder())) return;
          observer.disconnect();
          scheduleRender();
        });

        observer.observe(document.body, { childList: true, subtree: true });

        window.setTimeout(function() {
          observer.disconnect();
        }, 8000);
      }

      function syncLegacyHiddenClassNames() {
        const searchTargets = searchRoot.querySelectorAll(
          '.option_frame_colour_new, .option_frame_colour_new *, .option_custom_frame_colour_new, .option_custom_frame_colour_new *, .hanger_checkbox, .hanger_checkbox *, .option_hanger_colour, .option_hanger_colour *'
        );
        searchTargets.forEach(function(node) {
          if (node.classList.contains('hide-oos-disabled')) {
            node.classList.add('hide-oos-disable');
          }
        });
      }

      function syncSwatchSelectedState(block) {
        if (!block) return;

        block.querySelectorAll('label.spb-productoptionswatchwrapper').forEach(function(wrapper) {
          const input = wrapper.querySelector('input[type="radio"], input[type="checkbox"]');
          wrapper.classList.toggle('selected', !!(input && input.checked));
        });
      }

      function ensureDefaultFrameColour(frameColourBlock) {
        if (!frameColourBlock) return;
        if (!finishNeedsFrameColourBlock()) return;

        const frameColourInputs = Array.from(
          frameColourBlock.querySelectorAll('input[type="radio"][name="properties[Frame colour]"]')
        );
        const preferredFrameColour = String(window.__UM_PDP_ACTIVE_FRAME_COLOUR_PREFERENCE__ || '').trim();
        const preferredInput = preferredFrameColour
          ? frameColourInputs.find(function(input) {
              return !input.disabled && String(input.value || '').trim() === preferredFrameColour;
            })
          : null;
        const checkedInput = frameColourInputs.find(function(input) {
          return input.checked;
        }) || null;
        if (preferredInput && checkedInput !== preferredInput) {
          frameColourInputs.forEach(function(input) {
            input.checked = input === preferredInput;
          });
          root.dataset.pdpPricingDefaultFrameApplied = 'true';
          preferredInput.dispatchEvent(new Event('input', { bubbles: true }));
          preferredInput.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        if (checkedInput) {
          root.dataset.pdpPricingDefaultFrameApplied = 'true';
          return;
        }

        const blackInput = frameColourInputs.find(function(input) {
          return (input.value || '').trim().toLowerCase() === 'black';
        });

        if (!blackInput) return;

        root.dataset.pdpPricingDefaultFrameApplied = 'true';
        blackInput.checked = true;
        blackInput.dispatchEvent(new Event('input', { bubbles: true }));
        blackInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function getAgedToneValueFromRealControl() { const c = document.querySelector('[name="properties[Colour tone]"][type="radio"]:checked'); return String(c && c.value || '').trim().toLowerCase() === 'aged' ? 'aged' : 'original'; }
      function dispatchAgedToneEvent(el, type) {
        try {
          el.dispatchEvent(new Event(type, { bubbles: true }));
        } catch (error) {
          const event = document.createEvent('Event');
          event.initEvent(type, true, true);
          el.dispatchEvent(event);
        }
      }
      function setRealAgedToneValue(nextValue) {
        const n = String(nextValue || '').trim().toLowerCase() === 'aged' ? 'aged' : 'original';
        const t = Array.from(document.querySelectorAll('[name="properties[Colour tone]"][type="radio"]')).find(function(input){ return String(input.value || '').trim().toLowerCase() === n; });
        if (!t) return false; if (!t.checked) { t.checked = true; dispatchAgedToneEvent(t, 'input'); dispatchAgedToneEvent(t, 'change'); }
        return true;
      }
      function gs(){return document.querySelector('#infiniteoptions-container select[name="properties[Aged Level]"]');}
      function ga(){const s=gs();return s?String(s.value||'').trim():'';}
      function sa(v){const s=gs();if(!s)return false;const t=String(v||'').trim().toLowerCase();if(!t)return false;const o=Array.from(s.options||[]).find(function(x){return String(x.value||'').trim().toLowerCase()===t;});const n=o&&o.value?o.value:'';if(!n)return false;if(String(s.value||'').trim()===n)return true;s.value=n;window._u=n;s.dispatchEvent(new Event('input',{bubbles:true}));s.dispatchEvent(new Event('change',{bubbles:true}));return true;}
      function ra(){const c=(window._u&&String(window._u).trim())||'Balanced';window._u=c;if(!sa(c))sa('Balanced');}
      function ba(){const s=gs();if(!s||s.dataset.ab==='1')return;s.dataset.ab='1';const f=function(){if(getAgedToneValueFromRealControl()==='aged'){const c=ga();if(c)window._u=c;}};s.addEventListener('input',f);s.addEventListener('change',f);}
      function getAgedToneProxyDescription() {
        const currentTone = getAgedToneValueFromRealControl();
        if (currentTone !== 'aged') return localizedPdpLabels.colourToneOriginalDescription;

        const agedLevel = (window._u || 'balanced').toLowerCase();
        if (agedLevel === 'subtle') return localizedPdpLabels.colourToneAgedSubtleDescription;
        if (agedLevel === 'rich') return localizedPdpLabels.colourToneAgedRichDescription;
        return localizedPdpLabels.colourToneAgedBalancedDescription;
      }
      function normalizeAgedToneExamplesTrigger(trigger) {
        if (!trigger) return trigger;
        Array.from(trigger.childNodes).forEach(function(child) {
          if (child.nodeType === 3 && child.nodeValue.trim() === '.') child.remove();
        });
        return trigger;
      }
      function getAgedToneExamplesTrigger() {
        const existingTrigger = document.querySelector('#agedMidflowOption [data-pdp-aged-examples-trigger]');
        if (existingTrigger && existingTrigger.tagName && existingTrigger.tagName.toLowerCase() === 'tool-tip-trigger') {
          bindAgedToneExamplesCommonNinja(existingTrigger);
          return normalizeAgedToneExamplesTrigger(existingTrigger);
        }

        const sourceTrigger = document.querySelector('#AgedHelperText tool-tip-trigger');
        if (!sourceTrigger) return null;
        if (existingTrigger) existingTrigger.remove();

        const clonedTrigger = sourceTrigger.cloneNode(true);
        clonedTrigger.setAttribute('data-pdp-aged-examples-trigger', '');
        const triggerTitle = clonedTrigger.querySelector('.tool-tip-trigger__title');
        if (triggerTitle) triggerTitle.textContent = 'See examples';
        const triggerContent = clonedTrigger.querySelector('[data-tool-tip-content]');
        if (triggerContent) {
          triggerContent.classList.add('tool-tip-trigger__content');
          triggerContent.style.display = 'none';
        }
        bindAgedToneExamplesCommonNinja(clonedTrigger);
        return normalizeAgedToneExamplesTrigger(clonedTrigger);
      }
      function bindAgedToneExamplesCommonNinja(trigger) {
        if (!trigger || trigger.dataset.agedProxyCommonNinjaBound === '1') return;
        trigger.dataset.agedProxyCommonNinjaBound = '1';
        const triggerTitle = trigger.querySelector('.tool-tip-trigger__title');
        if (!triggerTitle) return;
        triggerTitle.addEventListener('click', function() {
          [50, 250, 800].forEach(function(delay) {
            setTimeout(function() {
              if (typeof window.__umEnsureCommonNinja === 'function') {
                window.__umEnsureCommonNinja(document);
              }
            }, delay);
          });
        }, { passive: true });
      }
      function scheduleAgedToneProxySync(p) {
        if (!p || p.__agedToneProxyDelayedSyncQueued) return;
        p.__agedToneProxyDelayedSyncQueued = true;
        [0, 80, 250, 700, 1500].forEach(function(delay) {
          setTimeout(function() {
            syncAgedToneProxyState(p);
            if (delay === 1500) p.__agedToneProxyDelayedSyncQueued = false;
          }, delay);
        });
      }
      function getCanonicalAgedToneProxyHost() {
        const hosts = Array.from(document.querySelectorAll('#agedMidflowOption'));
        if (pricingConfig.singleVisualiserOnly) {
          const legacyHost = hosts.shift() || null;
          hosts.forEach(function(extraHost) {
            if (extraHost !== legacyHost) extraHost.innerHTML = '';
          });
          return legacyHost;
        }
        const finishWrapper = document.querySelector('.variant-wrapper[data-handle="finish"]');
        let host = finishWrapper ? hosts.find(function(candidate) {
          return candidate.parentNode === finishWrapper;
        }) : null;
        host = host || hosts.shift() || null;

        if (!host && finishWrapper) {
          host = document.createElement('div');
          host.id = 'agedMidflowOption';
        }

        if (host && finishWrapper && host.parentNode !== finishWrapper) {
          const finishDescription = finishWrapper.querySelector('.finish-description');
          if (finishDescription && finishDescription.parentNode === finishWrapper) {
            finishDescription.insertAdjacentElement('afterend', host);
          } else {
            finishWrapper.appendChild(host);
          }
        }

        hosts.forEach(function(extraHost) {
          if (extraHost !== host) extraHost.innerHTML = '';
        });
        return host;
      }
      function removeExtraAgedToneProxies(activeProxy) {
        document.querySelectorAll('[data-pdp-aged-tone-proxy]').forEach(function(proxy) {
          if (proxy !== activeProxy) proxy.remove();
        });
      }
      function createAgedToneAdjustTrigger(p) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'aged-proxy-adjust-link';
        button.setAttribute('data-pdp-aged-tone-adjust', '');
        button.setAttribute('aria-expanded', p && p.dataset.toneStrengthExpanded === 'true' ? 'true' : 'false');
        button.textContent = 'Adjust aged tone';
        button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          if (!p) return;
          p.dataset.toneStrengthExpanded = 'true';
          const toneStrength = p.querySelector('.tone-strength');
          if (toneStrength) {
            toneStrength.classList.add('is-visible');
            toneStrength.setAttribute('aria-hidden', 'false');
          }
          button.setAttribute('aria-expanded', 'true');
        });
        return button;
      }
      function createAgedToneActionsLine() {
        const line = document.createElement('span');
        line.className = 'aged-proxy-actions-line';
        return line;
      }
      function createAgedToneActionsSeparator() {
        const dot = document.createElement('span');
        dot.className = 'aged-proxy-actions-dot';
        dot.setAttribute('aria-hidden', 'true');
        return dot;
      }
      function syncAgedToneProxyState(p) {
        if (!p) return;
        removeExtraAgedToneProxies(p);
        const currentTone = getAgedToneValueFromRealControl();
        p.classList.toggle('is-aged-tone', currentTone === 'aged');
        const desc = p.querySelector('.aged-proxy-desc');
        p.querySelectorAll('a.aged-proxy-examples-link[data-pdp-aged-examples-trigger]').forEach(function(link) {
          link.remove();
        });

        p.querySelectorAll('[data-v]').forEach(function(button) {
          button.classList.toggle('is-active', button.getAttribute('data-v') === currentTone);
        });

        if (desc) {
          let descText = desc.querySelector('[data-pdp-aged-proxy-desc-text]');
          if (!descText) {
            descText = document.createElement('span');
            descText.setAttribute('data-pdp-aged-proxy-desc-text', '');
          }
          const examplesTrigger = getAgedToneExamplesTrigger();
          descText.textContent = getAgedToneProxyDescription();
          desc.replaceChildren(descText);
          const actionsLine = createAgedToneActionsLine();
          if (examplesTrigger) {
            actionsLine.appendChild(examplesTrigger);
          } else {
            actionsLine.textContent = 'See examples';
          }
          if (actionsLine.textContent.trim() || actionsLine.children.length) {
            actionsLine.appendChild(createAgedToneActionsSeparator());
            actionsLine.appendChild(createAgedToneAdjustTrigger(p));
            desc.appendChild(actionsLine);
          }
        }
      }
      function bindAgedToneProxyClick(p) {
        if (!p || p.dataset.agedToneProxyClickBound === '1') return;
        p.dataset.agedToneProxyClickBound = '1';
        p.addEventListener('click', function(e){
          const target = e.target && e.target.closest ? e.target : null;
          const b = target ? target.closest('[data-v]') : null;
          if (!b) return;
          const nextValue = String(b.getAttribute('data-v') || '').trim().toLowerCase() === 'aged' ? 'aged' : 'original';
          if (!setRealAgedToneValue(nextValue)) return;
          if (nextValue === 'aged') ra();
          syncAgedToneProxyState(p);
          document.dispatchEvent(new CustomEvent('pdp:aged-proxy-selected', { detail: { value: nextValue, proxy: p } }));
          queueRefresh();

          [0, 90].forEach(function(delay) {
            setTimeout(function() {
              if (getAgedToneValueFromRealControl() === nextValue) return;
              if (!setRealAgedToneValue(nextValue)) return;
              if (nextValue === 'aged') ra();
              syncAgedToneProxyState(p);
              queueRefresh();
            }, delay);
          });
        });
      }
      function hideRealAgedToneControls() {
        document.documentElement.classList.remove('pdp-aged-native-controls-enabled');
        document.documentElement.classList.add('pdp-aged-proxy-enabled');
        document.querySelectorAll('.option_colour_tone,.AgedLevelDropdown,#AgedHelperText').forEach(function(node){
          node.hidden = false;
          node.removeAttribute('aria-hidden');
          node.style.display = '';
          node.setAttribute('data-pdp-aged-proxy-real-control', 'true');
        });
      }
      function useRealAgedToneControls() {
        document.documentElement.classList.remove('pdp-aged-proxy-enabled');
        document.documentElement.classList.add('pdp-aged-native-controls-enabled');

        // Only undo state that the proxy path previously applied. Infinite
        // Options remains responsible for its own dependency visibility.
        document.querySelectorAll('[data-pdp-aged-proxy-real-control]').forEach(function(node) {
          node.hidden = false;
          node.removeAttribute('aria-hidden');
          node.style.display = '';
          node.removeAttribute('data-pdp-aged-proxy-real-control');
        });

        document.querySelectorAll('[data-pdp-aged-tone-proxy]').forEach(function(proxy) {
          proxy.remove();
        });
        document.querySelectorAll('#agedMidflowOption').forEach(function(host) {
          host.innerHTML = '';
        });
      }
      function ensureAgedToneProxy() {
        if (!pricingConfig.useAgedToneProxy) {
          if (!document.documentElement.classList.contains('pdp-aged-native-controls-enabled')) {
            useRealAgedToneControls();
          }
          return;
        }
        if (pricingConfig.agedUnavailable) {
          const h0 = getCanonicalAgedToneProxyHost();
          if (h0) h0.innerHTML = '';
          removeExtraAgedToneProxies(null);
          return;
        }
        hideRealAgedToneControls();
        ba();
        const h = getCanonicalAgedToneProxyHost();
        if (!h) return;
        h.hidden = false;
        const proxies = Array.from(h.querySelectorAll('[data-pdp-aged-tone-proxy]'));
        let p = proxies.shift() || null;
        proxies.forEach(function(extraProxy) {
          extraProxy.remove();
        });
        removeExtraAgedToneProxies(p);
        if (!p) {
          p = document.createElement('div'); p.setAttribute('data-pdp-aged-tone-proxy','');
          p.innerHTML = '<div class="aged-proxy-title">' + escapeHtml(localizedPdpLabels.colourToneTitle) + '</div><div class="aged-proxy-options"><button type="button" class="pdp-aged-proxy-option" data-v="original"><span class="aged-proxy-swatch is-original"><span class="aged-proxy-swatch-dot"></span></span>' + escapeHtml(localizedPdpLabels.colourToneOriginal) + '</button><button type="button" class="pdp-aged-proxy-option" data-v="aged"><span class="aged-proxy-swatch is-aged"><span class="aged-proxy-swatch-dot"></span></span>' + escapeHtml(localizedPdpLabels.colourToneAged) + '</button></div><p class="aged-proxy-desc"></p>';
        }
        bindAgedToneProxyClick(p);
        if (p.parentNode !== h) h.appendChild(p);
        syncAgedToneProxyState(p);
        document.dispatchEvent(new CustomEvent('pdp:aged-proxy-ready', { detail: { proxy: p } }));
        scheduleAgedToneProxySync(p);
      }

      function scheduleFrameColourSync() {
        const now = Date.now();
        if (frameColourSyncQueued || now < swatchSyncCooldownUntil) return;
        swatchSyncCooldownUntil = now + 120;
        frameColourSyncQueued = true;

        window.requestAnimationFrame(function() {
          frameColourSyncQueued = false;
          syncLegacyHiddenClassNames();
          const frameColourBlock = searchRoot.querySelector('[data-pdp-pricing-frame-colour], .option_frame_colour_new');
          const hangerColourBlock = searchRoot.querySelector('[data-pdp-pricing-hanger-colour], .option_hanger_colour');
          const frameColourVisible = isBridgeVisible(frameColourBlock);
          const hangerColourVisible = isBridgeVisible(hangerColourBlock) && hangerNeedsColourBlock();
          ensureDefaultFrameColour(frameColourBlock);
          if (frameColourVisible) {
            syncSwatchSelectedState(frameColourBlock);
          }
          if (hangerColourVisible) {
            syncSwatchSelectedState(hangerColourBlock);
          }
        });
      }

      function getSelectedFinishValue() {
        const selectedFinishInput = searchRoot.querySelector('[name="Finish"][type="radio"]:checked, fieldset[name="Finish"] input[type="radio"]:checked');
        return selectedFinishInput ? selectedFinishInput.value : '';
      }

      function hangerNeedsColourBlock() {
        const hangerCheckbox = searchRoot.querySelector('.hanger_checkbox input[type="checkbox"]');
        return !!(hangerCheckbox && hangerCheckbox.checked);
      }

      function finishNeedsFrameColourBlock() {
        const selectedFinish = (getSelectedFinishValue() || '').trim().toLowerCase();
        return selectedFinish.indexOf('fram') !== -1;
      }

      function queueRefresh() {
        if (refreshQueued) return;
        refreshQueued = true;

        window.requestAnimationFrame(function() {
          refreshQueued = false;
          localizeFrameColourControls();
          moveDifferentialPricingBlocks();
          bindInfiniteOptionsListeners();
          scheduleFrameColourSync();
        });
      }

      function isBridgeVisible(element) {
        if (!element) return false;
        if (element.hidden) return false;
        if (element.getAttribute('aria-hidden') === 'true') return false;
        if (element.style && element.style.display === 'none') return false;
        if (element.classList && (element.classList.contains('hide-oos-disable') || element.classList.contains('hide-oos-disabled'))) return false;
        if (element.hasAttribute('disabled') && element.classList.contains('io-dep-framing')) return false;

        const computed = window.getComputedStyle(element);
        return computed.display !== 'none' && computed.visibility !== 'hidden';
      }

      function moveDifferentialPricingBlocks() {
        if (isFinishFirstMode()) {
          ensureAgedToneProxy();
        } else {
          applyPricingSizeFirstLayout();
        }

        const finishCard = finishSection && (
          finishSection.querySelector('.variant-wrapper[data-handle="finish"]') ||
          finishSection.querySelector('.variant-wrapper.io-card')
        );
        const frameColourBlock =
          searchRoot.querySelector('[data-pdp-pricing-finish-first-finish-section] > .option_frame_colour_new') ||
          searchRoot.querySelector('#infiniteoptions-container .option_frame_colour_new') ||
          searchRoot.querySelector('.option_frame_colour_new');
        const customFrameBlock =
          searchRoot.querySelector('[data-pdp-pricing-finish-first-finish-section] > .option_custom_frame_colour_new') ||
          searchRoot.querySelector('#infiniteoptions-container .option_custom_frame_colour_new') ||
          searchRoot.querySelector('.option_custom_frame_colour_new');
        const hangerBlock =
          searchRoot.querySelector('[data-pdp-pricing-finish-first-finish-section] > .hanger_checkbox') ||
          searchRoot.querySelector('#infiniteoptions-container .hanger_checkbox') ||
          searchRoot.querySelector('.hanger_checkbox');
        const hangerColourBlock =
          searchRoot.querySelector('[data-pdp-pricing-finish-first-finish-section] > .option_hanger_colour') ||
          searchRoot.querySelector('#infiniteoptions-container .option_hanger_colour') ||
          searchRoot.querySelector('.option_hanger_colour');

        if (!finishSection || !finishCard) return false;

        // Position hidden dependants too: revealing them must not move the page
        // from the old Infinite Options location below sizing into the finish card.
        let optionAnchor = finishCard;
        [frameColourBlock, customFrameBlock, hangerBlock, hangerColourBlock].forEach(function(block) {
          if (!block) return;
          if (optionAnchor.nextElementSibling !== block) {
            optionAnchor.insertAdjacentElement('afterend', block);
          }
          optionAnchor = block;
        });

        syncLegacyHiddenClassNames();

        const hasFrameColourBlock = !!frameColourBlock;
        const hasVisibleFrameColourBlock = hasFrameColourBlock && isBridgeVisible(frameColourBlock);
        const hasVisibleHangerBlock = !!(hangerBlock && isBridgeVisible(hangerBlock));
        const hasVisibleCustomFrameBlock = !!(customFrameBlock && isBridgeVisible(customFrameBlock));
        const hasVisibleHangerColourBlock = !!(hangerColourBlock && isBridgeVisible(hangerColourBlock));
        const hangerColourEnabled = hangerNeedsColourBlock();
        const hasActiveHangerColourBlock = hasVisibleHangerColourBlock && hangerColourEnabled;
        const needsFrameColourBlock = finishNeedsFrameColourBlock();
        const isFinishToHangerAdjacent = !!(hangerBlock && finishCard.nextElementSibling === hangerBlock);
        const finishHasBridgeTop = finishCard.hasAttribute('data-pdp-pricing-bridge-top');
        const hangerHasBridgeFollow = !!(hangerBlock && hangerBlock.classList.contains('io-bridge-follow'));

        const layoutSignature = [
          (getSelectedFinishValue() || '').trim().toLowerCase(),
          hasVisibleFrameColourBlock ? 'f1' : 'f0',
          hasVisibleCustomFrameBlock ? 'c1' : 'c0',
          hasVisibleHangerBlock ? 'h1' : 'h0',
          hasActiveHangerColourBlock ? 'hc1' : 'hc0',
          needsFrameColourBlock ? 'nf1' : 'nf0',
          isFinishToHangerAdjacent ? 'fh1' : 'fh0',
          finishHasBridgeTop ? 'bt1' : 'bt0',
          hangerHasBridgeFollow ? 'bf1' : 'bf0'
        ].join('|');

        if (layoutSignature === lastLayoutSignature) {
          return true;
        }

        finishCard.classList.add('io-card');
        finishCard.classList.remove('io-bridge-follow');

        if (hasVisibleFrameColourBlock) {
          finishCard.classList.add('io-bridge-top');
          finishCard.setAttribute('data-pdp-pricing-bridge-top', 'true');

          frameColourBlock.classList.add('io-card', 'io-bridge-follow');
          frameColourBlock.classList.remove('io-bridge-top', 'io-group-mid', 'io-group-end');
          if (hasVisibleCustomFrameBlock || hasVisibleHangerBlock) {
            frameColourBlock.classList.add('io-group-section', 'io-group-start');
          } else {
            frameColourBlock.classList.remove('io-group-section', 'io-group-start');
          }
          frameColourBlock.setAttribute('data-pdp-pricing-frame-colour', 'true');
          ensureDefaultFrameColour(frameColourBlock);
          syncSwatchSelectedState(frameColourBlock);
        } else {
          finishCard.classList.remove('io-bridge-top');
          finishCard.removeAttribute('data-pdp-pricing-bridge-top');
        }

        if (customFrameBlock) {
          customFrameBlock.classList.add('io-card', 'io-group-section', 'io-group-end');
          customFrameBlock.classList.remove('io-bridge-top', 'io-bridge-follow', 'io-group-start');
          customFrameBlock.setAttribute('data-pdp-pricing-custom-frame', 'true');
        }

        const anchorBlock = customFrameBlock && hasVisibleCustomFrameBlock
          ? customFrameBlock
          : hasVisibleFrameColourBlock
            ? frameColourBlock
            : finishCard;

        if (hangerBlock && anchorBlock && hasVisibleHangerBlock) {
          hangerBlock.classList.add('io-card', 'io-group-section');
          hangerBlock.classList.remove('io-bridge-top');
          hangerBlock.setAttribute('data-pdp-pricing-hanger', 'true');

          if (anchorBlock === finishCard) {
            finishCard.classList.add('io-bridge-top');
            finishCard.setAttribute('data-pdp-pricing-bridge-top', 'true');
            hangerBlock.classList.add('io-bridge-follow');
          } else {
            hangerBlock.classList.remove('io-bridge-follow');
          }

          if (hasActiveHangerColourBlock) {
            hangerBlock.classList.add('io-group-start');
            hangerBlock.classList.remove('io-group-end');
          } else {
            hangerBlock.classList.add('io-group-end');
            hangerBlock.classList.remove('io-group-start');
          }


          if (hangerColourBlock) {
            hangerColourBlock.classList.add('io-card', 'io-group-section', 'io-group-end');
            hangerColourBlock.classList.remove('io-bridge-top', 'io-bridge-follow', 'io-group-start');
            hangerColourBlock.setAttribute('data-pdp-pricing-hanger-colour', 'true');


            if (isBridgeVisible(hangerColourBlock)) {
              syncSwatchSelectedState(hangerColourBlock);
            }
          }
        } else if (hangerBlock) {
          hangerBlock.classList.remove('io-bridge-follow', 'io-group-start', 'io-group-end');
        }

        if (!hasVisibleFrameColourBlock && !hasVisibleHangerBlock) {
          finishCard.classList.remove('io-bridge-top');
          finishCard.removeAttribute('data-pdp-pricing-bridge-top');
        }

        hostBlock.classList.add('pdp-pricing-experiment--finish-first-active');
        lastLayoutSignature = layoutSignature;

        if (!needsFrameColourBlock) return true;
        if (hasVisibleFrameColourBlock) {
          return finishCard.nextElementSibling === frameColourBlock;
        }
        if (hasVisibleHangerBlock) {
          return finishCard.nextElementSibling === hangerBlock;
        }
        return !hasFrameColourBlock;
      }

      function withSizeObserverPaused(work) {
        if (!sizeMutationObserver) {
          return work();
        }

        sizeMutationObserver.disconnect();
        isSyncingExpandedList = true;

        try {
          return work();
        } finally {
          isSyncingExpandedList = false;
          sizeMutationObserver.observe(sizeFieldset, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeOldValue: true,
            attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-hidden']
          });
        }
      }

      function formatMoney(cents) {
        const formatted = theme.Currency.formatMoney(cents, moneyFormat);
        if (!stripTrailingZeros) return formatted;
        return formatted
          // Remove only the decimal suffix. Do not capture/rewrite the final
          // integer digit: localized comma formats such as "841,00 kr" must
          // retain the complete amount.
          .replace(/[\.,]00(?=\D|$)/, '')
          .replace(/[\.,]?<sup>00<\/sup>(?=\D|$)/, '');
      }

      function formatSummarySavingsLabel(cents) {
        if (pseudoSalePercentageOnly) {
          const discountLabel = String(localizedPdpLabels.featuredSizesSaleDiscount || '[percent]% off')
            .replace('[percent]', pseudoSalePercent);
          if (pseudoSaleEndsDate) {
            const endsLabel = String(localizedPdpLabels.featuredSizesSaleEnds || 'Ends [date]')
              .replace('[date]', pseudoSaleEndsDate);
            return escapeHtml(discountLabel + ' \u00b7 ' + endsLabel);
          }
          return escapeHtml(discountLabel);
        }
        const marker = '[amount]';
        let template = pseudoSaleEndsDate
          ? String(localizedSummaryLabels.endsYouSave || ('Ends [date] - You save ' + marker))
          : String(localizedSummaryLabels.youSave || ('You save ' + marker));
        if (pseudoSaleEndsDate) {
          template = template.replace('[date]', pseudoSaleEndsDate);
        }
        const markerIndex = template.indexOf(marker);
        if (markerIndex === -1) return escapeHtml(template) + ' ' + formatMoney(cents);
        return escapeHtml(template.slice(0, markerIndex)) +
          formatMoney(cents) +
          escapeHtml(template.slice(markerIndex + marker.length));
      }

      function formatSavingsLabel(cents) {
        if (pseudoSalePercentageOnly) {
          return escapeHtml(String(localizedPdpLabels.featuredSizesSaleDiscount || '[percent]% off')
            .replace('[percent]', pseudoSalePercent));
        }
        const marker = '[amount]';
        const template = String(localizedSummaryLabels.youSave || ('You save ' + marker));
        const markerIndex = template.indexOf(marker);
        if (markerIndex === -1) return escapeHtml(template) + ' ' + formatMoney(cents);
        return escapeHtml(template.slice(0, markerIndex)) +
          formatMoney(cents) +
          escapeHtml(template.slice(markerIndex + marker.length));
      }

      function isFeaturedBandSalePriceEligible(variant) {
        if (!pseudoSaleFeaturedBandActive || !pseudoSalePercent || !variant) return false;
        const variantPrice = Number(variant.price || 0);
        return variantPrice >= pseudoSaleMinPrice && variantPrice <= pseudoSaleMaxPrice;
      }

      function isFeaturedBandSaleVariant(variant, featuredKey) {
        if (!isFeaturedBandSalePriceEligible(variant)) return false;
        // Only callers rendering the featured table supply a tier key. The
        // expanded All sizes renderer deliberately omits it.
        if (featuredKey !== 'small' && featuredKey !== 'medium') return false;
        return true;
      }

      function isSelectedFeaturedBandSaleVariant(variant) {
        if (!isFeaturedBandSalePriceEligible(variant)) return false;
        const variantSizeHandle = handleize(getVariantOptionValue(variant, sizePosition));
        return !!variantSizeHandle && featuredBandSaleSizeHandles.has(variantSizeHandle);
      }

      function formatFeaturedSizePrice(variant, includeFromPrefix, featuredKey, isSelectedSize) {
        if (!isVariantEligible(variant)) return '&mdash;';

        const prefixHtml = includeFromPrefix
          ? '<span class="pdp-featured-size__price-prefix">' + escapeHtml(localizedSummaryLabels.from) + '</span>'
          : '';
        const googleQuote = window.UMGoogleDiscount
          ? window.UMGoogleDiscount.resolveVariantPrice(variant)
          : null;
        if (googleQuote && googleQuote.googleDiscountActive) {
          return prefixHtml +
            '<s class="pdp-featured-size__compare">' + formatMoney(googleQuote.comparePrice) + '</s>' +
            '<span class="pdp-featured-size__sale">' + formatMoney(googleQuote.price) + '</span>';
        }
        if (isFeaturedBandSaleVariant(variant, featuredKey)) {
          return prefixHtml +
            '<s class="pdp-featured-size__compare">' + formatMoney(variant.price) + '</s>' +
            '<span class="pdp-featured-size__sale">' + formatMoney(calculatePseudoSalePrice(variant.price)) + '</span>';
        }
        const selectedPseudoSaleActive = isSelectedSize && (
          pseudoSaleActive || isSelectedFeaturedBandSaleVariant(variant)
        );
        if (selectedPseudoSaleActive) {
          return prefixHtml +
            '<s class="pdp-featured-size__compare pdp-featured-size__compare--selected-desktop">' + formatMoney(variant.price) + '</s>' +
            '<span class="pdp-featured-size__sale pdp-featured-size__sale--selected-desktop">' + formatMoney(calculatePseudoSalePrice(variant.price)) + '</span>';
        }

        if (!pseudoSaleActive) return prefixHtml + formatMoney(variant.price);

        return prefixHtml + formatMoney(applyPseudoSale(variant.price));
      }

      function formatFeaturedSizesSaleMessage(saleNameOverride) {
        if (!pseudoSaleActive) return '';

        const parts = [];
        const saleName = String(saleNameOverride || pricingConfig.pseudoSaleName || '').trim();
        const endsDate = String(pricingConfig.pseudoSaleEndsDate || '').trim();
        if (saleName) parts.push(saleName);
        if (pseudoSalePercent > 0) {
          parts.push(String(localizedPdpLabels.featuredSizesSaleDiscount || '[percent]% off applied')
            .replace('[percent]', pseudoSalePercent));
        }
        if (endsDate) {
          parts.push(String(localizedPdpLabels.featuredSizesSaleEnds || 'Ends [date]')
            .replace('[date]', endsDate));
        }
        return parts.join(' \u00b7 ');
      }

      function formatFeaturedBandSaleMessage(template) {
        return normalizeLocalizedText(String(
          template ||
          localizedPdpLabels.featuredSizesLimitedSale ||
          'Ends Tonight \u2014 [percent]% off [classic] & [statement] sizes'
        )
          .replace('[percent]', pseudoSalePercent)
          .replace('[classic]', localizedPdpLabels.featuredSizesClassic || 'Classic')
          .replace('[statement]', localizedPdpLabels.featuredSizesStatement || 'Statement'));
      }

      function setHtmlIfChanged(element, html) {
        if (!element || element.innerHTML === html) return;
        element.innerHTML = html;
      }

      function setTextIfChanged(element, text) {
        if (!element || element.textContent === text) return;
        if (finishFirstVariantDebugEnabled() && (
          element.matches('.variant__button-label-text, .pdp-featured-size__name, [data-featured-sizes-toggle]')
        )) {
          finishFirstVariantDebug('label-write', {
            target: element.matches('[data-featured-sizes-toggle]') ? 'all-sizes-toggle' :
              element.matches('.pdp-featured-size__name') ? 'featured-size-' + (element.closest('[data-featured-size-key]')?.dataset.featuredSizeKey || '') :
              'finish-' + (element.closest('.variant-input')?.dataset.value || ''),
            before: element.textContent,
            after: text
          });
        }
        element.textContent = text;
      }

      function setFeaturedSaleMessage(element, next) {
        if (!element) return;
        const previous = element.__pdpSaleMessage;
        if (previous && previous.html === next.html && previous.exclusive === next.exclusive &&
            previous.hidden === next.hidden && previous.ineligible === next.ineligible) return;
        if (element.__pdpSaleMessageTimer) window.clearTimeout(element.__pdpSaleMessageTimer);
        element.__pdpSaleMessage = next;
        const apply = function() {
          element.__pdpSaleMessageTimer = null;
          setHtmlIfChanged(element, next.html);
          setBooleanPropertyIfChanged(element, 'hidden', next.hidden);
          element.classList.toggle('is-exclusive-offer', next.exclusive);
          element.classList.toggle('is-finish-ineligible', next.ineligible);
          setAttributeIfChanged(element, 'aria-hidden', next.hidden || next.ineligible ? 'true' : 'false');
          element.classList.remove('is-message-changing');
        };
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (previous && previous.exclusive !== next.exclusive && !element.hidden && !reducedMotion) {
          element.classList.add('is-message-changing');
          element.__pdpSaleMessageTimer = window.setTimeout(apply, 180);
        } else {
          apply();
        }
      }

      function setDataIfChanged(element, key, value) {
        if (!element || element.dataset[key] === value) return;
        element.dataset[key] = value;
      }

      function setBooleanPropertyIfChanged(element, key, value) {
        if (!element || element[key] === value) return;
        element[key] = value;
      }

      function setAttributeIfChanged(element, key, value) {
        if (!element || element.getAttribute(key) === value) return;
        element.setAttribute(key, value);
      }

      function setStylePropertyIfChanged(element, key, value) {
        if (!element || element.style[key] === value) return;
        element.style[key] = value;
      }

      function normalizeLocalizedText(value) {
        return String(value == null ? '' : value)
          .replace(/&amp;/g, '&')
          .replace(/&quot;/g, '"')
          .replace(/&#0*39;|&#x0*27;/gi, "'");
      }

      function escapeHtml(value) {
        value = normalizeLocalizedText(value);
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      function getFeaturedTierLabelForSize(sizeValue) {
        if (!sizeValue) return '';
        const normalizedTarget = normalizeCamouflageSizeValue(sizeValue);
        if (!normalizedTarget) return '';

        const buttons = Array.from(document.querySelectorAll('[data-featured-size-key][data-size-value]'));
        for (let i = 0; i < buttons.length; i += 1) {
          const btn = buttons[i];
          const key = btn.getAttribute('data-featured-size-key');
          if (!key || key === 'selected') continue;
          const buttonSizeValue = normalizeCamouflageSizeValue(btn.dataset.sizeValue || '');
          if (!buttonSizeValue || buttonSizeValue !== normalizedTarget) continue;
          const nameEl = btn.querySelector('.pdp-featured-size__name');
          const tierLabel = nameEl ? String(nameEl.textContent || '').trim() : '';
          if (tierLabel) return tierLabel;
        }
        return '';
      }

      function formatSummaryBaseLabel(baseNoun, sizeLabel, selectedSizeValue, rawFinishValue, rawFinishLabel) {
        const noun = String(baseNoun || localizedMapPrintLabel).trim() || localizedMapPrintLabel;
        const rawSizeText = String(sizeLabel || selectedSizeValue || '').trim();
        const sizeText = window.UMSizeDisplay && typeof window.UMSizeDisplay.format === 'function'
          ? window.UMSizeDisplay.format(rawSizeText)
          : rawSizeText;
        const finishValue = String(rawFinishValue || '').trim().toLowerCase();
        const finishLabel = String(rawFinishLabel || '').trim().toLowerCase();
        const finishText = (finishValue + ' ' + finishLabel).trim();
        const piecesMatch = finishText.match(/(?:^|[^0-9])(\d{1,3})\s*pieces?\b/);
        const piecesCount = piecesMatch ? parseInt(piecesMatch[1], 10) : NaN;
        const tierLabel = getFeaturedTierLabelForSize(selectedSizeValue);
        const safeNoun = escapeHtml(noun);
        const safeTier = escapeHtml(tierLabel);
        const safeSize = escapeHtml(sizeText);

        if (Number.isFinite(piecesCount) && piecesCount > 1) {
          const printsLabel = escapeHtml(piecesCount + ' ' + localizedMapPrintsLabel);
          if (safeSize) {
            return '<span class="pdp-pricing-summary__base-noun">' + printsLabel + '</span> ' +
              '<span class="pdp-pricing-summary__sep" aria-hidden="true">&middot;</span> ' +
              '<span class="pdp-pricing-summary__label-tail">' + escapeHtml(localizedSummaryLabels.totalSize) + ' ' + safeSize + '</span>';
          }
          return '<span class="pdp-pricing-summary__base-noun">' + printsLabel + '</span>';
        }

        if (safeTier && safeSize) {
          return '<span class="pdp-pricing-summary__base-noun">' + safeNoun + '</span> ' +
            '<span class="pdp-pricing-summary__sep" aria-hidden="true">&middot;</span> ' +
            '<span class="pdp-pricing-summary__label-tail">' + safeTier + ' ' + safeSize + '</span>';
        }

        if (safeSize) {
          return '<span class="pdp-pricing-summary__base-noun">' + safeNoun + '</span> ' +
            '<span class="pdp-pricing-summary__sep" aria-hidden="true">&middot;</span> ' +
            '<span class="pdp-pricing-summary__label-tail">' + safeSize + '</span>';
        }

        return '<span class="pdp-pricing-summary__base-noun">' + safeNoun + '</span>';
      }

      function formatOverallFramedSize(rawSize, preferredUnit) {
        const raw = String(rawSize || '').trim();
        if (!raw) return '';

        const aSeriesMm = {
          a0: [841, 1189],
          a1: [594, 841],
          a2: [420, 594],
          a3: [297, 420],
          a4: [210, 297],
          a5: [148, 210],
          a6: [105, 148]
        };
        const aSeriesMatch = raw.toLowerCase().replace(/\s+/g, '').match(/\ba([0-6])\b/);
        if (aSeriesMatch && aSeriesMm['a' + aSeriesMatch[1]]) {
          const dimensions = aSeriesMm['a' + aSeriesMatch[1]];
          return (dimensions[0] + 40) + ' \u00d7 ' + (dimensions[1] + 40) + ' mm';
        }

        const matches = [];
        const sizePattern = /(\d+(?:\.\d+)?)\s*[x\u00d7]\s*(\d+(?:\.\d+)?)\s*(mm|cm|in)?/ig;
        let match;
        while ((match = sizePattern.exec(raw)) !== null) {
          matches.push({
            width: Number(match[1]),
            height: Number(match[2]),
            unit: String(match[3] || '').toLowerCase()
          });
        }
        if (!matches.length) return '';

        const normalizedPreferredUnit = String(preferredUnit || '').toLowerCase();
        const dimensions =
          matches.find(function(item) { return item.unit === normalizedPreferredUnit; }) ||
          matches.find(function(item) { return item.unit === 'cm'; }) ||
          matches.find(function(item) { return item.unit === 'mm'; }) ||
          matches.find(function(item) { return item.unit === 'in'; }) ||
          matches[0];
        const unit = dimensions.unit || 'cm';
        const totalFrameAllowance = unit === 'mm' ? 40 : (unit === 'in' ? 1.5 : 4);

        function formatDimension(value) {
          const rounded = Math.round(value * 10) / 10;
          return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
        }

        return formatDimension(dimensions.width + totalFrameAllowance) +
          ' \u00d7 ' +
          formatDimension(dimensions.height + totalFrameAllowance) +
          ' ' + unit;
      }

      function resolvePromotedBaseNoun(defaultBaseNoun, rawFinishValue, rawFinishLabel) {
        const finishValue = String(rawFinishValue || '').trim().toLowerCase();
        const finishLabel = String(rawFinishLabel || '').trim().toLowerCase();
        const finishText = (finishValue + ' ' + finishLabel).trim();
        if (/\bpush pin map\b/.test(finishText)) return 'Push pin map';
        if (/\bcanvas\b/.test(finishText)) return 'Canvas print';
        return String(defaultBaseNoun || localizedMapPrintLabel).trim() || localizedMapPrintLabel;
      }

      function resolveCombinedMainProductNoun(defaultBaseNoun, rawFinishValue, rawFinishLabel) {
        const finishValue = String(rawFinishValue || '').trim().toLowerCase();
        const finishLabel = String(rawFinishLabel || '').trim().toLowerCase();
        const finishText = (finishValue + ' ' + finishLabel).trim();
        if (/\bpush pin map\b/.test(finishText)) return 'Push pin map';
        if (/\bcanvas\b/.test(finishText)) return localizedFramedCanvasLabel || 'Framed canvas';
        if (/\bfram/.test(finishText)) {
          return pricingConfig.productType === 'Fine art'
            ? (localizedFramedArtPrintLabel || localizedArtPrintLabel)
            : (localizedFramedMapLabel || localizedMapPrintLabel);
        }
        return String(defaultBaseNoun || localizedMapPrintLabel).trim() || localizedMapPrintLabel;
      }

      function getVariantOptionValue(variant, position) {
        return variant ? variant['option' + position] || '' : '';
      }

      function getCheckedVariantInput(position) {
        return document.querySelector('.variant-input[data-index="option' + position + '"] input:checked');
      }

      function getOptionFieldset(position) {
        return document.querySelector('.variant-input-wrap[data-index="option' + position + '"], fieldset.variant-input-wrap[data-index="option' + position + '"]');
      }

      function getCurrentNodeLabel(node) {
        if (!node) return '';
        const textNode = node.querySelector('.variant__button-label-text');
        if (textNode && textNode.textContent) {
          return textNode.textContent.trim();
        }

        const label = node.querySelector('label');
        if (label && label.textContent) {
          const priceNode = label.querySelector('[data-pdp-size-price], [data-pdp-finish-delta], .variant__button-price');
          const priceText = priceNode && priceNode.textContent ? priceNode.textContent.trim() : '';
          const fullText = label.textContent.trim();
          return priceText ? fullText.replace(priceText, '').trim() : fullText;
        }

        return node.dataset.displayLabel || node.dataset.value || '';
      }

      function normalizeCamouflageSizeValue(value) {
        return String(value || '')
          .replace(/\u00a0/g, ' ')
          .replace(/[\u00d7]/g, 'x')
          .replace(/[\u2013\u2014]/g, '-')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
      }

      function getCamouflageHiddenSizeSet() {
        const hiddenValues = new Set();
        const tagGroupHiddenSizesRaw = pricingConfig.tagGroupHiddenSizesRaw || '';
        const sources = [
          window.variant_sizes_to_hide,
          tagGroupHiddenSizesRaw,
          pricingConfig.sizeVariantsToHide || ''
        ];

        sources.forEach(function(rawSource) {
          const raw = String(rawSource || '').trim();
          if (!raw) return;

          const addValue = function(value) {
            const normalized = normalizeCamouflageSizeValue(value);
            if (normalized) hiddenValues.add(normalized);
          };

          if (raw.charAt(0) === '[' && raw.charAt(raw.length - 1) === ']') {
            try {
              const parsed = JSON.parse(raw);
              if (Array.isArray(parsed)) {
                parsed.forEach(addValue);
                return;
              }
            } catch (error) {}
          }

          raw.split('|').forEach(addValue);
        });

        return hiddenValues;
      }

      function isCamouflageHiddenSizeValue(value) {
        return getCamouflageHiddenSizeSet().has(normalizeCamouflageSizeValue(value));
      }

      function getSelectedOptionValue(position) {
        if (!hasVariantOptionInteraction && initialUrlVariant) {
          const initialValue = getVariantOptionValue(initialUrlVariant, position);
          if (initialValue) return initialValue;
        }

        const input = getCheckedVariantInput(position);
        if (input) return input.value;

        const select = document.querySelector('select[data-index="option' + position + '"]');
        return select ? select.value : '';
      }

      function getSelectedOptionLabel(position) {
        const input = getCheckedVariantInput(position);
        if (input) {
          if (position === sizePosition) {
            const selectedNode = input.closest('.variant-input');
            const liveLabel = getCurrentNodeLabel(selectedNode);
            if (liveLabel) {
              const liveLabelText = liveLabel.trim();
              if (isCompoundSizeLabel(liveLabelText)) {
                const converted = getPreferredConvertedSizeLabel(input.value || '');
                if (converted) return converted;
              }
              return liveLabelText;
            }
          }
          return (
            input.dataset.displayLabel ||
            input.closest('.variant-input')?.dataset.displayLabel ||
            input.value ||
            ''
          ).trim();
        }

        const fieldset = getOptionFieldset(position);
        const selectedNode = fieldset?.querySelector('.variant-input input:checked')?.closest('.variant-input');
        const selectedNodeLabel = getCurrentNodeLabel(selectedNode);
        if (selectedNodeLabel) {
          const selectedNodeText = selectedNodeLabel.trim();
          if (position === sizePosition && isCompoundSizeLabel(selectedNodeText)) {
            const selectedValueForNode = getSelectedOptionValue(position);
            const converted = getPreferredConvertedSizeLabel(selectedValueForNode);
            if (converted) return converted;
          }
          return selectedNodeText;
        }

        const selectedValue = getSelectedOptionValue(position);
        if (fieldset && selectedValue) {
          const matchedNode = Array.from(fieldset.querySelectorAll('.variant-input[data-value]')).find(function(node) {
            return String(node.dataset.value || '') === String(selectedValue);
          }) || null;
          const matchedNodeLabel = getCurrentNodeLabel(matchedNode);
          if (matchedNodeLabel) {
            const matchedNodeText = matchedNodeLabel.trim();
            if (position === sizePosition && isCompoundSizeLabel(matchedNodeText)) {
              const converted = getPreferredConvertedSizeLabel(selectedValue);
              if (converted) return converted;
            }
            return matchedNodeText;
          }
        }

        return selectedValue || '';
      }

      function rememberCurrentSizeSelection(reason, target) {
        const selectedSizeValue = getSelectedOptionValue(sizePosition) ||
          lastKnownSizeValue ||
          (currentVariant ? getVariantOptionValue(currentVariant, sizePosition) : '');
        if (!selectedSizeValue) return;

        lastKnownSizeValue = selectedSizeValue;
        intendedSizeValue = selectedSizeValue;
        finishFirstVariantDebug('remember-size', function() { return {
          reason: reason,
          selectedSizeValue: selectedSizeValue,
          target: target ? {
            index: target.dataset.index || '',
            value: target.value || '',
            name: target.name || ''
          } : null
        }; });
      }

      function getCurrentSelections() {
        const selections = {};
        optionPositions.forEach(function(position) {
          const value = getSelectedOptionValue(position);
          if (value) {
            selections[position] = value;
            return;
          }

          if (currentVariant) {
            const fallback = getVariantOptionValue(currentVariant, position);
            if (fallback) {
              selections[position] = fallback;
            }
          }
        });
        return selections;
      }

      function isBaseFinish(finishValue) {
        const finishHandle = handleize(finishValue);
        if (baseFinishHandles.has(finishHandle)) return true;
        if (finishHandle === 'push-pin-map') return true;
        if (/^map-\d+-pieces?$/.test(finishHandle)) return true;
        if (/^art-print-\d+-pieces?$/.test(finishHandle)) return true;
        return false;
      }

      function variantMatchesSelections(variant, selections, excludedPositions) {
        const excluded = excludedPositions || new Set();
        return optionPositions.every(function(position) {
          if (excluded.has(position)) return true;
          const expected = selections[position];
          if (!expected) return true;
          return handleize(getVariantOptionValue(variant, position)) === handleize(expected);
        });
      }

      function findVariantFor(sizeValue, finishValue, selections) {
        const matchSelections = Object.assign({}, selections || getCurrentSelections(), {
          [sizePosition]: sizeValue,
          [finishPosition]: finishValue
        });

        return variants.find(function(variant) {
          return variantMatchesSelections(variant, matchSelections);
        }) || null;
      }

      function findLowestVariantForFinish(finishValue, selections) {
        const matchSelections = Object.assign({}, selections || getCurrentSelections(), {
          [finishPosition]: finishValue
        });
        const excludedPositions = new Set([sizePosition]);

        return variants.reduce(function(lowestVariant, variant) {
          if (!isVariantEligible(variant)) return lowestVariant;
          if (!variantMatchesSelections(variant, matchSelections, excludedPositions)) return lowestVariant;
          if (!lowestVariant || variant.price < lowestVariant.price) return variant;
          return lowestVariant;
        }, null);
      }

      function findBaseVariant(sizeValue, selections) {
        const matchSelections = Object.assign({}, selections || getCurrentSelections(), {
          [sizePosition]: sizeValue
        });

        return variants.find(function(variant) {
          return variantMatchesSelections(variant, matchSelections, new Set([finishPosition])) &&
            isBaseFinish(getVariantOptionValue(variant, finishPosition));
        }) || null;
      }

      function getCurrentVariantFromDom() {
        const urlVariant = initialVariantUrlState.variant;
        if (urlVariant && !hasVariantOptionInteraction) return urlVariant;

        // The hidden master select can briefly revert while option controllers
        // reconcile. A complete visible selection is the stronger source.
        const selectedOptions = optionPositions.map(function(position) {
          return { position: position, value: getSelectedOptionValue(position) };
        });
        if (selectedOptions.length && selectedOptions.every(function(option) { return !!option.value; })) {
          const selectedVariant = variants.find(function(variant) {
            return selectedOptions.every(function(option) {
              return getVariantOptionValue(variant, option.position) === option.value;
            });
          });
          if (selectedVariant) return selectedVariant;
        }

        const variantSelect = document.querySelector('select[name="id"]');
        const variantId = variantSelect?.value || document.querySelector('input[name="id"]')?.value;
        if (!variantId) return variants[0] || null;
        return variants.find(function(variant) {
          return String(variant.id) === String(variantId);
        }) || variants[0] || null;
      }

      function isElementHidden(element) {
        if (!element) return false;
        if (element.hidden) return true;
        if (element.getAttribute('aria-hidden') === 'true') return true;
        if (element.classList.contains('hide')) return true;
        if (element.classList.contains('pdp-size-option-hidden')) return false;

        if (visibilityCache.has(element)) {
          return visibilityCache.get(element);
        }

        // Size-option visibility is controlled by this controller's own
        // classes/attributes. Avoid forcing style calculation for every size
        // and label during each pricing render.
        if (sizeFieldset.contains(element)) {
          const inlineHidden =
            element.style.display === 'none' ||
            element.style.visibility === 'hidden';
          visibilityCache.set(element, inlineHidden);
          return inlineHidden;
        }

        const style = window.getComputedStyle(element);
        const hidden = style.display === 'none' || style.visibility === 'hidden';
        visibilityCache.set(element, hidden);
        return hidden;
      }

      function isNodeSuppressed(node) {
        if (!node) return true;

        const input = node.querySelector('input, select');
        const label = node.querySelector('label');
        const isSizeOptionNode = String(node.dataset.index || '') === ('option' + sizePosition);
        const hasSuppressedClass = function(element) {
          return !!element && (
            element.classList.contains('disabled') ||
            element.classList.contains('hide-oos-disable') ||
            element.classList.contains('camouflage-marked-unavailable')
          );
        };

        if (hasSuppressedClass(node) || hasSuppressedClass(input)) return true;
        if (!isSizeOptionNode && hasSuppressedClass(label)) return true;
        if (isSizeOptionNode && hasSuppressedClass(label) && input?.disabled) return true;
        if (input?.disabled) return true;
        if (isElementHidden(node) || isElementHidden(label)) return true;

        return false;
      }

      function isVariantEligible(variant) {
        return !!(
          variant &&
          variant.available &&
          typeof variant.price === 'number' &&
          variant.price > 0
        );
      }

      function getPropertyHandle(control) {
        const rawName =
          String(control?.name || '') ||
          String(control?.getAttribute?.('name-disabled') || '');
        const match = rawName.match(/^properties\[(.+)\]$/);
        if (match && match[1]) return handleize(match[1]);

        const optionClassHost = control?.closest('[class*="option_"], [class*="_checkbox"], [class*="_toggle"]');
        if (!optionClassHost) return '';
        const optionClass = Array.from(optionClassHost.classList).find(function(className) {
          return className.indexOf('option_') === 0 ||
            className.endsWith('_checkbox') ||
            className.endsWith('_toggle');
        });
        if (!optionClass) return '';

        return handleize(
          optionClass
            .replace(/^option_/, '')
            .replace(/_checkbox$/, '')
            .replace(/_toggle$/, '')
        );
      }

      function getReadableSelectionLabel(control) {
        if (!control) return '';
        const explicitLabel = control.getAttribute('data-price-label');
        if (explicitLabel) return explicitLabel.trim();

        const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : null;
        if (option?.textContent) return option.textContent.trim();

        const wrapperLabel = control.closest('label');
        if (wrapperLabel?.textContent) return wrapperLabel.textContent.trim();

        return String(control.value || '').trim();
      }

      function normalizeSelectionLabel(value) {
        const label = String(value || '').trim();
        if (!label) return '';
        const lowered = label.toLowerCase();
        if (lowered === 'yes' || lowered === 'no' || lowered === 'on' || lowered === 'off' || lowered === 'true' || lowered === 'false') {
          return '';
        }
        return label;
      }

      function buildAddonDisplayLabel(entry, propertyHandle, control) {
        const baseLabel = String(entry?.label || propertyHandle || '').trim() || 'Option';
        const selectedLabel = normalizeSelectionLabel(getReadableSelectionLabel(control));

        if (!selectedLabel) return baseLabel;

        if (
          propertyHandle === 'frame-colour' ||
          propertyHandle === 'frame-color' ||
          propertyHandle === 'custom-frame-colour' ||
          propertyHandle === 'custom-frame-color'
        ) {
          return baseLabel + ' - ' + selectedLabel;
        }

        return baseLabel;
      }

      function resolveAddonEntryPrice(entry) {
        if (!entry) return Promise.resolve(null);
        if (typeof entry.price === 'number' && !Number.isNaN(entry.price)) {
          return Promise.resolve({
            price: entry.price,
            compareAtPrice: typeof entry.compareAtPrice === 'number' ? entry.compareAtPrice : null
          });
        }

        const handle = String(entry.productHandle || '').trim();
        if (!handle) return Promise.resolve(null);

        if (addonProductCache.has(handle)) {
          return addonProductCache.get(handle);
        }

        const request = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function(response) {
            if (!response.ok) throw new Error('Failed to load add-on product ' + handle);
            return response.json();
          })
          .then(function(productJson) {
            if (entry.productId && String(productJson.id) !== String(entry.productId)) {
              console.warn('PDP pricing experiment: add-on product ID mismatch for', handle, entry.productId, productJson.id);
            }

            const variant = Array.isArray(productJson.variants) ? productJson.variants[0] : null;
            if (typeof variant?.price !== 'number') return null;

            return {
              price: variant.price,
              compareAtPrice: typeof variant.compare_at_price === 'number' ? variant.compare_at_price : null
            };
          })
          .catch(function(error) {
            console.error('PDP pricing experiment: could not resolve add-on product price', error);
            return null;
          });

        addonProductCache.set(handle, request);
        return request;
      }

      function controlIsSelected(control) {
        if (!control) return false;
        if (control.checked) return true;

        const wrapperLabel = control.closest('label');
        if (wrapperLabel?.classList.contains('selected')) return true;
        if (wrapperLabel?.getAttribute('aria-pressed') === 'true') return true;

        const watchWrapper = control.closest('.spb-productoptionswatchwrapper');
        if (watchWrapper?.classList.contains('selected')) return true;

        const toggleCard = control.closest('[role="switch"]');
        if (toggleCard?.getAttribute('aria-checked') === 'true') return true;

        return false;
      }

      function getRelatedToggleControl(control) {
        const container = control?.closest('fieldset, .checkbox_same_line, [role="switch"]');
        if (!container) return null;
        return container.querySelector('input[type="checkbox"], input[type="radio"]');
      }

      function hiddenProxyIsSelected(control) {
        const toggleCard = control?.closest('[role="switch"]');
        if (toggleCard?.getAttribute('aria-checked') === 'true') return true;
        if (toggleCard?.getAttribute('aria-checked') === 'false') return false;

        const relatedToggle = getRelatedToggleControl(control);
        return relatedToggle ? controlIsSelected(relatedToggle) : false;
      }
      function ih(h){return h==='aged'||h==='aged-level'||h==='colour-tone'||h==='color-tone';}

      function isHangerPropertyHandle(propertyHandle) {
        return propertyHandle === 'add-a-map-hanger' ||
          propertyHandle === 'add-a-hanger' ||
          propertyHandle === 'hanger';
      }

      function getAddonCategory(propertyHandle) {
        const finishHandles = new Set([
          'frame-colour',
          'frame-color',
          'frame-colour-new',
          'frame-color-new',
          'custom-frame-colour',
          'custom-frame-color',
          'custom-frame-colour-new',
          'custom-frame-color-new',
          'add-a-map-hanger',
          'add-a-hanger',
          'hanger',
          'colour-tone',
          'color-tone',
          'aged',
          'unique-3d',
          'unique-3d-pm',
          'unique3dpm'
        ]);
        const personalisationHandles = new Set([
          'artist-border',
          'artist-name',
          'add-artist-border',
          'personalisation',
          'pop-art-text'
        ]);

        if (finishHandles.has(propertyHandle)) return 'finish';
        if (personalisationHandles.has(propertyHandle)) return 'personalisation';
        return null;
      }

      function isFrameColourHandle(propertyHandle) {
        return propertyHandle === 'frame-colour' ||
          propertyHandle === 'frame-color' ||
          propertyHandle === 'frame-colour-new' ||
          propertyHandle === 'frame-color-new' ||
          propertyHandle === 'custom-frame-colour' ||
          propertyHandle === 'custom-frame-color' ||
          propertyHandle === 'custom-frame-colour-new' ||
          propertyHandle === 'custom-frame-color-new';
      }

      function hasRenderableLineItem(item) {
        if (!item) return false;
        const price = typeof item.price === 'number' ? item.price : 0;
        const compareAt = typeof item.compareAtPrice === 'number' ? item.compareAtPrice : 0;
        const selectedValue = String(item.selectedValueLabel || '').trim();
        const label = String(item.label || '').trim();
        return !!label && (price !== 0 || compareAt > price || selectedValue !== '');
      }

      function getSelectedFrameColourLabelFromDom() {
        const checked =
          document.querySelector('.option_frame_colour_new input[type="radio"]:checked') ||
          document.querySelector('.option_custom_frame_colour_new input[type="radio"]:checked');
        if (checked) {
          const fromData = checked.getAttribute('data-price-label') || checked.getAttribute('data-label');
          if (fromData && String(fromData).trim()) return String(fromData).trim();
          if (checked.value && String(checked.value).trim()) return String(checked.value).trim();
        }

        const selectedWrap =
          document.querySelector('.option_frame_colour_new .spb-productoptionswatchwrapper.selected') ||
          document.querySelector('.option_custom_frame_colour_new .spb-productoptionswatchwrapper.selected');
        if (selectedWrap) {
          const txt = selectedWrap.textContent || '';
          const clean = txt.replace(/\s+/g, ' ').trim();
          if (clean) return clean;
        }

        return '';
      }

      function getSelectedHangerColourLabelFromDom() {
        const checked =
          document.querySelector('.option_hanger_colour input[type="radio"]:checked') ||
          document.querySelector('.option_hanger_colour_new input[type="radio"]:checked');
        if (checked) {
          const fromData = checked.getAttribute('data-price-label') || checked.getAttribute('data-label');
          if (fromData && String(fromData).trim()) return String(fromData).trim();
          if (checked.value && String(checked.value).trim()) return String(checked.value).trim();
        }

        const selectedWrap =
          document.querySelector('.option_hanger_colour .spb-productoptionswatchwrapper.selected') ||
          document.querySelector('.option_hanger_colour_new .spb-productoptionswatchwrapper.selected');
        if (selectedWrap) {
          const txt = selectedWrap.textContent || '';
          const clean = txt.replace(/\s+/g, ' ').trim();
          if (clean) return clean;
        }

        return '';
      }

      function getSelectedAgedLevelLabelFromDom() {
        const select = gs();
        if (select) { const raw = String(select.value || '').trim(); if (raw) return raw; }
        if (window._u) { const cached = String(window._u || '').trim(); if (cached) return cached; }

        const slider = document.querySelector('.io-aged-level-slider__range');
        if (slider) {
          const ariaText = String(slider.getAttribute('aria-valuetext') || '').trim();
          if (ariaText) return ariaText;
          const raw = String(slider.value || '').trim();
          if (raw && /^\d+(\.\d+)?$/.test(raw)) return raw + '%';
        }

        return '';
      }

      function getInputValueByName(name) {
        if (!name) return '';
        const checked = document.querySelector('input[name="' + name + '"]:checked');
        if (checked) {
          const fromData = checked.getAttribute('data-price-label') || checked.getAttribute('data-label');
          if (fromData && String(fromData).trim()) return String(fromData).trim();
          if (checked.value && String(checked.value).trim()) return String(checked.value).trim();
        }

        const select = document.querySelector('select[name="' + name + '"]');
        if (select) {
          const v = String(select.value || '').trim();
          if (v) return v;
        }

        const textarea = document.querySelector('textarea[name="' + name + '"]');
        if (textarea) {
          const v = String(textarea.value || '').trim();
          if (v) return v;
        }

        const textInput = document.querySelector('input[name="' + name + '"]:not([type="radio"]):not([type="checkbox"])');
        if (textInput) {
          const v = String(textInput.value || '').trim();
          if (v) return v;
        }

        return '';
      }

      function getHiddenInputValueByName(name) {
        if (!name) return '';
        const hiddenInput = document.querySelector('input[type="hidden"][name="' + name + '"]');
        if (!hiddenInput) return '';
        return String(hiddenInput.value || '').trim();
      }

      function getSafeHttpUrl(rawValue) {
        const value = String(rawValue || '').trim();
        if (!value) return '';
        try {
          const parsed = new URL(value, window.location.origin);
          if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
          return parsed.href;
        } catch (error) {
          return '';
        }
      }

      function getSavedMapEditLink() {
        const fromProperty = getHiddenInputValueByName('properties[_Edit Link]');
        if (fromProperty) return getSafeHttpUrl(fromProperty);

        const byId = document.getElementById('map-edit-url');
        if (byId && byId.value) return getSafeHttpUrl(byId.value);

        return '';
      }

      function capitalizeFirstLetter(value) {
        const text = String(value || '');
        if (!text) return '';
        const firstAlphaIndex = text.search(/[a-zA-Z]/);
        if (firstAlphaIndex === -1) return text;
        const firstChar = text.charAt(firstAlphaIndex);
        const upper = firstChar.toUpperCase();
        if (firstChar === upper) return text;
        return text.slice(0, firstAlphaIndex) + upper + text.slice(firstAlphaIndex + 1);
      }

      function getPopArtDetailRows() {
        const textValue = getInputValueByName('properties[Pop Art Words]');
        const colourValue = getInputValueByName('properties[Pop Art Colour]');
        const styleValue =
          getInputValueByName('properties[Pop art text style]') ||
          getInputValueByName('properties[Pop Art Text Style]');
        const fontValue = getInputValueByName('properties[Pop Art Font]');
        const rows = [];
        const popChoiceLabels = {
          'hot pink': localizedSummaryLabels.popHotPink,
          'bright blue': localizedSummaryLabels.popBrightBlue,
          'vibrant orange': localizedSummaryLabels.popVibrantOrange,
          'vivid green': localizedSummaryLabels.popVividGreen,
          black: localizedSummaryLabels.popBlack,
          white: localizedSummaryLabels.popWhite,
          custom: localizedSummaryLabels.popCustom,
          flat: localizedSummaryLabels.popFlat,
          '3d': localizedSummaryLabels.popThreeD,
          '3d shadow': localizedSummaryLabels.popThreeDShadow
        };
        const localizedChoice = function(value) {
          return popChoiceLabels[String(value).trim().toLowerCase()] || value;
        };

        if (textValue) rows.push({ label: localizedSummaryLabels.details, value: textValue.toUpperCase() });
        if (colourValue) rows.push({ label: localizedSummaryLabels.colour, value: localizedChoice(colourValue), rawValue: colourValue, isColour: true });
        if (styleValue) rows.push({ label: localizedSummaryLabels.style || 'Style', value: localizedChoice(styleValue) });
        if (fontValue) rows.push({ label: localizedSummaryLabels.font, value: fontValue });

        return rows;
      }

      function getPersonalisationDetailRows() {
        const inactiveDirectField = document.querySelector(
          'textarea[name-disabled="properties[Personalisation]"]'
        );
        const directValue =
          getInputValueByName('properties[Personalisation]') ||
          String(inactiveDirectField?.value || '').trim();
        const toggleValue = getInputValueByName('properties[Personalisation?]');
        const rows = [];

        if (directValue) {
          const structuredLabels = {
            'place or address': 'Place',
            'wording': 'Wording',
            'visual detail': 'Small detail',
            'detail to add': 'Detail'
          };
          const unmatchedLines = [];
          String(directValue).split(/\n+/).forEach(function(line) {
            const trimmedLine = String(line || '').trim();
            if (!trimmedLine) return;
            const match = trimmedLine.match(/^(Place or address|Wording|Visual detail|Detail to add):\s*(.+)$/i);
            if (!match) {
              unmatchedLines.push(trimmedLine);
              return;
            }
            rows.push({
              label: structuredLabels[String(match[1] || '').toLowerCase()] || localizedSummaryLabels.details,
              value: String(match[2] || '').trim()
            });
          });
          if (unmatchedLines.length) {
            rows.push({
              label: localizedSummaryLabels.details,
              value: capitalizeFirstLetter(unmatchedLines.join(' · '))
            });
          }
          if (!rows.length) {
            rows.push({ label: localizedSummaryLabels.details, value: capitalizeFirstLetter(directValue) });
          }
        } else if (toggleValue && !/^(yes|true|1)$/i.test(String(toggleValue).trim())) {
          return rows;
        }

        const editLink = getSavedMapEditLink();
        if (editLink) {
          rows.push({
            label: 'Mark your map',
            value: 'Edit saved design',
            linkUrl: editLink
          });
        }

        return rows;
      }

      function getMapDetailRows() {
        const rows = [];
        const mapLocation = getHiddenInputValueByName('properties[Map location]');
        if (mapLocation) {
          rows.push({
            label: localizedSummaryLabels.mapLocation,
            value: mapLocation,
            separator: 'dot'
          });
        }
        const mapInstructions = getInputValueByName('properties[Map instructions]');
        if (mapInstructions) {
          rows.push({
            label: localizedSummaryLabels.instructions,
            value: capitalizeFirstLetter(mapInstructions),
            separator: 'dot'
          });
        }
        const focusAddress = getInputValueByName('properties[Focus address]');
        if (focusAddress) {
          rows.push({
            label: localizedSummaryLabels.focusAddress,
            value: capitalizeFirstLetter(focusAddress),
            separator: 'dot'
          });
        }
        const mapStyle =
          getInputValueByName('properties[Map style]') ||
          getInputValueByName('properties[Golf map style]');
        if (mapStyle) {
          rows.push({
            label: localizedSummaryLabels.style,
            value: mapStyle,
            separator: 'dot'
          });
        }
        const mapTitleAndSubtitle = getInputValueByName('properties[Map title & subtitle]');
        if (mapTitleAndSubtitle) {
          rows.push({
            label: localizedSummaryLabels.mapTitleSubtitle || 'Map title & subtitle',
            value: mapTitleAndSubtitle,
            separator: 'dot'
          });
        }
        const mapAge = getInputValueByName('properties[Map age]');
        if (mapAge) {
          rows.push({
            label: localizedSummaryLabels.year,
            value: mapAge,
            separator: 'dot'
          });
        }
        const customLegend = getInputValueByName('properties[Custom legend]');
        if (customLegend) {
          rows.push({
            label: localizedSummaryLabels.customLegend,
            value: customLegend,
            separator: 'dot'
          });
        }
        const freePersonalisation = getInputValueByName('properties[Free personalisation]');
        if (freePersonalisation) {
          rows.push({
            label: localizedSummaryLabels.personalisation,
            value: capitalizeFirstLetter(freePersonalisation),
            separator: 'dot'
          });
        }

        const refinedValue = getHiddenInputValueByName('properties[_Map refined]');
        const isRefined = /^(1|true|yes)$/i.test(refinedValue);
        if (isRefined) {
          const lat = getHiddenInputValueByName('properties[_Map latitude]');
          const lng = getHiddenInputValueByName('properties[_Map longitude]');
          if (lat && lng) {
            rows.push({
              label: localizedSummaryLabels.centrePoint,
              value: lat + ', ' + lng,
              separator: 'dot'
            });
          }
        }
        return rows;
      }

      function getCssColorFromLabel(rawValue) {
        const value = String(rawValue || '').trim();
        if (!value) return '';

        const normalized = value.toLowerCase().replace(/\s+/g, ' ').trim();
        const namedMap = {
          'hot pink': 'hotpink',
          'bright blue': '#29B1DB',
          'vivid green': '#1DDD49',
          'vibrant orange': '#ff6a00',
          'burnt orange': '#cc5500',
          'sky blue': 'skyblue',
          'navy blue': 'navy',
          'forest green': 'forestgreen',
          'charcoal': '#36454f',
          'off white': '#f8f8f0'
        };

        const mapped = namedMap[normalized] || normalized.replace(/\s+/g, '');
        try {
          if (window.CSS && typeof window.CSS.supports === 'function' && window.CSS.supports('color', mapped)) {
            return mapped;
          }
        } catch (error) {
        }
        return '';
      }

      function isLightCssColor(colorValue) {
        const value = String(colorValue || '').trim();
        if (!value) return false;
        try {
          const probe = document.createElement('span');
          probe.style.color = value;
          probe.style.position = 'absolute';
          probe.style.left = '-9999px';
          document.body.appendChild(probe);
          const computed = window.getComputedStyle(probe).color || '';
          probe.remove();

          const match = computed.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
          if (!match) return false;
          const r = Number(match[1]) / 255;
          const g = Number(match[2]) / 255;
          const b = Number(match[3]) / 255;
          const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
          return luminance >= 0.82;
        } catch (error) {
          return false;
        }
      }

      function isAddonControlSuppressed(control, propertyHandle) {
        function isHiddenByIoAccordion(element) {
          if (!element) return false;

          const moreWaysRoot = element.closest(
            '#infiniteoptions-container.io-static-aged-layout'
          );
          if (
            moreWaysRoot &&
            moreWaysRoot.getAttribute('data-io-more-personalisation-expanded') === 'false' &&
            element.closest('.io-more-personalisation-item')
          ) {
            return true;
          }

          const body = document.body;
          if (!body) return false;

          const collapsed1 = body.getAttribute('data-io-collapsed-1') === '1';
          const collapsed2 = body.getAttribute('data-io-collapsed-2') === '1';
          if (!collapsed1 && !collapsed2) return false;

          if (collapsed1 && element.closest('.io-sec-1')) return true;
          if (
            collapsed2 &&
            element.closest(
              '.io-sec-2, .io-aged-dep, .io-dep-3d, .io-dep-3dpm, .io-dep-limited-edition, .io-3d-colour-dep, .io-pop-art-dep-words, .io-pop-art-dep-colours, .io-pop-art-dep-style, .io-pop-art-dep-custom-colour, .io-pop-art-dep-pick-font, .io-pop-art-dep-custom-font'
            )
          ) return true;

          return false;
        }

        const host = control?.closest(
          '.hanger_checkbox, .option_hanger_colour, .option_frame_colour_new, .option_custom_frame_colour_new, .checkbox_same_line, [class*="option_"], [role="switch"]'
        );

        if (isHangerPropertyHandle(propertyHandle) && finishNeedsFrameColourBlock()) return true;

        const candidates = [
          control,
          host,
          control?.closest('fieldset'),
          control?.closest('[role="switch"]')
        ];

        for (let index = 0; index < candidates.length; index += 1) {
          const element = candidates[index];
          if (!element) continue;
          if (element.disabled || element.hasAttribute('disabled')) return true;
          if (element.getAttribute('aria-disabled') === 'true') return true;
          if (
            element.classList?.contains('disabled') ||
            element.classList?.contains('hide-oos-disable') ||
            element.classList?.contains('hide-oos-disabled') ||
            element.classList?.contains('camouflage-marked-unavailable')
          ) {
            return true;
          }
        }

        const relatedToggle = getRelatedToggleControl(control);
        if (relatedToggle && relatedToggle !== control && relatedToggle.disabled) return true;
        const isEnhancedPersonalisationSource =
          propertyHandle === 'personalisation' &&
          !!control?.closest('.io-personalisation-card-test__native-toggle') &&
          !!control?.closest('[data-io-personalisation-card-test]');
        const isCollapsedCustomFrameSource =
          !!host?.matches('.option_custom_frame_colour_new[data-frame-colour-custom-details][hidden]') &&
          !!document.querySelector('.option_frame_colour_new input[name="properties[Frame colour]"][value="Custom"]:checked');
        if (host && isElementHidden(host) && !isHiddenByIoAccordion(host) && !isEnhancedPersonalisationSource && !isCollapsedCustomFrameSource) return true;

        return false;
      }

      function publishAddonApproval(required) {
        if (window.__PDP_ADDON_APPROVAL_REQUIRED__ === required) return;
        window.__PDP_ADDON_APPROVAL_REQUIRED__ = required;
        document.dispatchEvent(new CustomEvent('pdp:addon-approval-change', {
          detail: { requiresApproval: required }
        }));
      }

      function getAddonSelections() {
        const container = document.getElementById('infiniteoptions-container');
        const addonRoots = [];

        function addAddonRoot(rootNode) {
          if (!rootNode || addonRoots.indexOf(rootNode) !== -1) return;
          addonRoots.push(rootNode);
        }

        addAddonRoot(container);
        addAddonRoot(document.querySelector('[data-pdp-pricing-finish-first-finish-section]'));
        addAddonRoot(document.querySelector('[data-pdp-pricing-finish-first-layout]'));
        document.querySelectorAll('[data-pdp-pricing-hanger], [data-pdp-pricing-hanger-colour], .hanger_checkbox').forEach(addAddonRoot);

        if (!addonRoots.length) {
          publishAddonApproval(false);
          return Promise.resolve({ items: [], hasUnmapped: false });
        }

        const items = [];
        let hasUnmapped = false;
        let requiresApproval = false;
        const seen = new Set();
        const work = [];
        const controls = [];
        const seenControls = new Set();

        addonRoots.forEach(function(rootNode) {
          rootNode.querySelectorAll('input, select').forEach(function(control) {
            if (seenControls.has(control)) return;
            seenControls.add(control);
            controls.push(control);
          });
        });

        controls.forEach(function(control) {
          const rawName =
            String(control.name || '') ||
            String(control.getAttribute('name-disabled') || '');
          if (control.disabled && control.type !== 'hidden') return;

          const propertyHandle = getPropertyHandle(control);
          if (!propertyHandle) return;
          if (ih(propertyHandle) && getAgedToneValueFromRealControl() !== 'aged') return;
          if (isAddonControlSuppressed(control, propertyHandle)) return;

          if (!rawName && ['radio', 'checkbox'].includes(control.type)) {
            const container = control.closest('fieldset, .checkbox_same_line, [role="switch"]');
            const hiddenProxy = container && Array.from(container.querySelectorAll('input[type="hidden"]')).find(function(input) {
              const proxyHandle = getPropertyHandle(input);
              const proxyConfig = addonConfig[proxyHandle];
              const proxyValueKey = handleize(input.value || 'yes');
              return !!(proxyConfig && proxyConfig[proxyValueKey]);
            });

            if (hiddenProxy) return;
          }

          const category = getAddonCategory(propertyHandle);
          if (!category) return;

          const configForHandle = addonConfig[propertyHandle];
          if (!configForHandle) return;

          if (control.type === 'hidden') {
            const hiddenValue = String(control.value || '').trim();
            const isProxySelected = hiddenProxyIsSelected(control);
            if (!hiddenValue && !isProxySelected) return;
            if (!isProxySelected) return;

            const valueKey = handleize(hiddenValue || 'yes');
            const entry = configForHandle[valueKey];
            if (!entry) return;

            const key = propertyHandle + '::' + valueKey;
            if (seen.has(key)) return;
            seen.add(key);
            requiresApproval = requiresApproval || (entry.requiresApproval ?? defaultAddonConfig[propertyHandle]?.[valueKey]?.requiresApproval) === true;

            work.push(
              resolveAddonEntryPrice(entry).then(function(resolvedPrice) {
                if (resolvedPrice === null) {
                  hasUnmapped = true;
                  return;
                }

                items.push({
                  label: buildAddonDisplayLabel(entry, propertyHandle, control),
                  category: category,
                  propertyHandle: propertyHandle,
                  selectedValueLabel: normalizeSelectionLabel(getReadableSelectionLabel(control)),
                  price: resolvedPrice.price,
                  compareAtPrice: resolvedPrice.compareAtPrice
                });
              })
            );
            return;
          }

          if (control.tagName === 'SELECT') {
            const selectedOption = control.selectedOptions[0];
            if (!selectedOption || !selectedOption.value) return;

            const valueKey = handleize(selectedOption.value);
            const entry = configForHandle[valueKey];
            if (!entry) return;

            const key = propertyHandle + '::' + valueKey;
            if (seen.has(key)) return;
            seen.add(key);
            requiresApproval = requiresApproval || (entry.requiresApproval ?? defaultAddonConfig[propertyHandle]?.[valueKey]?.requiresApproval) === true;

            work.push(
              resolveAddonEntryPrice(entry).then(function(resolvedPrice) {
                if (resolvedPrice === null) {
                  hasUnmapped = true;
                  return;
                }

                items.push({
                  label: buildAddonDisplayLabel(entry, propertyHandle, control),
                  category: category,
                  propertyHandle: propertyHandle,
                  selectedValueLabel: normalizeSelectionLabel(getReadableSelectionLabel(control)),
                  price: resolvedPrice.price,
                  compareAtPrice: resolvedPrice.compareAtPrice
                });
              })
            );
            return;
          }

          if (control.type === 'radio' && !controlIsSelected(control)) return;
          if (control.type === 'checkbox' && !controlIsSelected(control)) return;
          if (!['radio', 'checkbox'].includes(control.type)) return;

          const valueKey = handleize(control.value || 'yes');
          const entry = configForHandle[valueKey];
          if (!entry) return;

          const key = propertyHandle + '::' + valueKey;
          if (seen.has(key)) return;
          seen.add(key);
          requiresApproval = requiresApproval || (entry.requiresApproval ?? defaultAddonConfig[propertyHandle]?.[valueKey]?.requiresApproval) === true;

          work.push(
            resolveAddonEntryPrice(entry).then(function(resolvedPrice) {
              if (resolvedPrice === null) {
                hasUnmapped = true;
                return;
              }

              items.push({
                label: buildAddonDisplayLabel(entry, propertyHandle, control),
                category: category,
                propertyHandle: propertyHandle,
                selectedValueLabel: normalizeSelectionLabel(getReadableSelectionLabel(control)),
                price: resolvedPrice.price,
                compareAtPrice: resolvedPrice.compareAtPrice
              });
            })
          );
        });

        if (getAgedToneValueFromRealControl() === 'aged') {
          const agedHandle = addonConfig['colour-tone'] ? 'colour-tone' : (addonConfig['color-tone'] ? 'color-tone' : (addonConfig['aged'] ? 'aged' : ''));
          const agedEntry = agedHandle && addonConfig[agedHandle] ? addonConfig[agedHandle].aged : null;
          const agedKey = agedHandle ? (agedHandle + '::aged') : '';
          if (agedEntry && agedKey && !seen.has(agedKey)) {
            seen.add(agedKey);
            work.push(resolveAddonEntryPrice(agedEntry).then(function(resolvedPrice) {
              if (resolvedPrice === null) { hasUnmapped = true; return; }
              items.push({ label: buildAddonDisplayLabel(agedEntry, agedHandle, null), category: getAddonCategory(agedHandle) || 'finish', propertyHandle: agedHandle, selectedValueLabel: getSelectedAgedLevelLabelFromDom(), price: resolvedPrice.price, compareAtPrice: resolvedPrice.compareAtPrice });
            }));
          }
        }

        publishAddonApproval(requiresApproval);
        return Promise.all(work).then(function() {
          return { items: items, hasUnmapped: hasUnmapped };
        });
      }

      function getLimitedEditionAddonItem(baseVariant) {
        if (!baseVariant || typeof baseVariant.price !== 'number') return null;
        if (window.UMGoogleDiscount && typeof window.UMGoogleDiscount.syncLimitedEditionAvailability === 'function' &&
            window.UMGoogleDiscount.syncLimitedEditionAvailability(baseVariant)) return null;

        function getLimitedEditionBaseCentsFromVariant(variant) {
          if (!variant || typeof variant.price !== 'number') return null;
          if (typeof variant.compare_at_price === 'number' && variant.compare_at_price > 0) {
            return variant.compare_at_price;
          }
          const form = document.querySelector('[data-product-select]')?.form;
          const field = form && Array.from(form.elements).find(function(input) {
            return !input.disabled && input.name === 'properties[LE Base Price]' && String(input.value || '').trim();
          });
          const explicitBase = field ? parseFloat(field.value) : NaN;
          if (Number.isFinite(explicitBase)) return Math.round(explicitBase * 100);
          return variant.price;
        }

        function isLimitedEditionSelectedLocal() {
          const root = document.querySelector('.option_limited_edition');
          if (!root) return false;

          const checkbox = root.querySelector('input[type="checkbox"]');
          if (checkbox) return !!checkbox.checked;

          const switchCard = root.querySelector('[role="switch"]');
          if (switchCard) return switchCard.getAttribute('aria-checked') === 'true';

          const selectedRadio = root.querySelector('input[type="radio"]:checked');
          if (selectedRadio) return !/^(no|false|0)$/i.test(String(selectedRadio.value || '').trim());

          return false;
        }

        function computeLimitedEditionAddonCentsLocal(baseCents) {
          function getLimitedEditionAddonFloorLocal() {
            const code = String(window.Shopify?.currency?.active || 'GBP').toUpperCase();
            if (code === 'USD') return 60;
            if (code === 'EUR') return 50;
            return 40;
          }

          const base = baseCents / 100;
          // Match the cart transform: the rounding tier uses the uplifted total.
          const total = base * 1.5;
          const step = total < 100 ? 1 : (total < 500 ? 10 : 100);
          const leTotalRounded = Math.ceil((total + 1e-9) / step) * step;
          const addon = leTotalRounded - base;
          const addonFinal = Math.max(addon, getLimitedEditionAddonFloorLocal());
          return Math.max(0, Math.round(addonFinal * 100));
        }

        const isSelected = (typeof window.__UMC_IS_LIMITED_EDITION_SELECTED__ === 'function')
          ? window.__UMC_IS_LIMITED_EDITION_SELECTED__()
          : isLimitedEditionSelectedLocal();
        if (!isSelected) return null;

        const baseCents = getLimitedEditionBaseCentsFromVariant(baseVariant);
        if (typeof baseCents !== 'number' || Number.isNaN(baseCents) || baseCents <= 0) return null;

        const addonCents = (typeof window.__UMC_GET_LIMITED_EDITION_ADDON_CENTS__ === 'function')
          ? window.__UMC_GET_LIMITED_EDITION_ADDON_CENTS__(baseCents)
          : computeLimitedEditionAddonCentsLocal(baseCents);
        if (typeof addonCents !== 'number' || addonCents <= 0) return null;

        return {
          label: localizedSummaryLabels.limitedEdition,
          category: 'finish',
          propertyHandle: 'limited-edition',
          selectedValueLabel: localizedSummaryLabels.limitedEdition,
          // The transform replaces the entire unit price using its chosen base.
          price: baseCents + addonCents - baseVariant.price,
          compareAtPrice: null
        };
      }

      function getSummaryFlavourLabel(item) {
        if (!item) return '';
        const handle = String(item.propertyHandle || '').trim().toLowerCase();
        const rawLabel = String(item.label || '').trim().toLowerCase();
        if (isHangerPropertyHandle(handle)) {
          const hangerColour = normalizeSelectionLabel(item.selectedValueLabel) ||
            normalizeSelectionLabel(getSelectedHangerColourLabelFromDom());
          return localizedSummaryLabels.woodenHanger + (hangerColour ? ' \u00b7 ' + hangerColour : '');
        }
        if (rawLabel === 'aged' || handle === 'aged' || handle === 'colour-tone' || handle === 'color-tone') {
          var agedLevel = String(item.selectedValueLabel || '').trim();
          if (!agedLevel || !/%$/.test(agedLevel)) {
            agedLevel = getSelectedAgedLevelLabelFromDom();
          }
          if (agedLevel) {
            if (!/%$/.test(agedLevel) && /^\d+(\.\d+)?$/.test(agedLevel)) {
              agedLevel += '%';
            }
            var agedLevelNumeric = parseFloat(String(agedLevel).replace('%', ''));
            var agedDescriptor = '';
            if (Number.isFinite(agedLevelNumeric)) {
              if (agedLevelNumeric >= 10 && agedLevelNumeric <= 20) {
                agedDescriptor = localizedSummaryLabels.light;
              } else if (agedLevelNumeric >= 30 && agedLevelNumeric <= 70) {
                agedDescriptor = localizedSummaryLabels.medium;
              } else if (agedLevelNumeric >= 80 && agedLevelNumeric <= 100) {
                agedDescriptor = localizedSummaryLabels.heavy;
              }
            }
            return agedDescriptor
              ? (localizedSummaryLabels.agedFinish + ' \u00b7 ' + agedLevel + ' ' + agedDescriptor)
              : (localizedSummaryLabels.agedFinish + ' \u00b7 ' + agedLevel);
          }
          return localizedSummaryLabels.agedFinish;
        }
        if (handle === 'limited-edition' || rawLabel === 'limited edition' || rawLabel === 'limited-edition') {
          return localizedSummaryLabels.limitedEdition + ' \u00b7 ' + localizedSummaryLabels.editionOf50;
        }
        if (handle === 'pop-art-text' || handle === 'customisation-pop-art-text' || rawLabel === 'pop art text') {
          return localizedSummaryLabels.popArtText;
        }
        return String(item.label || '').trim();
      }

      function formatSummaryLabelPattern(label) {
        const raw = String(label || '').trim();
        if (!raw) return '';
        const parts = raw.split('\u00b7');
        if (parts.length < 2) {
          return '<span class="pdp-pricing-summary__base-noun">' + escapeHtml(raw) + '</span>';
        }
        const lead = String(parts.shift() || '').trim();
        const tailRaw = String(parts.join('\u00b7') || '').trim();
        const tail = tailRaw.replace(/^[\s\u00b7·•.:-]+/, '').trim();
        if (!lead || !tail) {
          return '<span class="pdp-pricing-summary__base-noun">' + escapeHtml(raw) + '</span>';
        }
        const looksLikeFeaturedSizeTail =
          /^(classic|statement|feature|grand|gallery)\b/i.test(tail) ||
          /\b\d+\s*[x×]\s*\d+/.test(tail);
        if (looksLikeFeaturedSizeTail) {
          return '<span class="pdp-pricing-summary__base-noun">' + escapeHtml(lead) + '</span> ' +
            '<span class="pdp-pricing-summary__label-tail">' + escapeHtml(tail) + '</span>';
        }
        return '<span class="pdp-pricing-summary__base-noun">' + escapeHtml(lead) + '</span> ' +
          '<span class="pdp-pricing-summary__sep" aria-hidden="true">&middot;</span> ' +
          '<span class="pdp-pricing-summary__label-tail">' + escapeHtml(tail) + '</span>';
      }

      function renderAddonRows(items) {
        if (!addonsListEl) return;
        addonsListEl.innerHTML = '';

        items.forEach(function(item) {
          const row = document.createElement('div');
          row.className = 'pdp-pricing-summary__row';
          row.innerHTML = `
            <span class="pdp-pricing-summary__label"></span>
            <span class="pdp-pricing-summary__value-wrap">
              <span class="pdp-pricing-summary__compare"></span>
              <span class="pdp-pricing-summary__value"></span>
            </span>
          `;
          row.querySelector('.pdp-pricing-summary__label').textContent = item.label;
          const compareEl = row.querySelector('.pdp-pricing-summary__compare');
          if (item.compareAtPrice && item.compareAtPrice > item.price) {
            compareEl.innerHTML = formatMoney(item.compareAtPrice);
          } else if (compareEl) {
            compareEl.remove();
          }
          row.querySelector('.pdp-pricing-summary__value').innerHTML = formatMoney(item.price);
          addonsListEl.appendChild(row);
        });
      }

      function renderLineItems(targetEl, items) {
        if (!targetEl) return;
        targetEl.innerHTML = '';

        (items || []).forEach(function(item) {
          const row = document.createElement('div');
          row.className = 'pdp-pricing-summary__row pdp-pricing-summary__row--flat-addon';
          row.innerHTML = `
            <span class="pdp-pricing-summary__label"></span>
            <span class="pdp-pricing-summary__value-wrap">
              <span class="pdp-pricing-summary__compare"></span>
              <span class="pdp-pricing-summary__value"></span>
            </span>
          `;
          row.querySelector('.pdp-pricing-summary__label').innerHTML = formatSummaryLabelPattern(getSummaryFlavourLabel(item));
          const compareEl = row.querySelector('.pdp-pricing-summary__compare');
          const itemPrice = Number(item.price || 0);
          const isMapDetailsRow = String(item.propertyHandle || '').trim().toLowerCase() === 'map-details';
          if (isMapDetailsRow) {
            if (compareEl) compareEl.remove();
            row.querySelector('.pdp-pricing-summary__value').textContent = '';
          } else if (itemPrice <= 0) {
            if (compareEl) compareEl.remove();
            row.querySelector('.pdp-pricing-summary__value').textContent = localizedSummaryLabels.included;
          } else {
            if (item.compareAtPrice && item.compareAtPrice > itemPrice) {
              compareEl.innerHTML = formatMoney(item.compareAtPrice);
            } else if (compareEl) {
              compareEl.remove();
            }
            row.querySelector('.pdp-pricing-summary__value').innerHTML = formatMoney(itemPrice);
          }
          targetEl.appendChild(row);

          const itemHandle = String(item.propertyHandle || '').trim().toLowerCase();
          const itemLabel = String(item.label || '').trim().toLowerCase();
          const isPopArtRow =
            itemHandle === 'pop-art-text' ||
            itemHandle === 'customisation-pop-art-text' ||
            itemLabel === 'pop art text';
          const isPersonalisationRow =
            itemHandle === 'personalisation' ||
            itemHandle === 'map-personalisation' ||
            itemHandle === 'customisation-personalisation' ||
            itemHandle === 'personalization' ||
            itemLabel === 'personalisation' ||
            itemLabel === 'personalization';

          if (isPopArtRow) {
            const detailRows = getPopArtDetailRows();
            if (detailRows.length) {
              const sub = document.createElement('div');
              sub.className = 'pdp-pricing-summary__subrows';
              detailRows.forEach(function(detail) {
                const line = document.createElement('div');
                line.className = 'pdp-pricing-summary__subrow';
                const labelEl = document.createElement('span');
                labelEl.className = 'pdp-pricing-summary__subrow-label';
                labelEl.textContent = String(detail.label || '');
                line.appendChild(labelEl);
                line.appendChild(document.createTextNode(' \u00b7 '));

                const valueEl = document.createElement('span');
                const rawDetailValue = String(detail.value || '');
                valueEl.textContent = rawDetailValue;
                if (String(detail.label || '').toLowerCase() === 'text') {
                  valueEl.textContent = rawDetailValue.toUpperCase();
                }
                if (detail.isColour) {
                  valueEl.className = 'pdp-pricing-summary__subrow-value--colour';
                  const cssColor = getCssColorFromLabel(detail.rawValue || detail.value);
                  if (cssColor) {
                    valueEl.style.color = cssColor;
                    if (isLightCssColor(cssColor)) {
                      valueEl.classList.add('pdp-pricing-summary__subrow-value--on-light');
                    }
                  }
                }

                line.appendChild(valueEl);
                sub.appendChild(line);
              });
              targetEl.appendChild(sub);
            }
          }
          if (isPersonalisationRow) {
            const detailRows = getPersonalisationDetailRows();
            if (detailRows.length) {
              const sub = document.createElement('div');
              sub.className = 'pdp-pricing-summary__subrows';
              detailRows.forEach(function(detail) {
                const line = document.createElement('div');
                line.className = 'pdp-pricing-summary__subrow';

                const labelEl = document.createElement('span');
                labelEl.className = 'pdp-pricing-summary__subrow-label';
                labelEl.textContent = String(detail.label || '') + ':';
                line.appendChild(labelEl);
                line.appendChild(document.createTextNode(' '));

                const valueEl = document.createElement('span');
                const detailValue = String(detail.value || '');
                const detailLinkUrl = getSafeHttpUrl(detail.linkUrl || '');
                if (detailLinkUrl) {
                  const linkEl = document.createElement('a');
                  linkEl.className = 'pdp-pricing-summary__subrow-value-link';
                  linkEl.href = detailLinkUrl;
                  linkEl.target = '_blank';
                  linkEl.rel = 'noopener';
                  linkEl.textContent = detailValue || 'Edit saved design';
                  valueEl.appendChild(linkEl);
                } else {
                  valueEl.textContent = detailValue;
                }
                line.appendChild(valueEl);
                sub.appendChild(line);
              });
              targetEl.appendChild(sub);
            }
          }
          if (isMapDetailsRow) {
            const detailRows = getMapDetailRows();
            if (detailRows.length) {
              const sub = document.createElement('div');
              sub.className = 'pdp-pricing-summary__subrows';
              detailRows.forEach(function(detail) {
                const line = document.createElement('div');
                line.className = 'pdp-pricing-summary__subrow';

                const labelEl = document.createElement('span');
                labelEl.className = 'pdp-pricing-summary__subrow-label';
                labelEl.textContent = String(detail.label || '');
                line.appendChild(labelEl);
                line.appendChild(document.createTextNode(detail.separator === 'dot' ? ' \u00b7 ' : ': '));

                const valueEl = document.createElement('span');
                valueEl.textContent = String(detail.value || '');
                line.appendChild(valueEl);
                sub.appendChild(line);
              });
              targetEl.appendChild(sub);
            }
          }
        });
      }

      function splitAddonGroups(items) {
        const grouped = {
          finish: [],
          personalisation: []
        };
        (items || []).forEach(function(item) {
          if (item && item.category === 'finish') {
            grouped.finish.push(item);
          } else if (item) {
            grouped.personalisation.push(item);
          }
        });
        return grouped;
      }

      function moneyTextFromCents(cents) {
        if (typeof cents !== 'number' || Number.isNaN(cents)) return '';
        const host = document.createElement('span');
        host.innerHTML = formatMoney(cents);
        return (host.textContent || '').trim();
      }

      function getAddonConfigEntryForLabel(handleCandidates, preferredValueKeys) {
        const keys = Array.isArray(preferredValueKeys) && preferredValueKeys.length
          ? preferredValueKeys.map(handleize).filter(Boolean)
          : ['yes', 'true', 'default'];
        for (let i = 0; i < handleCandidates.length; i += 1) {
          const handle = handleize(handleCandidates[i]);
          if (!handle) continue;
          const values = addonConfig[handle];
          if (!values || typeof values !== 'object') continue;
          let entry = null;
          for (let k = 0; k < keys.length; k += 1) {
            const key = keys[k];
            if (Object.prototype.hasOwnProperty.call(values, key)) {
              entry = values[key];
              break;
            }
          }
          if (!entry) continue;
          return { handle: handle, entry: entry };
        }
        return null;
      }

      function computeLimitedEditionAddonCentsForLabel(baseCents) {
        function getLimitedEditionAddonFloorLocal() {
          const code = String(window.Shopify?.currency?.active || 'GBP').toUpperCase();
          if (code === 'USD') return 60;
          if (code === 'EUR') return 50;
          return 40;
        }

        if (typeof baseCents !== 'number' || Number.isNaN(baseCents) || baseCents <= 0) return 0;
        const base = baseCents / 100;
        const total = base * 1.5;
        const step = total < 100 ? 1 : (total < 500 ? 10 : 100);
        const leTotalRounded = Math.ceil((total + 1e-9) / step) * step;
        const addon = leTotalRounded - base;
        const addonFinal = Math.max(addon, getLimitedEditionAddonFloorLocal());
        return Math.max(0, Math.round(addonFinal * 100));
      }

      function getToggleCardTitleLabel(row) {
        if (!row) return null;
        return row.querySelector(':scope > .spb-label-tooltip > label.spb-productdescfont.spb-productdesctextcolor') ||
          row.querySelector(':scope > label.spb-productdescfont.spb-productdesctextcolor');
      }

      function ensureToggleCardPriceNode(labelEl) {
        if (!labelEl) return null;
        // The standalone 3D card groups its status and price for mobile wrapping.
        // Reuse that nested price rather than creating another direct child.
        let node = labelEl.querySelector('[data-io-addon-price]');
        if (!node) {
          node = document.createElement('span');
          node.className = 'io-addon-price';
          node.setAttribute('data-io-addon-price', '');
          node.setAttribute('aria-hidden', 'true');
          labelEl.appendChild(node);
        }
        return node;
      }

      function ensureMostPopularBadges(row, labelEl) {
        if (!row || !labelEl) return;

        let desktopBadge = labelEl.querySelector(':scope > [data-io-most-popular-desktop]');
        if (!desktopBadge) {
          desktopBadge = document.createElement('span');
          desktopBadge.className = 'io-most-popular-badge io-most-popular-badge--desktop';
          desktopBadge.setAttribute('data-io-most-popular-desktop', '');
          desktopBadge.textContent = localizedSummaryLabels.mostPopular || 'Most popular';
          labelEl.appendChild(desktopBadge);
        }

        const helperHost = row.classList.contains('unique3dpm_checkbox')
          ? document.querySelector('#Unique3DPMHelperText')
          : document.querySelector('#Unique3DHelperText');
        const mobileHost = helperHost || row;
        let mobileBadge = mobileHost.querySelector(':scope > [data-io-most-popular-mobile]');
        if (!mobileBadge) {
          mobileBadge = document.createElement('div');
          mobileBadge.className = 'io-most-popular-badge io-most-popular-badge--mobile';
          mobileBadge.setAttribute('data-io-most-popular-mobile', '');
          mobileBadge.textContent = localizedSummaryLabels.mostPopular || 'Most popular';
          mobileHost.appendChild(mobileBadge);
        }
      }

      function setToggleCardLabelPrice(rowSelector, handleCandidates, map) {
        const row = document.querySelector(rowSelector);
        if (!row) return;
        const labelEl = getToggleCardTitleLabel(row);
        if (!labelEl) return;
        const priceNode = ensureToggleCardPriceNode(labelEl);
        if (!priceNode) return;

        let item = null;
        handleCandidates.some(function(candidate) {
          const key = handleize(candidate);
          item = key ? (map[key] || null) : null;
          return !!item;
        });

        if (!item || typeof item.price !== 'number' || Number.isNaN(item.price)) {
          priceNode.textContent = '';
          priceNode.hidden = true;
          return;
        }

        if (item.price <= 0) {
          priceNode.textContent = '';
          priceNode.hidden = true;
          return;
        }

        const moneyText = moneyTextFromCents(item.price);
        if (!moneyText) {
          priceNode.textContent = '';
          priceNode.hidden = true;
          return;
        }

        priceNode.textContent = '+\u00a0' + moneyText.replace(/\s/g, '\u00a0');
        priceNode.hidden = false;
      }

      function stripInlineAddonPriceText(text) {
        if (typeof text !== 'string' || !text) return text;
        return text
          .replace(/\s*\(\+\s*[^)]*\d[^)]*\)/g, '')
          .replace(/\s{2,}/g, ' ')
          .replace(/\s+\./g, '.')
          .trim();
      }

      function stripHelperPriceCopy(helperSelector) {
        const helperEl = document.querySelector(helperSelector);
        if (!helperEl) return;

        for (let i = 0; i < helperEl.childNodes.length; i += 1) {
          const node = helperEl.childNodes[i];
          if (!node || node.nodeType !== Node.TEXT_NODE) continue;
          const original = node.textContent || '';
          if (!original.trim()) continue;
          const cleaned = stripInlineAddonPriceText(original);
          if (cleaned !== original) node.textContent = cleaned + ' ';
          return;
        }
      }

      function renderToggleCardLabelPrices() {
        const priceMap = state.labelAddonPricesByHandle || {};
        setToggleCardLabelPrice('.option_limited_edition', ['limited-edition'], priceMap);
        setToggleCardLabelPrice('.unique3d_checkbox', ['unique-3d'], priceMap);
        setToggleCardLabelPrice('.unique3dpm_checkbox', ['unique-3d-pm', 'unique3dpm'], priceMap);
        setToggleCardLabelPrice('.pop_art_text_checkbox', ['pop-art-text'], priceMap);
        setToggleCardLabelPrice('.personalise_checkbox', ['personalisation'], priceMap);
        setToggleCardLabelPrice('.artist_name_checkbox', ['artist-name', 'artist-border', 'add-artist-border'], priceMap);
        setToggleCardLabelPrice('.option_colour_tone', ['colour-tone'], priceMap);

        stripHelperPriceCopy('#Unique3DHelperText');
        stripHelperPriceCopy('#Unique3DPMHelperText');
        stripHelperPriceCopy('#PopArtHelperText');
        stripHelperPriceCopy('#LimitedEditionHelperText');
        stripHelperPriceCopy('#PersonalisationHelperText');
        stripHelperPriceCopy('#ArtistNameHelperText');

        const uniqueRows = document.querySelectorAll('.unique3d_checkbox, .unique3dpm_checkbox');
        uniqueRows.forEach(function(row) {
          const labelEl = getToggleCardTitleLabel(row);
          if (!labelEl) return;
          ensureMostPopularBadges(row, labelEl);
        });
      }

      function buildToggleCardLabelPrices(baseVariant) {
        const map = {};
        const jobs = [];

        function getLimitedEditionBaseCentsFromVariant(variant) {
          if (!variant || typeof variant.price !== 'number') return null;
          if (typeof variant.compare_at_price === 'number' && variant.compare_at_price > 0) {
            return variant.compare_at_price;
          }
          const form = document.querySelector('[data-product-select]')?.form;
          const field = form && Array.from(form.elements).find(function(input) {
            return !input.disabled && input.name === 'properties[LE Base Price]' && String(input.value || '').trim();
          });
          const explicitBase = field ? parseFloat(field.value) : NaN;
          if (Number.isFinite(explicitBase)) return Math.round(explicitBase * 100);
          return variant.price;
        }

        function queueConfigPrice(handles, storageHandle, preferredValueKeys) {
          const hit = getAddonConfigEntryForLabel(handles, preferredValueKeys);
          if (!hit) return;
          jobs.push(resolveAddonEntryPrice(hit.entry).then(function(resolved) {
            if (!resolved || typeof resolved.price !== 'number' || Number.isNaN(resolved.price)) return;
            map[handleize(storageHandle || hit.handle)] = {
              handle: hit.handle,
              price: resolved.price,
              compareAtPrice: resolved.compareAtPrice || null
            };
          }));
        }

        queueConfigPrice(['unique-3d'], 'unique-3d');
        queueConfigPrice(['unique-3d-pm', 'unique3dpm'], 'unique-3d-pm');
        queueConfigPrice(['pop-art-text'], 'pop-art-text');
        queueConfigPrice(['personalisation'], 'personalisation');
        queueConfigPrice(['artist-name', 'artist-border', 'add-artist-border'], 'artist-name');
        queueConfigPrice(['colour-tone'], 'colour-tone', ['aged']);

        jobs.push(Promise.resolve().then(function() {
          if (!baseVariant || typeof baseVariant.price !== 'number' || Number.isNaN(baseVariant.price)) return;
          const baseCents = getLimitedEditionBaseCentsFromVariant(baseVariant);
          if (typeof baseCents !== 'number' || Number.isNaN(baseCents) || baseCents <= 0) return;
          const cents = (typeof window.__UMC_GET_LIMITED_EDITION_ADDON_CENTS__ === 'function')
            ? window.__UMC_GET_LIMITED_EDITION_ADDON_CENTS__(baseCents)
            : computeLimitedEditionAddonCentsForLabel(baseCents);
          if (typeof cents !== 'number' || Number.isNaN(cents) || cents <= 0) return;
          map['limited-edition'] = { handle: 'limited-edition', price: baseCents + cents - baseVariant.price, compareAtPrice: null };
        }));

        return Promise.all(jobs).then(function() {
          return map;
        });
      }

      function ensureFeaturedSizesCard() {
        let card = document.querySelector('[data-pdp-featured-sizes]');
        if (card) return card;

        const saleMessage = formatFeaturedSizesSaleMessage();
        const compactSaleMessage = formatFeaturedSizesSaleMessage(pricingConfig.pseudoSaleShortName);
        const legacySaleMessageHtml = saleMessage
          ? '<span class="pdp-featured-sizes__sale-message-legacy-full">' + escapeHtml(saleMessage) + '</span>' +
            '<span class="pdp-featured-sizes__sale-message-legacy-short">' + escapeHtml(compactSaleMessage || saleMessage) + '</span>'
          : '';
        card = document.createElement('div');
        card.className = 'pdp-featured-sizes';
        card.setAttribute('data-pdp-featured-sizes', '');
        card.innerHTML = `
          <div class="pdp-featured-sizes__list">
            <p class="pdp-featured-sizes__sale-message${saleMessage ? ' pdp-featured-sizes__sale-message--legacy' : ''}" data-featured-sizes-sale-message${saleMessage ? '' : ' hidden'}>${legacySaleMessageHtml}</p>
            <p class="pdp-featured-sizes__set-message" data-featured-sizes-set-message hidden></p>
            <p class="pdp-featured-sizes__subtitle" data-featured-subtitle-featured hidden>${escapeHtml(localizedPdpLabels.featuredSizesFeatured)}</p>
            <p class="pdp-featured-sizes__subtitle" data-featured-subtitle-selected hidden>${escapeHtml(localizedPdpLabels.featuredSizesCurrent)}</p>
            <button type="button" class="pdp-featured-size pdp-featured-size--selected is-hidden" data-featured-size-key="selected">
              <span class="pdp-featured-size__dot" aria-hidden="true"></span>
              <span class="pdp-featured-size__name"></span>
              <span class="pdp-featured-size__label" data-featured-size-label>&mdash;</span>
              <span class="pdp-featured-size__price" data-featured-size-price>&mdash;</span>
            </button>
            <p class="pdp-featured-sizes__subtitle" data-featured-subtitle-recommended hidden>${escapeHtml(localizedPdpLabels.featuredSizesRecommended)}</p>
            <button type="button" class="pdp-featured-size is-hidden" data-featured-size-key="meta-small" disabled>
              <span class="pdp-featured-size__dot" aria-hidden="true"></span>
              <span class="pdp-featured-size__name">${escapeHtml(localizedPdpLabels.featuredSizesSmall || 'Small')}</span>
              <span class="pdp-featured-size__label" data-featured-size-label>&mdash;</span>
              <span class="pdp-featured-size__price" data-featured-size-price>&mdash;</span>
            </button>
            <button type="button" class="pdp-featured-size" data-featured-size-key="small">
              <span class="pdp-featured-size__dot" aria-hidden="true"></span>
              <span class="pdp-featured-size__name">${escapeHtml(localizedPdpLabels.featuredSizesClassic)}</span>
              <span class="pdp-featured-size__label" data-featured-size-label>&mdash;</span>
              <span class="pdp-featured-size__price" data-featured-size-price>&mdash;</span>
            </button>
            <button type="button" class="pdp-featured-size" data-featured-size-key="medium">
              <span class="pdp-featured-size__dot" aria-hidden="true"></span>
              <span class="pdp-featured-size__name">${escapeHtml(localizedPdpLabels.featuredSizesStatement)}</span>
              <span class="pdp-featured-size__label" data-featured-size-label>&mdash;</span>
              <span class="pdp-featured-size__price" data-featured-size-price>&mdash;</span>
            </button>
            <button type="button" class="pdp-featured-size" data-featured-size-key="grand">
              <span class="pdp-featured-size__dot" aria-hidden="true"></span>
              <span class="pdp-featured-size__name">${escapeHtml(localizedPdpLabels.featuredSizesFeature)}</span>
              <span class="pdp-featured-size__label" data-featured-size-label>&mdash;</span>
              <span class="pdp-featured-size__price" data-featured-size-price>&mdash;</span>
            </button>
            <button type="button" class="pdp-featured-size" data-featured-size-key="large">
              <span class="pdp-featured-size__dot" aria-hidden="true"></span>
              <span class="pdp-featured-size__name">${escapeHtml(localizedPdpLabels.featuredSizesGrand)}</span>
              <span class="pdp-featured-size__label" data-featured-size-label>&mdash;</span>
              <span class="pdp-featured-size__price" data-featured-size-price>&mdash;</span>
            </button>
            <button type="button" class="pdp-featured-size" data-featured-size-key="gallery">
              <span class="pdp-featured-size__dot" aria-hidden="true"></span>
              <span class="pdp-featured-size__name">${escapeHtml(localizedPdpLabels.featuredSizesGallery)}</span>
              <span class="pdp-featured-size__label" data-featured-size-label>&mdash;</span>
              <span class="pdp-featured-size__price" data-featured-size-price>&mdash;</span>
            </button>
            <div class="pdp-featured-sizes__gallery-merch" data-featured-gallery-merch aria-hidden="true">
              <p class="pdp-featured-sizes__gallery-merch-title">${escapeHtml(localizedPdpLabels.featuredSizesGalleryAdviceTitle)}</p>
              <p class="pdp-featured-sizes__gallery-merch-body">${escapeHtml(localizedPdpLabels.featuredSizesGalleryAdviceBody)}</p>
              <div class="pdp-featured-sizes__gallery-merch-benefits">${renderGalleryAdviceBenefits()}</div>
              <span data-featured-gallery-contact-wrap></span>
            </div>
          </div>
          <div class="pdp-featured-sizes__controls">
            <span class="pdp-featured-sizes__all-label" data-featured-all-label hidden>${escapeHtml(localizedPdpLabels.featuredSizesAllSizes)}</span>
            <button type="button" class="pdp-featured-sizes__toggle" data-featured-sizes-toggle aria-expanded="false">${escapeHtml(localizedPdpLabels.featuredSizesViewAll)}</button>
            <span class="pdp-featured-sizes__toggle-subtitle" data-featured-sizes-toggle-subtitle>${escapeHtml(localizedPdpLabels.featuredSizesToggleSubtitle)}</span>
            <span class="pdp-featured-sizes__size-help" data-featured-size-help>
              <span>${escapeHtml(localizedPdpLabels.featuredSizesUnsure)}</span>
              <span class="pdp-featured-sizes__size-help-contact" data-featured-size-contact-wrap></span>
            </span>
          </div>
        `;

        sizeFieldset.insertAdjacentElement('beforebegin', card);
        addFeaturedSizeContactPanel(card);
        addGalleryContactPanel(card.querySelector('[data-featured-gallery-merch]'));
        return card;
      }

      function renderGalleryAdviceBenefits() {
        const parts = String(localizedPdpLabels.featuredSizesGalleryAdviceBenefits || '')
          .split('·')
          .map(function(part) { return part.trim(); })
          .filter(Boolean);
        if (!parts.length) return '';

        const tooltipHtml = String(pricingConfig.galleryCustomFramingTooltipHtml || '').trim();
        let html = '<span class="pdp-featured-sizes__gallery-merch-primary-benefit">';
        html += '<span class="pdp-featured-sizes__gallery-merch-benefit-item">' + escapeHtml(parts[0]) + '</span>';
        if (tooltipHtml) {
          html += '<span class="pdp-featured-sizes__gallery-merch-tooltip">' + tooltipHtml + '</span>';
        }
        html += '</span>';
        parts.slice(1).forEach(function(part) {
          html += '<span class="pdp-featured-sizes__gallery-merch-separator" aria-hidden="true"> · </span>';
          html += '<span class="pdp-featured-sizes__gallery-merch-benefit-item">' + escapeHtml(part) + '</span>';
        });
        return html;
      }

      function getVisibleSizeEntries() {
        const selections = getCurrentSelections();
        const finishFirstMode = isFinishFirstMode();
        const selectedFinishValue = getSelectedOptionValue(finishPosition);

        return Array.from(sizeFieldset.querySelectorAll('.variant-input[data-value]'))
          .map(function(node) {
            const value = node.dataset.value || '';
            const baseVariant = findBaseVariant(value, selections);
            const finishVariant = finishFirstMode && selectedFinishValue
              ? findVariantFor(value, selectedFinishValue, selections)
              : null;
            return {
              node: node,
              value: value,
              label: getCurrentNodeLabel(node) || value,
              baseVariant: baseVariant,
              finishVariant: finishVariant,
              order: originalSizeOrder.has(value) ? originalSizeOrder.get(value) : Number.MAX_SAFE_INTEGER
            };
          })
          .filter(function(entry) {
            if (isCamouflageHiddenSizeValue(entry.value)) return false;
            if (finishFirstMode) {
              return isVariantEligible(entry.finishVariant);
            }
            return !isNodeSuppressed(entry.node);
          })
          .sort(function(a, b) {
            return a.order - b.order;
          });
      }

      function getEligibleSizeEntries(visibleEntries) {
        return (visibleEntries || getVisibleSizeEntries()).filter(function(entry) {
          return isVariantEligible(entry.baseVariant);
        });
      }

      function normalizeForSizeTierMatch(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/×/g, 'x')
          .replace(/[–—]/g, '-')
          .replace(/\s+/g, '')
          .replace(/"/g, 'in')
          .trim();
      }

      function matchesSizeTier(entry, tier) {
        if (!entry) return false;

        const normalizedLabel = normalizeForSizeTierMatch(entry.label || '');
        const normalizedValue = normalizeForSizeTierMatch(entry.value || '');
        const aliases = tier === 'classic'
          ? [
              '45x60cm', '18x24in',
              '45x45cm', '18x18in',
              '23x45cm', '9x18in'
            ]
          : tier === 'statement'
            ? [
                '60x90cm', '60x80cm', '60x75cm',
                '24x36in', '24x32in', '24x30in',
                '90x90cm', '36x36in',
                '30x60cm', '12x24in',
                '40x90cm', '16x36in'
              ]
            : [];

        return aliases.some(function(alias) {
          const normalizedAlias = normalizeForSizeTierMatch(alias);
          return normalizedLabel.includes(normalizedAlias) || normalizedValue.includes(normalizedAlias);
        });
      }

      function getLargestNonASizeEntry(entries) {
        const nonAEntries = entries.filter(function(entry) {
          return !isASizeLabel(entry.label || entry.value || '');
        });

        return nonAEntries.length ? nonAEntries[nonAEntries.length - 1] : (entries[entries.length - 1] || null);
      }

      function getSecondSmallestNonASizeEntry(entries) {
        const nonAEntries = entries.filter(function(entry) {
          return !isASizeLabel(entry.label || entry.value || '');
        });

        if (!nonAEntries.length) return null;
        return nonAEntries[1] || nonAEntries[0] || null;
      }

      function hasA0Size(entry) {
        const label = String(entry && (entry.label || '')).trim();
        const value = String(entry && (entry.value || '')).trim();
        return /^\s*a0(?:\b|\s|[-(])/i.test(label) || /^\s*a0(?:\b|\s|[-(])/i.test(value);
      }

      function getNormalizedSizeText(entry) {
        return normalizeForSizeTierMatch((entry && (entry.value || entry.label)) || '');
      }

      function getInchPairs(entry) {
        const normalized = getNormalizedSizeText(entry);
        const pairs = [];
        const regex = /(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)in/g;
        let match = null;

        while ((match = regex.exec(normalized))) {
          const first = parseFloat(match[1]);
          const second = parseFloat(match[2]);
          if (!isNaN(first) && !isNaN(second)) {
            pairs.push([first, second]);
          }
        }

        return pairs;
      }

      function isX50InEntry(entry) {
        return getInchPairs(entry).some(function(pair) {
          return Math.abs(pair[0] - 50) < 0.001 || Math.abs(pair[1] - 50) < 0.001;
        });
      }

      function getLargestInchArea(entry) {
        return getInchPairs(entry).reduce(function(largestArea, pair) {
          return Math.max(largestArea, pair[0] * pair[1]);
        }, 0);
      }

      function getCmPairs(entry) {
        const source = String((entry && (entry.value || entry.label)) || '').toLowerCase();
        const normalized = source
          .replace(/×/g, 'x')
          .replace(/\s+/g, '')
          .replace(/\(a\d+\)/g, '');
        const pairs = [];
        const regex = /(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)(?:cm|mm)/g;
        let match = null;

        while ((match = regex.exec(normalized))) {
          let first = parseFloat(match[1]);
          let second = parseFloat(match[2]);
          if (isNaN(first) || isNaN(second)) continue;
          if (match[0].endsWith('mm')) {
            first = first / 10;
            second = second / 10;
          }
          pairs.push([first, second]);
        }

        return pairs;
      }

      function isGalleryServiceSizeEligible(entry) {
        const inchPairs = getInchPairs(entry);
        if (inchPairs.length) {
          return inchPairs.some(function(pair) {
            const isSquare = Math.abs(pair[0] - pair[1]) < 0.001;
            return isSquare
              ? Math.min(pair[0], pair[1]) >= 45
              : Math.max(pair[0], pair[1]) >= 50;
          });
        }

        const cmPairs = getCmPairs(entry);
        return cmPairs.some(function(pair) {
          const isSquare = Math.abs(pair[0] - pair[1]) < 0.001;
          return isSquare
            ? Math.min(pair[0], pair[1]) >= 114
            : Math.max(pair[0], pair[1]) >= 127;
        });
      }

      function getLargestCmArea(entry) {
        return getCmPairs(entry).reduce(function(largestArea, pair) {
          return Math.max(largestArea, pair[0] * pair[1]);
        }, 0);
      }

      function getComparableArea(entry) {
        const inchArea = getLargestInchArea(entry);
        if (inchArea > 0) return inchArea;
        return getLargestCmArea(entry);
      }

      function getComparableLongestSide(entry) {
        if (!entry) return 0;
        const inchPairs = getInchPairs(entry);
        if (inchPairs.length) {
          return inchPairs.reduce(function(maxSide, pair) {
            return Math.max(maxSide, pair[0], pair[1]);
          }, 0);
        }
        const cmPairs = getCmPairs(entry);
        if (!cmPairs.length) return 0;
        return cmPairs.reduce(function(maxSide, pair) {
          return Math.max(maxSide, pair[0], pair[1]);
        }, 0);
      }

      function isExactA4Entry(entry) {
        const text = String((entry && entry.label) || '') + ' ' + String((entry && entry.value) || '');
        return /(?:^|[^a-z0-9])a4(?:[^a-z0-9]|$)/i.test(text);
      }

      function isExact8x10InEntry(entry) {
        return getInchPairs(entry).some(function(pair) {
          const directMatch = Math.abs(pair[0] - 8) < 0.001 && Math.abs(pair[1] - 10) < 0.001;
          const swappedMatch = Math.abs(pair[0] - 10) < 0.001 && Math.abs(pair[1] - 8) < 0.001;
          return directMatch || swappedMatch;
        });
      }

      function getMetaSmallSizeEntry(entries) {
        if (!isMetaFineArtTraffic || !Array.isArray(entries) || !entries.length) return null;

        const a4Entry = entries.find(isExactA4Entry) || null;
        const eightByTenEntry = entries.find(isExact8x10InEntry) || null;
        return eightByTenEntry || a4Entry;
      }

      function entryHasExactCmSize(entry, widthCm, heightCm) {
        if (!entry) return false;
        const pairs = getCmPairs(entry);
        if (!pairs.length) return false;
        return pairs.some(function(pair) {
          const a = pair[0];
          const b = pair[1];
          const directMatch = Math.abs(a - widthCm) < 0.001 && Math.abs(b - heightCm) < 0.001;
          const swappedMatch = Math.abs(a - heightCm) < 0.001 && Math.abs(b - widthCm) < 0.001;
          return directMatch || swappedMatch;
        });
      }

      function getClosestX50InEntry(entries, targetEntry) {
        const targetArea = getLargestInchArea(targetEntry);

        return entries.reduce(function(closestEntry, entry) {
          if (!entry || !isX50InEntry(entry)) return closestEntry;
          if (!closestEntry) return entry;
          if (!targetArea) return closestEntry;

          const currentDistance = Math.abs(getLargestInchArea(entry) - targetArea);
          const closestDistance = Math.abs(getLargestInchArea(closestEntry) - targetArea);
          return currentDistance < closestDistance ? entry : closestEntry;
        }, null);
      }

      function getSquareInches(entry) {
        const squarePair = getInchPairs(entry).find(function(pair) {
          return Math.abs(pair[0] - pair[1]) < 0.001;
        });
        return squarePair ? squarePair[0] : 0;
      }

      function isSquare45InEntry(entry) {
        return Math.abs(getSquareInches(entry) - 45) < 0.001;
      }

      function getGrandSizeEntry(entries, large) {
        if (useUsGrandSizeRule) {
          return getClosestX50InEntry(entries, large);
        }

        const a0Entry = entries.find(function(entry) {
          return hasA0Size(entry);
        }) || null;
        if (a0Entry) return a0Entry;

        const largeSquareInches = getSquareInches(large);
        if (largeSquareInches > 45) {
          const square45Entry = entries.find(function(entry) {
            return entry && entry.value !== (large && large.value || '') && isSquare45InEntry(entry);
          }) || null;
          if (square45Entry) return square45Entry;
        }

        if (!large || isX50InEntry(large)) return null;

        const x50Entry = entries.find(function(entry) {
          return entry && entry.value !== (large.value || '') && isX50InEntry(entry);
        }) || null;
        if (x50Entry) return x50Entry;

        return null;
      }

      function getFeaturedSizeDisplayLabel(entry) {
        if (!entry) return '—';
        if (hasA0Size(entry)) return '84×119cm (A0)';
        return entry.label || '—';
      }

      function getFallbackFeaturedSizeEntriesWithoutClassic(preferredEntries, large, allEntries) {
        const smallestPreferredEntry = preferredEntries[0] || null;
        const smallestComparableArea = getComparableArea(smallestPreferredEntry);
        const shouldAvoidSmallestAsClassic = preferredEntries.length >= 5 && smallestComparableArea > 0 && smallestComparableArea < 2500;
        const isSmallestPreferred = function(entry) {
          return !!(entry && smallestPreferredEntry && entry.value === (smallestPreferredEntry.value || ''));
        };
        const availableEntries = preferredEntries.filter(function(entry) {
          return !large || entry.value !== large.value;
        });
        const statementCandidate = preferredEntries.find(function(entry) {
          return (!large || entry.value !== large.value) && matchesSizeTier(entry, 'statement');
        }) || null;
        let small = null;
        if (statementCandidate) {
          const statementIndex = preferredEntries.findIndex(function(entry) {
            return entry.value === statementCandidate.value;
          });
          if (statementIndex > 0) {
            small = preferredEntries[statementIndex - 1] || null;
          }
        }
        if (!small) {
          small = availableEntries.find(function(entry) {
            return !shouldAvoidSmallestAsClassic || !isSmallestPreferred(entry);
          }) || availableEntries[0] || large || null;
        }
        const usedValues = new Set();

        if (small && small.value) {
          usedValues.add(small.value);
        }
        if (large && large.value) {
          usedValues.add(large.value);
        }

        let medium = null;
        if (small) {
          const smallIndex = preferredEntries.findIndex(function(entry) {
            return entry.value === small.value;
          });
          const oneSizeUp = preferredEntries[smallIndex + 1] || null;

          if (oneSizeUp && !usedValues.has(oneSizeUp.value || '')) {
            medium = oneSizeUp;
          }
        }

        if (!medium) {
          medium = preferredEntries.find(function(entry) {
            return !usedValues.has(entry.value || '') && (!shouldAvoidSmallestAsClassic || !isSmallestPreferred(entry));
          }) || null;
        }

        const featured = {
          small: small,
          medium: medium,
          large: large,
          grand: getGrandSizeEntry(allEntries || preferredEntries, large)
        };
        return finalizeFeaturedSizeEntries(applySmallestClassicPreference(featured, preferredEntries, large));
      }

      function applySmallestClassicPreference(featured, preferredEntries, large) {
        if (!featured || !Array.isArray(preferredEntries) || !preferredEntries.length) return featured;

        const smallestEntry = preferredEntries[0] || null;
        if (!smallestEntry || !smallestEntry.value) return featured;
        if (large && large.value && smallestEntry.value === large.value) return featured;

        const smallestArea = getComparableArea(smallestEntry);
        if (!(smallestArea > 0) || smallestArea < 2500) return featured;

        if (featured.small && featured.small.value === smallestEntry.value) return featured;

        const previousSmall = featured.small || null;
        featured.small = smallestEntry;

        if (!featured.medium || featured.medium.value === smallestEntry.value) {
          featured.medium = preferredEntries.find(function(entry) {
            return entry &&
              entry.value &&
              entry.value !== smallestEntry.value &&
              (!large || entry.value !== (large.value || ''));
          }) || previousSmall || null;
        }

        if (featured.medium && featured.medium.value === featured.small.value) {
          featured.medium = preferredEntries.find(function(entry) {
            return entry &&
              entry.value &&
              entry.value !== featured.small.value &&
              (!large || entry.value !== (large.value || ''));
          }) || null;
        }

        return featured;
      }

      function finalizeFeaturedSizeEntries(featured) {
        if (!featured) return featured;

        const keys = ['small', 'medium', 'grand', 'large', 'gallery'];
        const seenValues = new Set();
        keys.forEach(function(key) {
          const entry = featured[key];
          const value = entry && entry.value ? entry.value : '';
          if (!value) {
            featured[key] = null;
            return;
          }
          if (seenValues.has(value)) {
            featured[key] = null;
            return;
          }
          seenValues.add(value);
        });
        let previousMetric = 0;
        keys.forEach(function(key) {
          const entry = featured[key];
          if (!entry) return;
          const metric = getComparableLongestSide(entry);
          if (!(metric > 0)) return;
          if (previousMetric > 0 && metric < previousMetric) {
            featured[key] = null;
            return;
          }
          previousMetric = metric;
        });
        const has70x100 = keys.some(function(key) {
          return entryHasExactCmSize(featured[key], 70, 100);
        });
        if (has70x100) {
          keys.forEach(function(key) {
            if (entryHasExactCmSize(featured[key], 76, 114)) {
              featured[key] = null;
            }
          });
        }

        if (!featured.grand || !featured.medium) {
          return featured;
        }

        const grandArea = getComparableArea(featured.grand);
        const statementArea = getComparableArea(featured.medium);
        if (grandArea > 0 && statementArea > 0 && grandArea < statementArea) {
          featured.grand = null;
        }

        return featured;
      }

      function getFeaturedSizeEntriesLegacy(entries) {
        if (!entries.length) {
          return { small: null, medium: null, large: null, grand: null };
        }

        const nonAEntries = entries.filter(function(entry) {
          return !isASizeLabel(entry.label || entry.value || '');
        });
        const preferredEntries = nonAEntries.length ? nonAEntries : entries;
        const smallestPreferredEntry = preferredEntries[0] || null;
        const smallestComparableArea = getComparableArea(smallestPreferredEntry);
        const shouldAvoidSmallestAsClassic = preferredEntries.length >= 5 && smallestComparableArea > 0 && smallestComparableArea < 2500;
        const isSmallestPreferred = function(entry) {
          return !!(entry && smallestPreferredEntry && entry.value === (smallestPreferredEntry.value || ''));
        };
        const large = getLargestNonASizeEntry(entries);
        let classicMatch = preferredEntries.find(function(entry) {
          return (!large || entry.value !== large.value) && matchesSizeTier(entry, 'classic');
        }) || null;
        if (shouldAvoidSmallestAsClassic && isSmallestPreferred(classicMatch)) {
          classicMatch = preferredEntries.find(function(entry) {
            return (!large || entry.value !== large.value) && !isSmallestPreferred(entry);
          }) || null;
        }

        if (!classicMatch) {
          return getFallbackFeaturedSizeEntriesWithoutClassic(preferredEntries, large, entries);
        }

        if (preferredEntries.length <= 5) {
          const statementMatch = preferredEntries.find(function(entry) {
            return (!large || entry.value !== large.value) && matchesSizeTier(entry, 'statement');
          }) || null;

          const featured = {
            small: classicMatch,
            medium: statementMatch || preferredEntries.find(function(entry) {
              return entry && entry.value !== (classicMatch && classicMatch.value || '') && !isSmallestPreferred(entry);
            }) || getSecondSmallestNonASizeEntry(entries),
            large: getLargestNonASizeEntry(entries),
            grand: null
          };
          return finalizeFeaturedSizeEntries(applySmallestClassicPreference(featured, preferredEntries, large));
        }

        const usedValues = new Set(
          large && large.value ? [large.value] : []
        );

        let small = classicMatch;
        if (small && small.value) {
          usedValues.add(small.value);
        }

        let medium = preferredEntries.find(function(entry) {
          return !usedValues.has(entry.value || '') && matchesSizeTier(entry, 'statement');
        }) || null;
        if (medium && medium.value) {
          usedValues.add(medium.value);
        }

        const fallbackEntries = preferredEntries.filter(function(entry) {
          return !usedValues.has(entry.value || '');
        });

        if (!small) {
          small = fallbackEntries.shift() || null;
          if (small && small.value) {
            usedValues.add(small.value);
          }
        }

        if (!medium) {
          const mediumFallback = fallbackEntries.find(function(entry) {
            return !usedValues.has(entry.value || '');
          }) || null;
          medium = mediumFallback;
          if (medium && medium.value) {
            usedValues.add(medium.value);
          }
        }

        const featured = {
          small: small,
          medium: medium,
          large: large,
          grand: getGrandSizeEntry(entries, large)
        };
        return finalizeFeaturedSizeEntries(applySmallestClassicPreference(featured, preferredEntries, large));
      }

      function getFeaturedSizeEntriesV2(entries) {
        if (!entries || !entries.length) {
          return { small: null, medium: null, large: null, grand: null };
        }

        const preferredEntries = entries.filter(function(entry) {
          return entry && entry.value && !isASizeLabel(entry.label || entry.value || '');
        });
        if (!preferredEntries.length) {
          return { small: null, medium: null, large: null, grand: null };
        }

        function getLargestSquareInchesAreaLocal(entry) {
          const inchArea = getLargestInchArea(entry);
          if (inchArea > 0) return inchArea;
          const cmArea = getLargestCmArea(entry);
          if (cmArea <= 0) return 0;
          return cmArea / (2.54 * 2.54);
        }

        function getLongestSideInchesLocal(entry) {
          const inchPairs = getInchPairs(entry);
          if (inchPairs.length) {
            return inchPairs.reduce(function(maxSide, pair) {
              return Math.max(maxSide, pair[0], pair[1]);
            }, 0);
          }
          const cmPairs = getCmPairs(entry);
          if (!cmPairs.length) return 0;
          return cmPairs.reduce(function(maxSide, pair) {
            return Math.max(maxSide, pair[0] / 2.54, pair[1] / 2.54);
          }, 0);
        }

        const ordered = preferredEntries.slice().sort(function(a, b) {
          return getLongestSideInchesLocal(a) - getLongestSideInchesLocal(b);
        });

        const used = new Set();
        const markUsed = function(entry) {
          if (entry && entry.value) used.add(entry.value);
        };
        const isDistinct = function(entry) {
          return !!(entry && entry.value && !used.has(entry.value));
        };
        const firstDistinct = function(pool) {
          return (pool || []).find(function(entry) { return isDistinct(entry); }) || null;
        };
        const largestDistinct = function(pool) {
          const distinct = (pool || []).filter(function(entry) { return isDistinct(entry); });
          return distinct.length ? distinct[distinct.length - 1] : null;
        };
        const nearestToTargets = function(pool, targets, min, max) {
          return (pool || []).reduce(function(best, entry) {
            if (!isDistinct(entry)) return best;
            const side = getLongestSideInchesLocal(entry);
            if (!(side > 0)) return best;
            if (typeof min === 'number' && side < min) return best;
            if (typeof max === 'number' && side > max) return best;

            const distance = Math.min.apply(null, targets.map(function(target) {
              return Math.abs(side - target);
            }));
            if (!best) return { entry: entry, distance: distance, side: side };
            if (distance < best.distance) return { entry: entry, distance: distance, side: side };
            if (distance === best.distance && side > best.side) return { entry: entry, distance: distance, side: side };
            return best;
          }, null);
        };

        const isLimitedSet = ordered.length <= 3;
        const isFullSet = ordered.length >= 6;
        const smallest = ordered[0] || null;
        const second = ordered[1] || null;

        let classic = smallest;
        let hideClassic = false;
        if (isFullSet) {
          const classicTarget = nearestToTargets(ordered, [24], 21, 27);
          if (classicTarget && classicTarget.entry) {
            classic = classicTarget.entry;
          }
        } else if (!isLimitedSet && smallest && second) {
          const smallestArea = getLargestSquareInchesAreaLocal(smallest);
          const secondArea = getLargestSquareInchesAreaLocal(second);
          const tinyOutlier = smallestArea > 0 && secondArea > 0 && smallestArea < 300 && (secondArea / smallestArea) >= 1.3;
          if (tinyOutlier) classic = second;
        }
        if (!isLimitedSet && !isFullSet && smallest && second && classic && classic.value === smallest.value) {
          const smallestSide = getLongestSideInchesLocal(smallest);
          const secondSide = getLongestSideInchesLocal(second);
          if (smallestSide > 0 && secondSide > 0) {
            const isolatedBySide = (secondSide / smallestSide) >= 1.35;
            const smallestArea = getLargestSquareInchesAreaLocal(smallest);
            const secondArea = getLargestSquareInchesAreaLocal(second);
            const isolatedByArea = smallestArea > 0 && secondArea > 0 && (secondArea / smallestArea) >= 1.8;
            if (isolatedBySide || isolatedByArea) {
              hideClassic = true;
            }
          }
        }

        if (!hideClassic) {
          markUsed(classic);
        } else {
          classic = null;
        }

        let statement = null;
        if (isFullSet) {
          const statementTarget = nearestToTargets(ordered, [30, 36], 28, 38);
          statement = statementTarget ? statementTarget.entry : null;
        }
        if (!isDistinct(statement)) {
          statement = ordered.find(function(entry) {
            return isDistinct(entry) && getLongestSideInchesLocal(entry) > getLongestSideInchesLocal(classic);
          }) || firstDistinct(ordered);
        }
        markUsed(statement);

        let largeBracketMatch = nearestToTargets(ordered, [40, 45], 36, 48);
        let largeBracket = largeBracketMatch ? largeBracketMatch.entry : null;
        if (!isDistinct(largeBracket)) largeBracket = null;

        let grandBracketMatch = nearestToTargets(ordered, [50], 46, 56);
        let grandBracket = grandBracketMatch ? grandBracketMatch.entry : null;
        if (!isDistinct(grandBracket)) grandBracket = null;
        markUsed(grandBracket);

        if (largeBracket && !isDistinct(largeBracket)) {
          largeBracket = null;
        }
        let gallery = null;
        const largestOrderedEntry = ordered[ordered.length - 1] || null;
        const largestSideInches = getLongestSideInchesLocal(largestOrderedEntry);
        const classicSide = getLongestSideInchesLocal(classic);
        const grandSide = getLongestSideInchesLocal(grandBracket);
        const hasAboveGrand = ordered.some(function(entry) {
          return entry && entry !== grandBracket && getLongestSideInchesLocal(entry) > grandSide;
        });
        const secondLargestOrderedEntry = ordered.length > 1 ? ordered[ordered.length - 2] : null;
        const secondLargestSideInches = getLongestSideInchesLocal(secondLargestOrderedEntry);
        const hasEnoughSpread = (
          (ordered.length >= 5 && grandSide > 0 && hasAboveGrand) ||
          (ordered.length >= 3 && largestSideInches >= 60 && secondLargestSideInches > 0 && (largestSideInches - secondLargestSideInches) >= 6)
        );

        if (hasEnoughSpread && largestOrderedEntry && largestSideInches >= 60 && isDistinct(largestOrderedEntry)) {
          gallery = largestOrderedEntry;
        }

        return finalizeFeaturedSizeEntries({
          small: classic || null,
          medium: statement || null,
          grand: largeBracket || null,
          large: grandBracket || null,
          gallery: gallery || null
        });
      }

      function getFeaturedSizeEntries(entries) {
        try {
          return getFeaturedSizeEntriesV2(entries);
        } catch (error) {
          return getFeaturedSizeEntriesLegacy(entries);
        }
      }

      function isASizeLabel(value) {
        return /(?:^|[\s(])a\d+(?:\b|[\s)])/i.test(String(value || '').trim());
      }

      function getSizeToggleLabel(expanded, entries) {
        if (expanded) {
          return localizedPdpLabels.featuredSizesHideList;
        }
        const count = (entries || []).length;
        return normalizeLocalizedText(localizedPdpLabels.featuredSizesShowAllCount).replace('[count]', count);
      }

      function closeSizeConciergePanel(conciergeCell) {
        if (!conciergeCell) return;
        const trigger = conciergeCell.querySelector('[data-contact-advice-trigger]');
        if (trigger && trigger.getAttribute('aria-expanded') === 'true') trigger.click();
      }

      function getSizeContactPanel() {
        const panelTrigger = document.getElementById(String(pricingConfig.sizeContactPanelId || '') + '-trigger');
        return panelTrigger && panelTrigger.closest('[data-contact-advice-panel]');
      }

      function setSizeContactTriggerText(panel, text) {
        const trigger = panel && panel.querySelector('[data-contact-advice-trigger]');
        if (panel && text) {
          panel.setAttribute('data-contact-workshop-trigger-online', text);
          panel.setAttribute('data-contact-workshop-trigger-offline', text);
        }
        if (trigger && text) setTextIfChanged(trigger, text);
      }

      function setSizeContactPanelCopy(panel, title, body) {
        if (!panel) return;
        setTextIfChanged(panel.querySelector('.contact-advice-panel__title'), title || '');
        setTextIfChanged(panel.querySelector('.contact-advice-panel__body'), body || '');
      }

      function setSizeContactWhatsappUrl(panel, url) {
        if (!panel || !url) return;
        panel.querySelectorAll('[data-contact-advice-message-channel="whatsapp"], [data-contact-advice-whatsapp-secondary]').forEach(function(link) {
          link.setAttribute('href', url);
        });
      }

      function addSizeConciergePanel(conciergeCell) {
        if (!conciergeCell) return;
        const contactWrap = conciergeCell.querySelector('[data-pdp-concierge-contact-wrap]');
        if (!contactWrap) return;
        const panel = getSizeContactPanel();
        setSizeContactTriggerText(panel, localizedPdpLabels.featuredSizesConciergeLink);
        setSizeContactPanelCopy(panel, localizedPdpLabels.customSizeHelpTitle, localizedPdpLabels.customSizeHelpBody);
        setSizeContactWhatsappUrl(panel, pricingConfig.sizeContactWhatsappUrl);
        if (panel && panel.parentNode !== contactWrap) contactWrap.appendChild(panel);
      }

      function addFeaturedSizeContactPanel(card) {
        if (!card) return;
        const contactWrap = card.querySelector('[data-featured-size-contact-wrap]');
        if (!contactWrap) return;
        const panel = getSizeContactPanel();
        setSizeContactTriggerText(panel, localizedPdpLabels.featuredSizesAskTeam);
        setSizeContactPanelCopy(panel, localizedPdpLabels.featuredSizesHelpTitle, localizedPdpLabels.featuredSizesHelpBody);
        setSizeContactWhatsappUrl(panel, pricingConfig.featuredSizeContactWhatsappUrl);
        if (panel && panel.parentNode !== contactWrap) contactWrap.appendChild(panel);
      }

      function closeGalleryContactPanel(galleryMerch) {
        if (!galleryMerch) return;
        const trigger = galleryMerch.querySelector('[data-contact-advice-trigger]');
        if (trigger && trigger.getAttribute('aria-expanded') === 'true') trigger.click();
      }

      function addGalleryContactPanel(galleryMerch) {
        if (!galleryMerch) return;
        const contactWrap = galleryMerch.querySelector('[data-featured-gallery-contact-wrap]');
        if (!contactWrap) return;
        const panelTrigger = document.getElementById(String(pricingConfig.galleryContactPanelId || '') + '-trigger');
        const panel = panelTrigger && panelTrigger.closest('[data-contact-advice-panel]');
        if (panel && panel.parentNode !== contactWrap) contactWrap.appendChild(panel);
      }

      function syncExpandedSizeLayout(expanded, featuredValueSet, eligibleEntries) {
        withSizeObserverPaused(function() {
          let divider = sizeFieldset.querySelector('[data-pdp-a-size-divider]');
          let conciergeCell = sizeFieldset.querySelector('[data-pdp-concierge-cell]');
          const clearSizeGroupClasses = function() {
            Array.from(sizeFieldset.querySelectorAll('.variant-input[data-value]')).forEach(function(node) {
              node.classList.remove('pdp-size-group-start', 'pdp-size-group-end');
            });
          };
          const markSizeGroupEdges = function(entries) {
            const visibleNodes = entries
              .map(function(entry) { return entry && entry.node; })
              .filter(Boolean);
            if (!visibleNodes.length) return;
            visibleNodes[0].classList.add('pdp-size-group-start');
            visibleNodes[visibleNodes.length - 1].classList.add('pdp-size-group-end');
          };

          clearSizeGroupClasses();

          if (!conciergeCell) {
            conciergeCell = document.createElement('div');
            conciergeCell.className = 'pdp-size-concierge-cell';
            conciergeCell.setAttribute('data-pdp-concierge-cell', '');
            conciergeCell.innerHTML =
              '<span class="pdp-size-concierge-text">' + escapeHtml(localizedPdpLabels.featuredSizesConciergeText) + '</span>' +
              '<span class="pdp-size-concierge-contact" data-pdp-concierge-contact-wrap></span>';
            sizeFieldset.appendChild(conciergeCell);
          }
          if (!expanded) {
            closeSizeConciergePanel(conciergeCell);
            addFeaturedSizeContactPanel(document.querySelector('[data-pdp-featured-sizes]'));
            Array.from(sizeFieldset.querySelectorAll('.variant-input[data-value]')).forEach(function(node) {
              setStylePropertyIfChanged(node, 'order', '');
            });
            if (divider) {
              divider.remove();
            }
            conciergeCell.classList.remove('is-visible');
            setStylePropertyIfChanged(conciergeCell, 'order', '');
            return;
          }

          closeSizeConciergePanel(document.querySelector('[data-featured-size-help]'));
          addSizeConciergePanel(conciergeCell);

          const nonFeaturedEntries = eligibleEntries.filter(function(entry) {
            return !featuredValueSet.has(entry.value || '');
          });
          if (!nonFeaturedEntries.length) {
            Array.from(sizeFieldset.querySelectorAll('.variant-input[data-value]')).forEach(function(node) {
              setStylePropertyIfChanged(node, 'order', '');
            });
            if (divider) {
              divider.remove();
            }
            return;
          }

          const regularEntries = nonFeaturedEntries.filter(function(entry) {
            return !isASizeLabel(entry.label || entry.value || '');
          });
          const aSizeEntries = nonFeaturedEntries.filter(function(entry) {
            return isASizeLabel(entry.label || entry.value || '');
          });
          const orderedNodes = new Set();

          regularEntries.concat(aSizeEntries).forEach(function(entry, index) {
            orderedNodes.add(entry.node);
            setStylePropertyIfChanged(entry.node, 'order', String(index + 1));
          });

          Array.from(sizeFieldset.querySelectorAll('.variant-input[data-value]')).forEach(function(node) {
            if (!orderedNodes.has(node)) {
              setStylePropertyIfChanged(node, 'order', '');
            }
          });

          if (!aSizeEntries.length) {
            markSizeGroupEdges(regularEntries);
            conciergeCell.classList.add('is-visible');
            setStylePropertyIfChanged(conciergeCell, 'order', String(regularEntries.length + 1));
            if (divider) {
              divider.remove();
            }
            return;
          }

          if (!divider) {
            divider = document.createElement('p');
            divider.className = 'variant-input-group-subheader';
            divider.setAttribute('data-pdp-a-size-divider', '');
            divider.textContent = 'A-sizes';
            sizeFieldset.appendChild(divider);
          }

          conciergeCell.classList.add('is-visible');
          setStylePropertyIfChanged(conciergeCell, 'order', String(regularEntries.length + 1));
          setStylePropertyIfChanged(divider, 'order', String(regularEntries.length + 2));
          aSizeEntries.forEach(function(entry, index) {
            setStylePropertyIfChanged(entry.node, 'order', String(regularEntries.length + 3 + index));
          });
          markSizeGroupEdges(regularEntries);
          markSizeGroupEdges(aSizeEntries);
        });
      }

      const finishFirstDebugParamEnabled = (function() {
        try {
          return new URL(window.location.href).searchParams.get('pdp_finish_debug') === '1';
        } catch (error) {
          return false;
        }
      })();
      function finishFirstVariantDebugEnabled() {
        if (finishFirstDebugParamEnabled) return true;
        try {
          return window.sessionStorage && window.sessionStorage.getItem('pdp_finish_debug') === '1';
        } catch (error) {
          return false;
        }
      }
      function finishFirstVariantDebug(label, payload) {
        if (!finishFirstVariantDebugEnabled()) return;
        // Expensive DOM snapshots are built only when diagnostics are enabled.
        const safePayload = (typeof payload === 'function' ? payload() : payload) || {};
        try {
          window.__pdpFinishFirstDebugLog = window.__pdpFinishFirstDebugLog || [];
          window.__pdpFinishFirstDebugLog.push({
            label: label,
            payload: safePayload,
            at: Date.now()
          });
          if (window.__pdpFinishFirstDebugLog.length > 300) {
            window.__pdpFinishFirstDebugLog.splice(0, window.__pdpFinishFirstDebugLog.length - 300);
          }
        } catch (error) {}
        try {
          console.log('[PDP Finish First]', label, safePayload);
        } catch (error) {}
      }

      function startLabelChurnDiagnostics() {
        if (!finishFirstVariantDebugEnabled()) return;
        const card = document.querySelector('[data-pdp-featured-sizes]');
        const targets = [card, finishFieldset].filter(Boolean);
        if (!targets.length) return;
        finishFirstVariantDebug('label-source', {
          locale: document.documentElement.lang || '',
          gallery: localizedPdpLabels.featuredSizesGallery || '',
          grand: localizedPdpLabels.featuredSizesGrand || '',
          showAll: localizedPdpLabels.featuredSizesShowAllCount || '',
          framedMap: localizedFramedMapLabel || ''
        });
        let previous = '';
        const snapshot = function() {
          const gallery = card?.querySelector('[data-featured-size-key="gallery"]');
          return {
            variantId: currentVariant?.id || null,
            selectedSize: getSelectedOptionValue(sizePosition),
            selectedFinish: getSelectedOptionValue(finishPosition),
            galleryValue: gallery?.dataset.sizeValue || '',
            galleryLabel: gallery?.querySelector('.pdp-featured-size__name')?.textContent || '',
            galleryPrice: gallery?.querySelector('[data-featured-size-price]')?.textContent || '',
            gallerySelected: !!gallery?.classList.contains('is-active'),
            allSizesLabel: card?.querySelector('[data-featured-sizes-toggle]')?.textContent || '',
            finishLabels: Array.from(finishFieldset?.querySelectorAll('.variant-input[data-value]') || []).map(function(node) {
              return [
                node.dataset.value || '',
                node.querySelector('.variant__button-label-text')?.textContent || '',
                node.querySelector('[data-pdp-finish-price-render]')?.textContent || '',
                !!node.querySelector('input[type="radio"]:checked')
              ];
            })
          };
        };
        const record = function(reason) {
          const state = snapshot();
          const signature = JSON.stringify(state);
          if (signature === previous) return;
          previous = signature;
          finishFirstVariantDebug('label-state', { reason: reason, state: state });
        };
        record('initial');
        const observer = new MutationObserver(function() { record('DOM mutation'); });
        targets.forEach(function(target) {
          observer.observe(target, { childList: true, characterData: true, subtree: true });
        });
      }

      const autoClassicDebugStart = (window.performance && typeof window.performance.now === 'function')
        ? window.performance.now()
        : Date.now();
      function autoClassicElapsedMs() {
        const now = (window.performance && typeof window.performance.now === 'function')
          ? window.performance.now()
          : Date.now();
        return Math.round((now - autoClassicDebugStart) * 10) / 10;
      }
      function traceAutoClassic(step, payload) {
        finishFirstVariantDebug('auto-classic-trace:' + step, Object.assign({
          elapsedMs: autoClassicElapsedMs()
        }, payload || {}));
      }
      if (pendingAutoClassicTraceEvents.length) {
        pendingAutoClassicTraceEvents.forEach(function(entry) {
          traceAutoClassic(entry.step, entry.payload);
        });
        pendingAutoClassicTraceEvents.length = 0;
      }

      function getSizeConversionDebug(value) {
        const lookup = {
          inches: null,
          centimetres: null
        };
        try {
          const list = Array.isArray(window.sizeConversions) ? window.sizeConversions : [];
          const inchKey = String(value || '') + '-inches';
          const cmKey = String(value || '') + '-centimetres';
          for (let i = 0; i < list.length; i += 1) {
            const item = list[i];
            if (!item || !item.key) continue;
            if (item.key === inchKey) lookup.inches = item.value || null;
            if (item.key === cmKey) lookup.centimetres = item.value || null;
          }
        } catch (error) {}
        return lookup;
      }

      function isCompoundSizeLabel(text) {
        const value = String(text || '');
        return value.indexOf('(') > -1 && /\d/.test(value) && /cm/i.test(value) && /in/i.test(value);
      }

      function getCurrentSizeUnitPreference() {
        if (typeof window.__UMC_GET_SIZE_UNIT__ === 'function') {
          return window.__UMC_GET_SIZE_UNIT__();
        }
        const switchEl = document.querySelector('#cm_inch_switch');
        const storedUnit = String((switchEl && switchEl.dataset.currentUnit) || '').toLowerCase();
        if (storedUnit === 'cm' || storedUnit === 'in') return storedUnit;
        const switchHtml = String((switchEl && switchEl.innerHTML) || '').toLowerCase();
        if (/<strong>\s*cm\s*<\/strong>/.test(switchHtml)) return 'cm';
        if (/<strong>\s*in\s*<\/strong>/.test(switchHtml)) return 'in';
        if (/<u>\s*cm\s*<\/u>/.test(switchHtml)) return 'in';
        if (/<u>\s*in\s*<\/u>/.test(switchHtml)) return 'cm';

        const iso = String(window.shopify_country_iso || '').toUpperCase();
        if (iso === 'US' || iso === 'CA') return 'in';
        return 'cm';
      }

      function getPreferredConvertedSizeLabel(sizeValue) {
        const conversions = getSizeConversionDebug(sizeValue);
        const preferredUnit = getCurrentSizeUnitPreference();
        if (preferredUnit === 'in') {
          return conversions.inches || conversions.centimetres || '';
        }
        return conversions.centimetres || conversions.inches || '';
      }

      function logSizeLabelDebug(reason, visibleEntries, featuredEntries) {
        return;
      }

      const perfCounters = {
        renderPricingCalls: 0,
        updateSizeLabelsCalls: 0,
        updateFinishLabelsCalls: 0,
        syncSharedTotalsDispatches: 0,
        startedAt: Date.now()
      };

      function logPerfCounters(reason) {
        if (!finishFirstVariantDebugEnabled()) return;
        finishFirstVariantDebug('perf', {
          reason: reason || 'tick',
          elapsedMs: Date.now() - perfCounters.startedAt,
          renderPricingCalls: perfCounters.renderPricingCalls,
          updateSizeLabelsCalls: perfCounters.updateSizeLabelsCalls,
          updateFinishLabelsCalls: perfCounters.updateFinishLabelsCalls,
          syncSharedTotalsDispatches: perfCounters.syncSharedTotalsDispatches
        });
      }

      function getDebugVariantSummary(variant) {
        if (!variant) return null;
        return {
          id: variant.id,
          available: variant.available,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
          price: variant.price
        };
      }

      function getDebugEntrySummary(entry) {
        return {
          value: entry.value || '',
          label: entry.label || '',
          hidden: isNodeSuppressed(entry.node),
          baseVariant: getDebugVariantSummary(entry.baseVariant),
          finishVariant: getDebugVariantSummary(entry.finishVariant)
        };
      }

      function triggerSizeSelection(input, options) {
        if (!input) return;
        options = options || {};
        const userInitiated = options.userInitiated === true;
        finishFirstVariantDebug('trigger-size', function() { return {
          value: input.value,
          index: input.dataset.index,
          name: input.name,
          userInitiated: userInitiated,
          checkedBefore: input.checked,
          selectedSizeBefore: getSelectedOptionValue(sizePosition),
          selectedFinishBefore: getSelectedOptionValue(finishPosition),
          scrollBefore: window.scrollY || window.pageYOffset || 0
        }; });
        // Recovery/defaulting calls this during startup as well as user clicks.
        // Only a real user action (or a later change after bare-URL defaulting)
        // should close the one-shot Classic + framed default gate.
        if (
          userInitiated ||
          !shouldAutoFramedClassicFromUrl ||
          hasAppliedBareUrlStatementDefault
        ) {
          hasVariantOptionInteraction = true;
        }
        if (input.checked) {
          if (input.dataset.index === 'option' + sizePosition) {
            lastKnownSizeValue = input.value || lastKnownSizeValue;
            intendedSizeValue = input.value || intendedSizeValue;
          }
          return;
        }
        input.checked = true;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        finishFirstVariantDebug('trigger-size:after', function() { return {
          value: input.value,
          userInitiated: userInitiated,
          scrollAfter: window.scrollY || window.pageYOffset || 0
        }; });
      }

      function getVariantInputByPositionAndValue(position, value) {
        if (!position || !value) return null;
        const inputs = Array.from(
          document.querySelectorAll('input[data-variant-input][type="radio"][data-index="option' + position + '"]')
        );
        return inputs.find(function(input) {
          return String(input.value || '') === String(value);
        }) || null;
      }

      function setAllVariantInputsForPositionValue(position, value) {
        if (!position || !value) return;
        const targetValue = String(value);
        const inputs = Array.from(
          document.querySelectorAll('input[data-variant-input][type="radio"][data-index="option' + position + '"]')
        );
        inputs.forEach(function(input) {
          input.checked = String(input.value || '') === targetValue;
        });
      }

      function getPreferredFramedFinishValue() {
        if (!finishFieldset || !finishPosition) return '';

        const finishInputs = Array.from(
          finishFieldset.querySelectorAll('.variant-input[data-index="option' + finishPosition + '"] input[type="radio"]')
        ).filter(Boolean);
        if (!finishInputs.length) return '';

        const availableFinishValues = finishInputs.map(function(input) {
          return String(input.value || '').trim();
        }).filter(Boolean);

        const preferredHandles = pricingConfig.productType === 'Fine art'
          ? ['framed-art-print', 'framed-map']
          : ['framed-map', 'framed-art-print'];

        for (let index = 0; index < preferredHandles.length; index += 1) {
          const targetHandle = preferredHandles[index];
          const matchedValue = availableFinishValues.find(function(value) {
            return handleize(value) === targetHandle;
          });
          if (matchedValue) return matchedValue;
        }

        const genericFramedValue = availableFinishValues.find(function(value) {
          return /fram/i.test(value);
        });
        return genericFramedValue || '';
      }

      function resolveClassicAutoTargetVariant(classicSizeValue, selectedFinishValue, selections) {
        if (!classicSizeValue) return null;

        const preservedSelections = Object.assign({}, selections || getCurrentSelections());
        const preferredFramedFinishValue = getPreferredFramedFinishValue();
        if (preferredFramedFinishValue) {
          const preferredVariant = findVariantFor(classicSizeValue, preferredFramedFinishValue, preservedSelections);
          if (isVariantEligible(preferredVariant)) {
            traceAutoClassic('target-variant-preferred', {
              classicSizeValue: classicSizeValue,
              preferredFramedFinishValue: preferredFramedFinishValue,
              selectedFinishValue: selectedFinishValue,
              variant: getDebugVariantSummary(preferredVariant)
            });
            return preferredVariant;
          }
        }

        if (selectedFinishValue) {
          const currentFinishVariant = findVariantFor(classicSizeValue, selectedFinishValue, preservedSelections);
          if (isVariantEligible(currentFinishVariant)) {
            traceAutoClassic('target-variant-fallback-current-finish', {
              classicSizeValue: classicSizeValue,
              selectedFinishValue: selectedFinishValue,
              variant: getDebugVariantSummary(currentFinishVariant)
            });
            return currentFinishVariant;
          }
        }

        traceAutoClassic('target-variant-miss', {
          classicSizeValue: classicSizeValue,
          preferredFramedFinishValue: preferredFramedFinishValue,
          selectedFinishValue: selectedFinishValue,
          selections: preservedSelections
        });
        return null;
      }

      function applyAutoVariantUiLock(variantId, durationMs, source) {
        if (!variantId) return;
        const lockDuration = Number(durationMs) > 0 ? Number(durationMs) : 1800;
        const until = Date.now() + lockDuration;
        window.__pdpAutoVariantLock = {
          variantId: String(variantId),
          until: until,
          source: source || 'finish-first-empty-variant-default'
        };
        traceAutoClassic('ui-lock-set', {
          variantId: String(variantId),
          until: until,
          durationMs: lockDuration
        });
      }

      function getLockedVariantOverride(eventVariant) {
        const lock = window.__pdpAutoVariantLock;
        if (!lock || !lock.variantId || !lock.until) return eventVariant || null;
        if (Date.now() > Number(lock.until)) return eventVariant || null;

        const lockedVariant = variants.find(function(variant) {
          return String(variant.id) === String(lock.variantId);
        }) || null;
        if (!lockedVariant) return eventVariant || null;
        if (!eventVariant) return lockedVariant;
        if (String(eventVariant.id) === String(lockedVariant.id)) return eventVariant;

        traceAutoClassic('ui-lock-ignore-stale-event-variant', {
          staleVariant: getDebugVariantSummary(eventVariant),
          lockedVariant: getDebugVariantSummary(lockedVariant)
        });
        return lockedVariant;
      }

      function applyVariantSelectionSinglePass(variant, options) {
        if (!variant) return false;
        options = options || {};

        const targetSizeValue = getVariantOptionValue(variant, sizePosition);
        const targetFinishValue = getVariantOptionValue(variant, finishPosition);
        const sizeInput = getVariantInputByPositionAndValue(sizePosition, targetSizeValue);
        const finishInput = getVariantInputByPositionAndValue(finishPosition, targetFinishValue);
        const dispatchInput = sizeInput || finishInput;
        if (!dispatchInput) {
          traceAutoClassic('single-pass-no-dispatch-input', {
            targetSizeValue: targetSizeValue,
            targetFinishValue: targetFinishValue,
            hasSizeInput: !!sizeInput,
            hasFinishInput: !!finishInput
          });
          return false;
        }

        const finishChanged = !!(finishInput && !finishInput.checked);
        const sizeChanged = !!(sizeInput && !sizeInput.checked);

        if (targetFinishValue) setAllVariantInputsForPositionValue(finishPosition, targetFinishValue);
        if (targetSizeValue) setAllVariantInputsForPositionValue(sizePosition, targetSizeValue);

        hasVariantOptionInteraction = true;
        if (targetSizeValue) {
          intendedSizeValue = targetSizeValue;
          lastKnownSizeValue = targetSizeValue;
        }

        finishFirstVariantDebug('auto-classic:single-pass-apply', {
          variant: getDebugVariantSummary(variant),
          targetSizeValue: targetSizeValue,
          targetFinishValue: targetFinishValue,
          finishChanged: finishChanged,
          sizeChanged: sizeChanged
        });
        traceAutoClassic('single-pass-before-dispatch', {
          variant: getDebugVariantSummary(variant),
          dispatchInputIndex: dispatchInput.dataset ? dispatchInput.dataset.index : '',
          dispatchInputValue: dispatchInput.value || ''
        });
        applyAutoVariantUiLock(variant.id, 1800, options.source);

        dispatchInput.dispatchEvent(new Event('input', { bubbles: true }));
        dispatchInput.dispatchEvent(new Event('change', { bubbles: true }));
        traceAutoClassic('single-pass-dispatched', {
          variantId: variant.id,
          targetSizeValue: targetSizeValue,
          targetFinishValue: targetFinishValue
        });
        return true;
      }

      function getExactSessionFinishValue(value) {
        const normalizedValue = String(value || '').trim();
        if (!normalizedValue) return '';
        const input = getVariantInputByPositionAndValue(finishPosition, normalizedValue);
        return input ? String(input.value || '').trim() : '';
      }

      function resolveSessionSelectionVariant() {
        const storedSizeValue = String(activeSessionSelections.size || '').trim();
        if (!storedSizeValue || !getVariantInputByPositionAndValue(sizePosition, storedSizeValue)) return null;

        const selections = getCurrentSelections();
        const storedFinishValue = getExactSessionFinishValue(activeSessionSelections.finish);
        const currentFinishValue = getSelectedOptionValue(finishPosition);
        const finishCandidates = [];
        if (storedFinishValue) finishCandidates.push(storedFinishValue);
        if (currentFinishValue && finishCandidates.indexOf(currentFinishValue) === -1) {
          finishCandidates.push(currentFinishValue);
        }

        for (let index = 0; index < finishCandidates.length; index += 1) {
          const variant = findVariantFor(storedSizeValue, finishCandidates[index], selections);
          if (isVariantEligible(variant)) return variant;
        }

        return null;
      }

      function restoreActiveSessionVariantSelection() {
        if (!shouldAutoFramedClassicFromUrl || hasAttemptedSessionSelectionRestore) return false;
        hasAttemptedSessionSelectionRestore = true;
        if (
          !activeSessionSelections.sourcePageLoadId ||
          activeSessionSelections.sourcePageLoadId === activeSelectionPageLoadId
        ) return false;
        if (window.__UM_PDP_ACTIVE_SELECTION_RESTORED_LOAD_ID__ === activeSelectionPageLoadId) {
          hasRestoredSessionVariantSelection = true;
          return false;
        }

        const targetVariant = resolveSessionSelectionVariant();
        if (!targetVariant) return false;

        window.__UM_PDP_ACTIVE_SELECTION_RESTORED_LOAD_ID__ = activeSelectionPageLoadId;
        hasRestoredSessionVariantSelection = true;
        hasVariantOptionInteraction = true;
        if (activeSessionSelections.frameColour) {
          window.__UM_PDP_ACTIVE_FRAME_COLOUR_PREFERENCE__ = activeSessionSelections.frameColour;
        }
        const targetSizeValue = getVariantOptionValue(targetVariant, sizePosition);
        const targetFinishValue = getVariantOptionValue(targetVariant, finishPosition);
        intendedSizeValue = targetSizeValue || intendedSizeValue;
        lastKnownSizeValue = targetSizeValue || lastKnownSizeValue;

        const selectionAlreadyMatches =
          getSelectedOptionValue(sizePosition) === targetSizeValue &&
          getSelectedOptionValue(finishPosition) === targetFinishValue;
        if (selectionAlreadyMatches) return false;

        return applyVariantSelectionSinglePass(targetVariant, {
          source: 'active-session-selection'
        });
      }

      function restoreActiveSessionFrameColour() {
        if (
          hasRestoredSessionFrameColour ||
          !hasRestoredSessionVariantSelection ||
          !activeSessionSelections.frameColour
        ) return false;

        const inputs = Array.from(document.querySelectorAll(
          '.option_frame_colour_new input[type="radio"][name="properties[Frame colour]"]'
        ));
        if (!inputs.length) return false;

        const storedValue = String(activeSessionSelections.frameColour).trim();
        const targetInput = inputs.find(function(input) {
          return String(input.value || '').trim() === storedValue;
        });
        if (!targetInput || targetInput.disabled) {
          hasRestoredSessionFrameColour = true;
          return false;
        }

        hasRestoredSessionFrameColour = true;
        if (targetInput.checked) return false;
        inputs.forEach(function(input) {
          input.checked = input === targetInput;
        });
        targetInput.dispatchEvent(new Event('input', { bubbles: true }));
        targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      function applyBareUrlDefaultStatementSize() {
        return false;
      }

      function syncFinishSelectionUiFromVariant(variant) {
        if (!finishFieldset || !variant) return;

        const variantFinishValue = String(getVariantOptionValue(variant, finishPosition) || '');
        if (!variantFinishValue) return;

        const finishNodes = Array.from(
          finishFieldset.querySelectorAll('.variant-input[data-index="option' + finishPosition + '"]')
        );
        if (!finishNodes.length) return;

        let matchedInput = null;
        finishNodes.forEach(function(node) {
          const input = node.querySelector('input[type="radio"]');
          if (!input) return;
          if (!matchedInput && String(input.value || '') === variantFinishValue) {
            matchedInput = input;
          }
        });

        if (!matchedInput) return;

        finishNodes.forEach(function(node) {
          const input = node.querySelector('input[type="radio"]');
          const isSelected = !!(input && input === matchedInput);
          if (input) input.checked = isSelected;
          node.classList.toggle('is-selected', isSelected);
        });
      }

      function syncFinishSelectedClassFromInputs() {
        if (!finishFieldset) return;
        finishFieldset.querySelectorAll('.variant-input[data-index="option' + finishPosition + '"]').forEach(function(node) {
          const input = node.querySelector('input[type="radio"]');
          node.classList.toggle('is-selected', !!(input && input.checked));
        });
      }

      function ensureValidSizeSelection(visibleEntries) {
        const selectedSizeValue = getSelectedOptionValue(sizePosition);
        const intendedEntry = intendedSizeValue
          ? visibleEntries.find(function(entry) {
            return entry.value === intendedSizeValue;
          })
          : null;
        const selectedEntry = visibleEntries.find(function(entry) {
          return entry.value === selectedSizeValue;
        });
        if (
          selectedEntry &&
          intendedEntry &&
          intendedSizeValue &&
          selectedSizeValue &&
          selectedSizeValue !== intendedSizeValue
        ) {
          finishFirstVariantDebug('evs:restore-intended', function() { return {
            selectedSizeValue: selectedSizeValue,
            intendedSizeValue: intendedSizeValue,
            lastKnownSizeValue: lastKnownSizeValue,
            selectedFinishValue: getSelectedOptionValue(finishPosition),
            intendedEntry: getDebugEntrySummary(intendedEntry),
            selectedEntry: getDebugEntrySummary(selectedEntry),
            visibleEntries: visibleEntries.map(getDebugEntrySummary)
          }; });

          const intendedInput = intendedEntry.node.querySelector('input[type="radio"]');
          if (intendedInput) {
            triggerSizeSelection(intendedInput);
          }
          return false;
        }

        if (selectedEntry) {
          lastKnownSizeValue = selectedSizeValue;
          intendedSizeValue = selectedSizeValue;
          finishFirstVariantDebug('evs:selected-visible', function() { return {
            selectedSizeValue: selectedSizeValue,
            lastKnownSizeValue: lastKnownSizeValue,
            intendedSizeValue: intendedSizeValue,
            selectedFinishValue: getSelectedOptionValue(finishPosition),
            visibleEntries: visibleEntries.map(getDebugEntrySummary)
          }; });
          return true;
        }

        const currentVariantSizeValue = currentVariant ? getVariantOptionValue(currentVariant, sizePosition) : '';
        const recoverableSizeValue = intendedSizeValue || currentVariantSizeValue || lastKnownSizeValue;
        const recoverableEntry = recoverableSizeValue
          ? visibleEntries.find(function(entry) {
            return entry.value === recoverableSizeValue;
          })
          : null;

        if (recoverableEntry) {
          finishFirstVariantDebug('evs:restore-recoverable', function() { return {
            selectedSizeValue: selectedSizeValue,
            currentVariantSizeValue: currentVariantSizeValue,
            lastKnownSizeValue: lastKnownSizeValue,
            intendedSizeValue: intendedSizeValue,
            recoverableEntry: getDebugEntrySummary(recoverableEntry),
            selectedFinishValue: getSelectedOptionValue(finishPosition),
            visibleEntries: visibleEntries.map(getDebugEntrySummary)
          }; });

          const recoverableInput = recoverableEntry.node.querySelector('input[type="radio"]');
          if (recoverableInput) {
            triggerSizeSelection(recoverableInput);
          }
          return false;
        }

        const fallbackEntry = visibleEntries[0];
        const eligibleEntries = getEligibleSizeEntries(visibleEntries);
        const featuredSourceEntries = eligibleEntries.length ? eligibleEntries : visibleEntries;
        const featuredEntries = getFeaturedSizeEntries(featuredSourceEntries);
        const featuredClassicEntry = featuredEntries && featuredEntries.small ? featuredEntries.small : null;
        const fallbackEntryResolved = featuredClassicEntry || fallbackEntry;
        if (!fallbackEntryResolved) return false;

        finishFirstVariantDebug('evs:fallback-first-visible', function() { return {
          selectedSizeValue: selectedSizeValue,
          currentVariantSizeValue: currentVariantSizeValue,
          lastKnownSizeValue: lastKnownSizeValue,
          intendedSizeValue: intendedSizeValue,
          selectedFinishValue: getSelectedOptionValue(finishPosition),
          fallbackEntry: getDebugEntrySummary(fallbackEntryResolved),
          visibleEntries: visibleEntries.map(getDebugEntrySummary)
        }; });

        const fallbackInput = fallbackEntryResolved.node.querySelector('input[type="radio"]');
        if (fallbackInput) {
          triggerSizeSelection(fallbackInput);
        }
        return false;
      }

      function getSizeDisplayLabelHtml(entry, featuredKey) {
        if (!entry) return '\u2014';
        if (featuredKey === 'meta-small' && isExactA4Entry(entry)) {
          return escapeHtml(
            getCurrentSizeUnitPreference() === 'in'
              ? 'A4 - 8.27 x 11.69 in'
              : 'A4 - 21 x 29.7 cm'
          );
        }
        const fallback = getFeaturedSizeDisplayLabel(entry);
        const baseLabel = (entry.node && entry.node.dataset && entry.node.dataset.displayLabel)
          ? entry.node.dataset.displayLabel
          : (entry.label || fallback || '');
        const baseText = String(baseLabel || fallback || '\u2014');
        if (isCompoundSizeLabel(baseText)) {
          const converted = getPreferredConvertedSizeLabel(entry.value || '');
          if (converted) {
            const formattedConverted = window.UMSizeDisplay && typeof window.UMSizeDisplay.format === 'function'
              ? window.UMSizeDisplay.format(converted)
              : converted;
            return escapeHtml(formattedConverted);
          }
        }
        const formattedBaseText = window.UMSizeDisplay && typeof window.UMSizeDisplay.format === 'function'
          ? window.UMSizeDisplay.format(baseText)
          : baseText;
        return escapeHtml(formattedBaseText);
      }

      function updateFeaturedSizeButtons() {
        const card = ensureFeaturedSizesCard();
        const visibleEntries = getVisibleSizeEntries();
        const eligibleEntries = getEligibleSizeEntries(visibleEntries);
        const selections = getCurrentSelections();
        const selectedFinishValue = getSelectedOptionValue(finishPosition);
        const selectedFinishLabel = getSelectedOptionLabel(finishPosition) || selectedFinishValue;
        const finishFirstMode = isFinishFirstMode();
        const featuredMultiPieceConfig = getActiveMultiPieceConfig(selectedFinishValue, selectedFinishLabel);
        const setMessageEl = card.querySelector('[data-featured-sizes-set-message]');
        if (setMessageEl) {
          const panelCount = Number(featuredMultiPieceConfig && featuredMultiPieceConfig.panelCount || 0);
          setTextIfChanged(
            setMessageEl,
            panelCount > 0 ? 'Sizes shown are for the complete ' + panelCount + '-panel artwork' : ''
          );
          setBooleanPropertyIfChanged(setMessageEl, 'hidden', panelCount <= 0);
        }

        if (restoreActiveSessionVariantSelection()) {
          return false;
        }
        restoreActiveSessionFrameColour();

        if (!ensureValidSizeSelection(visibleEntries)) {
          return false;
        }

        const selectedSizeValue = getSelectedOptionValue(sizePosition);
        const featuredSourceEntries = eligibleEntries.length ? eligibleEntries : visibleEntries;
        const metaSmallEntry = getMetaSmallSizeEntry(featuredSourceEntries);
        const standardFeaturedEntries = metaSmallEntry
          ? featuredSourceEntries.filter(function(entry) {
              return entry && entry.value !== metaSmallEntry.value;
            })
          : featuredSourceEntries;
        const featured = getFeaturedSizeEntries(standardFeaturedEntries);
        featured['meta-small'] = metaSmallEntry;
        featured.grand = null;
        const largestNonAEntry = getLargestNonASizeEntry(featuredSourceEntries) || getLargestNonASizeEntry(visibleEntries);
        if (largestNonAEntry && largestNonAEntry.value) {
          featured.gallery = metaSmallEntry && largestNonAEntry.value === metaSmallEntry.value
            ? null
            : largestNonAEntry;
          if (featured.large && featured.large.value === largestNonAEntry.value) {
            featured.large = null;
          }
        }
        if (featured.gallery && featured.gallery.value) {
          const galleryValue = featured.gallery.value;
          ['meta-small', 'small', 'medium', 'large', 'grand'].forEach(function(key) {
            if (featured[key] && featured[key].value === galleryValue) {
              featured[key] = null;
            }
          });
        }
        featuredBandSaleSizeHandles = new Set(
          ['small', 'medium']
            .map(function(key) {
              return handleize(featured[key] && featured[key].value || '');
            })
            .filter(Boolean)
        );
        card.classList.toggle('has-meta-small-size', !!featured['meta-small']);
        card.classList.toggle('has-gallery-size', !!(featured && featured.gallery));
        if (shouldAutoFramedClassicFromUrl && !hasLoggedAutoClassicGateState) {
          traceAutoClassic('gate-state', {
            hasVariantOptionInteraction: hasVariantOptionInteraction,
            hasAppliedBareUrlStatementDefault: hasAppliedBareUrlStatementDefault,
            isFinishFirstMode: isFinishFirstMode(),
            hasMissingUrlVariantParam: hasMissingUrlVariantParam,
            hasExplicitEmptyUrlVariant: hasExplicitEmptyUrlVariant
          });
          hasLoggedAutoClassicGateState = true;
        }
        if (shouldAutoFramedClassicFromUrl && !hasVariantOptionInteraction && !hasAppliedBareUrlStatementDefault && isFinishFirstMode()) {
          let classicEntry = featured && featured.small ? featured.small : null;
          hasAppliedBareUrlStatementDefault = true;
          traceAutoClassic('entry', {
            hasClassicEntry: !!classicEntry,
            classicValue: classicEntry && classicEntry.value ? classicEntry.value : '',
            selectedFinishValue: selectedFinishValue,
            hasVariantOptionInteraction: hasVariantOptionInteraction,
            isFinishFirstMode: isFinishFirstMode(),
            hasMissingUrlVariantParam: hasMissingUrlVariantParam,
            hasExplicitEmptyUrlVariant: hasExplicitEmptyUrlVariant
          });

          const classicSizeValue = classicEntry && classicEntry.value ? classicEntry.value : '';
          const targetVariant = resolveClassicAutoTargetVariant(classicSizeValue, selectedFinishValue, selections);
          if (targetVariant && applyVariantSelectionSinglePass(targetVariant)) {
            traceAutoClassic('done-single-pass', {
              variant: getDebugVariantSummary(targetVariant)
            });
            return false;
          }

          let classicInput = classicEntry && classicEntry.node
            ? classicEntry.node.querySelector('input[type="radio"]')
            : null;
          if (classicInput && !classicInput.disabled && !classicInput.checked) {
            intendedSizeValue = classicEntry.value || intendedSizeValue;
            lastKnownSizeValue = classicEntry.value || lastKnownSizeValue;
            traceAutoClassic('fallback-size-only', {
              classicSizeValue: classicEntry.value || '',
              inputValue: classicInput.value || '',
              disabled: !!classicInput.disabled,
              checked: !!classicInput.checked
            });
            triggerSizeSelection(classicInput);
            return false;
          }
          traceAutoClassic('no-op-after-entry', {
            hasClassicInput: !!classicInput,
            classicInputDisabled: !!(classicInput && classicInput.disabled),
            classicInputChecked: !!(classicInput && classicInput.checked)
          });
        }
        const featuredValueSet = new Set(
          Object.values(featured)
            .filter(Boolean)
            .map(function(entry) {
              return entry.value || '';
            })
        );
        const selectedEntry = visibleEntries.find(function(entry) {
          return entry.value === selectedSizeValue;
        }) || null;
        const selectedNeedsDedicatedButton = !!(
          selectedEntry &&
          selectedSizeValue &&
          !featuredValueSet.has(selectedSizeValue)
        );
        const expanded = card.querySelector('[data-featured-sizes-toggle]')?.getAttribute('aria-expanded') === 'true';

        const showDedicatedSelectedRow = selectedNeedsDedicatedButton && !expanded;
        const renderableButtons = Object.assign({}, featured, {
          selected: showDedicatedSelectedRow ? selectedEntry : null
        });
        let hasFeaturedBandSaleVariant = false;
        let hasSelectedFinishFeaturedBandSaleVariant = false;

        // These checks scan the complete variant dataset and are only used by
        // the featured-band sale message. Keep them entirely off the normal
        // size/finish interaction path when that sale is not active.
        if (pseudoSaleFeaturedBandActive) {
          const featuredBandMatchExcludedPositions = new Set([sizePosition, finishPosition]);
          hasFeaturedBandSaleVariant = variants.some(function(variant) {
            if (!isVariantEligible(variant) || !isFeaturedBandSalePriceEligible(variant)) return false;
            if (!variantMatchesSelections(variant, selections, featuredBandMatchExcludedPositions)) return false;
            const variantSizeHandle = handleize(getVariantOptionValue(variant, sizePosition));
            return !!variantSizeHandle && featuredBandSaleSizeHandles.has(variantSizeHandle);
          });

          const selectedFinishIsFramed = /\bfram/.test(String(selectedFinishValue || '').trim().toLowerCase());
          if (!selectedFinishIsFramed) {
            const selectedFinishFeaturedBandMatchExcludedPositions = new Set([sizePosition]);
            hasSelectedFinishFeaturedBandSaleVariant = variants.some(function(variant) {
              if (!isVariantEligible(variant) || !isFeaturedBandSalePriceEligible(variant)) return false;
              if (!variantMatchesSelections(variant, selections, selectedFinishFeaturedBandMatchExcludedPositions)) return false;
              const variantSizeHandle = handleize(getVariantOptionValue(variant, sizePosition));
              return !!variantSizeHandle && featuredBandSaleSizeHandles.has(variantSizeHandle);
            });
          }
        }

        Object.entries(renderableButtons).forEach(function(entry) {
          const key = entry[0];
          const featuredEntry = entry[1];
          const btn = card.querySelector('[data-featured-size-key="' + key + '"]');
          if (!btn) return;

          if (!featuredEntry) {
            btn.classList.toggle('is-active', false);
            btn.classList.toggle('is-hidden', true);
            setBooleanPropertyIfChanged(btn, 'disabled', true);
            setDataIfChanged(btn, 'sizeValue', '');
            setTextIfChanged(btn.querySelector('.pdp-featured-size__name'), key === 'selected' ? '' : (btn.querySelector('.pdp-featured-size__name')?.textContent || ''));
            setTextIfChanged(btn.querySelector('[data-featured-size-label]'), '\u2014');
            setHtmlIfChanged(btn.querySelector('[data-featured-size-price]'), '&mdash;');
            return;
          }

          btn.classList.toggle('is-hidden', false);
          setBooleanPropertyIfChanged(btn, 'disabled', false);
          setDataIfChanged(btn, 'sizeValue', featuredEntry.value || '');
          setHtmlIfChanged(btn.querySelector('[data-featured-size-label]'), getSizeDisplayLabelHtml(featuredEntry, key));
          const displayVariant = finishFirstMode && selectedFinishValue
            ? findVariantFor(featuredEntry.value || '', selectedFinishValue, selections)
            : featuredEntry.baseVariant;
          const isSelectedSize = featuredEntry.value === selectedSizeValue;
          const priceHtml = formatFeaturedSizePrice(displayVariant, !finishFirstMode, key, isSelectedSize);
          setHtmlIfChanged(btn.querySelector('[data-featured-size-price]'), priceHtml);
          btn.classList.toggle('is-active', featuredEntry.value === selectedSizeValue);
        });

        const featuredSubtitle = card.querySelector('[data-featured-subtitle-featured]');
        const saleMessageEl = card.querySelector('[data-featured-sizes-sale-message]');
        if (saleMessageEl) {
          const selectedOfferVariant = currentVariant || getCurrentVariantFromDom();
          const googleOffer = window.UMGoogleDiscount &&
            window.UMGoogleDiscount.resolveVariantPrice(selectedOfferVariant).googleDiscountActive;
          const exclusiveLabel = escapeHtml((theme.strings && theme.strings.exclusiveOfferLabel) || 'Exclusive offer');
          if (googleOffer) {
            setFeaturedSaleMessage(saleMessageEl, {html: exclusiveLabel, exclusive: true, hidden: false, ineligible: false});
          } else if (pseudoSaleFeaturedBandActive) {
            const desktopSaleMessage = formatFeaturedBandSaleMessage();
            const mobileSaleMessage = formatFeaturedBandSaleMessage(
              localizedPdpLabels.featuredSizesLimitedSaleMobile ||
              'Ends Tonight \u2014 [percent]% off [classic] & [statement]'
            );
            setFeaturedSaleMessage(saleMessageEl, {
              html: hasFeaturedBandSaleVariant
                ? '<span class="pdp-featured-sizes__sale-message-desktop">' + escapeHtml(desktopSaleMessage) + '</span>' +
                  '<span class="pdp-featured-sizes__sale-message-mobile">' + escapeHtml(mobileSaleMessage) + '</span>'
                : '',
              exclusive: false,
              hidden: !hasFeaturedBandSaleVariant,
              ineligible: hasFeaturedBandSaleVariant && !hasSelectedFinishFeaturedBandSaleVariant
            });
          } else {
            const saleMessage = formatFeaturedSizesSaleMessage();
            const compactSaleMessage = formatFeaturedSizesSaleMessage(pricingConfig.pseudoSaleShortName);
            setFeaturedSaleMessage(saleMessageEl, {
              html: saleMessage
                ? '<span class="pdp-featured-sizes__sale-message-legacy-full">' + escapeHtml(saleMessage) + '</span>' +
                  '<span class="pdp-featured-sizes__sale-message-legacy-short">' + escapeHtml(compactSaleMessage || saleMessage) + '</span>'
                : '',
              exclusive: false, hidden: !saleMessage, ineligible: false
            });
          }
        }
        const selectedSubtitle = card.querySelector('[data-featured-subtitle-selected]');
        const recommendedSubtitle = card.querySelector('[data-featured-subtitle-recommended]');
        const allSizesLabel = card.querySelector('[data-featured-all-label]');
        const galleryMerch = card.querySelector('[data-featured-gallery-merch]');
        const featuredSizeHelp = card.querySelector('[data-featured-size-help]');
        const hasRecommendedButtons = ['meta-small', 'small', 'medium', 'grand', 'large', 'gallery'].some(function(key) {
          const btn = card.querySelector('[data-featured-size-key="' + key + '"]');
          return !!(btn && !btn.classList.contains('is-hidden'));
        });
        const galleryButton = card.querySelector('[data-featured-size-key="gallery"]');
        const galleryServiceEligible = isGalleryServiceSizeEligible(featured.gallery);
        if (galleryButton) {
          setTextIfChanged(
            galleryButton.querySelector('.pdp-featured-size__name'),
            galleryServiceEligible ? localizedPdpLabels.featuredSizesGallery : localizedPdpLabels.featuredSizesGrand
          );
        }
        const showGalleryMerch = !!(
          galleryButton &&
          !galleryButton.classList.contains('is-hidden') &&
          galleryButton.classList.contains('is-active') &&
          galleryServiceEligible
        );
        setBooleanPropertyIfChanged(featuredSubtitle, 'hidden', !(expanded && hasRecommendedButtons));
        setBooleanPropertyIfChanged(selectedSubtitle, 'hidden', !showDedicatedSelectedRow);
        setBooleanPropertyIfChanged(recommendedSubtitle, 'hidden', !(showDedicatedSelectedRow && hasRecommendedButtons));
        setBooleanPropertyIfChanged(allSizesLabel, 'hidden', !expanded);
        if (galleryMerch) {
          addGalleryContactPanel(galleryMerch);
          galleryMerch.classList.toggle('is-visible', showGalleryMerch);
          galleryMerch.setAttribute('aria-hidden', showGalleryMerch ? 'false' : 'true');
        }
        if (!showGalleryMerch) closeGalleryContactPanel(galleryMerch);
        card.classList.toggle('is-gallery-merch-visible', showGalleryMerch);
        if (featuredSizeHelp) {
          featuredSizeHelp.classList.toggle('is-suppressed', showGalleryMerch);
          if (showGalleryMerch) closeSizeConciergePanel(featuredSizeHelp);
        }

        withSizeObserverPaused(function() {
          Array.from(sizeFieldset.querySelectorAll('.variant-input[data-value]')).forEach(function(node) {
            const value = node.dataset.value || '';
            const isVisible = visibleEntries.some(function(entry) {
              return entry.value === value;
            });
            const isFeatured = featuredValueSet.has(value);
            const shouldHide = isCamouflageHiddenSizeValue(value) || !isVisible || (expanded && isFeatured);
            if (node.classList.contains('pdp-size-option-hidden') !== shouldHide) {
              node.classList.toggle('pdp-size-option-hidden', shouldHide);
            }
            if (!shouldHide) {
              if (
                node.classList.contains('hide-oos-disable') ||
                node.classList.contains('hide-oos-disabled') ||
                node.classList.contains('camouflage-marked-unavailable')
              ) {
                node.classList.remove('hide-oos-disable', 'hide-oos-disabled', 'camouflage-marked-unavailable');
              }
              if (node.classList.contains('disabled')) {
                node.classList.remove('disabled');
              }
              setBooleanPropertyIfChanged(node, 'hidden', false);
              setAttributeIfChanged(node, 'aria-hidden', 'false');
              setStylePropertyIfChanged(node, 'display', '');
              const input = node.querySelector('input[type="radio"]');
              if (input) {
                setBooleanPropertyIfChanged(input, 'disabled', false);
                if (input.hasAttribute('disabled')) {
                  input.removeAttribute('disabled');
                }
              }
              const label = node.querySelector('label');
              if (label) {
                if (
                  label.classList.contains('hide-oos-disable') ||
                  label.classList.contains('hide-oos-disabled') ||
                  label.classList.contains('camouflage-marked-unavailable')
                ) {
                  label.classList.remove('hide-oos-disable', 'hide-oos-disabled', 'camouflage-marked-unavailable');
                }
                setBooleanPropertyIfChanged(label, 'hidden', false);
                if (label.hasAttribute('hidden')) {
                  label.removeAttribute('hidden');
                }
                setStylePropertyIfChanged(label, 'display', '');
              }
            }
          });
        });

        syncExpandedSizeLayout(expanded, featuredValueSet, visibleEntries);
        if (card.classList.contains('is-expanded') !== expanded) {
          card.classList.toggle('is-expanded', expanded);
        }

        const toggle = card.querySelector('[data-featured-sizes-toggle]');
        if (toggle) {
          const toggleSubtitle = card.querySelector('[data-featured-sizes-toggle-subtitle]');
          const hasRealExtraSizes = Array.from(sizeFieldset.querySelectorAll('.variant-input[data-value]')).some(function(node) {
            const value = node.dataset.value || '';
            if (!value) return false;
            if (featuredValueSet.has(value)) return false;
            if (isCamouflageHiddenSizeValue(value)) return false;
            const isVisibleForCurrentSelection = visibleEntries.some(function(entry) {
              return entry.value === value;
            });
            if (!isVisibleForCurrentSelection) return false;
            const labelText = (getCurrentNodeLabel(node) || value).trim();
            return true;
          });
          const shouldHideToggle = !hasRealExtraSizes;
          setBooleanPropertyIfChanged(toggle, shouldHideToggle);
          setStylePropertyIfChanged(toggle, 'display', shouldHideToggle ? 'none' : '');
          setBooleanPropertyIfChanged(toggleSubtitle, shouldHideToggle || expanded);
          setStylePropertyIfChanged(toggleSubtitle, 'display', shouldHideToggle || expanded ? 'none' : '');
          setBooleanPropertyIfChanged(featuredSizeHelp, shouldHideToggle || expanded);
          setStylePropertyIfChanged(featuredSizeHelp, 'display', shouldHideToggle || expanded ? 'none' : '');
          const controls = toggle.closest('.pdp-featured-sizes__controls');
          if (controls) {
            setStylePropertyIfChanged(controls, 'display', shouldHideToggle ? 'none' : '');
          }
          const toggleLabel = getSizeToggleLabel(expanded, visibleEntries);
          setTextIfChanged(toggle, toggleLabel);
        }

        logSizeLabelDebug('updateFeaturedSizeButtons', visibleEntries, renderableButtons);

        return true;
      }

      function bindFeaturedSizeEvents() {
        const card = ensureFeaturedSizesCard();
        if (card.dataset.bound === 'true') return;
        card.dataset.bound = 'true';

        card.addEventListener('click', function(event) {
          if (event.target.closest('[data-contact-advice-panel]')) {
            return;
          }

          const sizeButton = event.target.closest('[data-featured-size-key]');
          if (sizeButton) {
            event.preventDefault();
            if (sizeButton.disabled) return;
            const value = sizeButton.dataset.sizeValue || '';
            const targetInput = sizeFieldset.querySelector('.variant-input[data-value="' + CSS.escape(value) + '"] input[type="radio"]');
            if (event.isTrusted) {
              rememberActiveSessionSelection('size', targetInput ? targetInput.value : value);
            }
            triggerSizeSelection(targetInput, { userInitiated: true });
            document.dispatchEvent(new CustomEvent('um:visualiser-size-target', {
              detail: {
                target: sizeButton,
                preserveWrapper: true,
                userInitiated: true
              }
            }));
            return;
          }

          const toggle = event.target.closest('[data-featured-sizes-toggle]');
          if (!toggle) return;
          event.preventDefault();

          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          updateFeaturedSizeButtons();
        });
      }

      function bindFinishCardEvents() {
        if (!finishFieldset || finishFieldset.dataset.pdpFinishCardsBound === 'true') return;
        finishFieldset.dataset.pdpFinishCardsBound = 'true';

        finishFieldset.addEventListener('click', function(event) {
          const option = event.target.closest('.variant-input[data-index="option' + finishPosition + '"]');
          if (!option || !finishFieldset.contains(option)) return;

          const input = option.querySelector('input[type="radio"]');
          if (!input || input.disabled) return;

          if (event.isTrusted) {
            rememberActiveSessionSelection('finish', input.value);
          }
          if (event.target === input) return;
          event.preventDefault();
          triggerSizeSelection(input, { userInitiated: true });
        });
      }

      function updateSizeLabels() {
        perfCounters.updateSizeLabelsCalls += 1;
        withSizeObserverPaused(function() {
          const selections = getCurrentSelections();
          const selectedFinishValue = getSelectedOptionValue(finishPosition);
          const selectedSizeValue = getSelectedOptionValue(sizePosition);
          const finishFirstMode = isFinishFirstMode();
          document.querySelectorAll('.variant-input[data-index="option' + sizePosition + '"]').forEach(function(node) {
            const target = node.querySelector('[data-pdp-size-price]');
            if (!target) return;

            const sizeValue = node.dataset.value || '';
            const baseVariant = findBaseVariant(sizeValue, selections);
            const displayVariant = finishFirstMode && selectedFinishValue
              ? findVariantFor(sizeValue, selectedFinishValue, selections)
              : baseVariant;
            const isSelectedSize = sizeValue === selectedSizeValue;
            const priceHtml = isNodeSuppressed(node) || !isVariantEligible(displayVariant)
              ? ''
              : formatFeaturedSizePrice(displayVariant, !finishFirstMode, '', isSelectedSize);
            setHtmlIfChanged(target, priceHtml);
          });
        });
      }

      function updateFinishLabels(selectedSizeValue) {
        perfCounters.updateFinishLabelsCalls += 1;
        if (!finishFieldset) return;

        const selections = getCurrentSelections();
        const baseVariant = findBaseVariant(selectedSizeValue, selections);
        const finishFirstMode = isFinishFirstMode();

        function ensureFinishPriceNode(optionNode) {
          const label = optionNode.querySelector('.variant__button-label');
          if (!label) return null;
          let priceNode = label.querySelector('[data-pdp-finish-price-render]');
          if (!priceNode) {
            priceNode = document.createElement('span');
            priceNode.className = 'variant__button-price';
            priceNode.setAttribute('data-pdp-finish-price-render', '');
            label.appendChild(priceNode);
          }
          return priceNode;
        }

        function ensureFinishMerchNode(optionNode) {
          const label = optionNode.querySelector('.variant__button-label');
          if (!label) return null;
          let merchNode = label.querySelector('[data-pdp-finish-merch-copy]');
          if (!merchNode) {
            merchNode = document.createElement('span');
            merchNode.className = 'pdp-pricing-experiment--finish-merch-copy';
            merchNode.setAttribute('data-pdp-finish-merch-copy', '');
            label.appendChild(merchNode);
          }
          return merchNode;
        }

        function getFinishDisplayLabel(rawFinishValue, fallbackLabel) {
          const finishValue = String(rawFinishValue || '').trim().toLowerCase();
          if (
            (finishValue === 'framed canvas' || finishValue === 'framed canvas map') &&
            window.__PDP_STRETCHED_CANVAS__ &&
            window.__PDP_STRETCHED_CANVAS__.preferred
          ) {
            return window.__PDP_STRETCHED_CANVAS__.label || 'Stretched canvas';
          }
          if (finishValue === 'map') return localizedMapPrintLabel;
          if (finishValue === 'art print') return localizedArtPrintLabel;
          if (finishValue === 'framed map') return localizedFramedMapLabel;
          if (finishValue === 'framed art print') return localizedFramedArtPrintLabel;
          if (finishValue === 'framed canvas' || finishValue === 'framed canvas map') return localizedFramedCanvasLabel;
          if (finishValue === 'push pin map') return localizedPushPinMapLabel;
          if (finishValue === 'framed push pin map') return localizedFramedPushPinMapLabel;
          return String(fallbackLabel || rawFinishValue || '').trim();
        }

        function getFinishMerchCopy(rawFinishValue, fallbackLabel) {
          const finishValue = String(rawFinishValue || '').trim().toLowerCase();
          const finishLabel = String(fallbackLabel || '').trim().toLowerCase();
          const finishText = (finishValue + ' ' + finishLabel).trim();

          if (finishValue === 'framed map - 3 pieces' || finishLabel === 'framed map - 3 pieces') {
            return localizedPdpLabels.finishMerchFramedSet;
          }
          if (finishValue === 'map - 3 pieces' || finishLabel === 'map - 3 pieces') {
            return localizedPdpLabels.finishMerchPaperSet;
          }

          const isPieceSet = /\b(piece|pieces)\b/.test(finishText);
          const isMapSet = /\bmaps?\b/.test(finishText);
          const isFramedSet = /\bfram/.test(finishText);

          if (isPieceSet && isMapSet) {
            if (isFramedSet) {
              return localizedPdpLabels.finishMerchFramedSet;
            }
            return localizedPdpLabels.finishMerchPaperSet;
          }
          if (finishValue === 'map' || finishValue === 'art print') {
            return localizedPdpLabels.finishMerchPaper;
          }
          if (finishValue === 'push pin map') {
            return localizedPdpLabels.finishMerchPushPin;
          }
          if (finishValue === 'framed map' || finishValue === 'framed art print') {
            return localizedPdpLabels.finishMerchFramed;
          }
          if (finishValue === 'framed push pin map') {
            return localizedPdpLabels.finishMerchFramedPushPin;
          }
          if (finishValue === 'framed canvas' || finishValue === 'framed canvas map') {
            return localizedPdpLabels.finishMerchCanvas;
          }
          return '';
        }

        finishFieldset.querySelectorAll('.variant-input[data-index="option' + finishPosition + '"]').forEach(function(node) {
          const finishValue = (node.dataset.value || '').trim() || ((node.querySelector('input[type="radio"]') && node.querySelector('input[type="radio"]').value) || '').trim();
          const finishLabelTextNode = node.querySelector('.variant__button-label-text');
          if (finishLabelTextNode) {
            const fallbackLabel =
              node.dataset.displayLabel ||
              ((node.querySelector('input[type="radio"]') && node.querySelector('input[type="radio"]').dataset && node.querySelector('input[type="radio"]').dataset.displayLabel) || '') ||
              finishLabelTextNode.textContent ||
              finishValue;
            setTextIfChanged(finishLabelTextNode, getFinishDisplayLabel(finishValue, fallbackLabel));
          }
          const finishPriceNode = ensureFinishPriceNode(node);
          const finishMerchNode = ensureFinishMerchNode(node);
          const merchCopy = getFinishMerchCopy(finishValue, finishLabelTextNode ? finishLabelTextNode.textContent : '');
          setHtmlIfChanged(finishMerchNode, merchCopy);
          node.classList.toggle('pdp-finish-no-merch-copy', !merchCopy);
          if (isNodeSuppressed(node) || (!finishFirstMode && !baseVariant)) {
            setDataIfChanged(node, 'pdpFinishPrice', '');
            setDataIfChanged(node, 'pdpFinishPrefix', '');
            setHtmlIfChanged(finishPriceNode, '');
            return;
          }

          const matchingVariant = finishFirstMode
            ? findLowestVariantForFinish(finishValue, selections)
            : (isBaseFinish(finishValue)
              ? baseVariant
              : findVariantFor(selectedSizeValue, finishValue, selections));
          if (!isVariantEligible(matchingVariant)) {
            setDataIfChanged(node, 'pdpFinishPrice', '');
            setDataIfChanged(node, 'pdpFinishPrefix', '');
            setHtmlIfChanged(finishPriceNode, '');
            return;
          }

          const moneyHtml = formatMoney(matchingVariant.price);
          const moneyText = moneyHtml.replace(/<[^>]*>/g, '').trim();
          setDataIfChanged(node, 'pdpFinishPrice', moneyText);
          setDataIfChanged(node, 'pdpFinishPrefix', finishFirstMode ? localizedSummaryLabels.from : '');
          if (finishFirstMode) {
            setHtmlIfChanged(
              finishPriceNode,
              '<span class="variant__button-price-prefix">' + escapeHtml(localizedSummaryLabels.from) + '</span>' + moneyHtml
            );
          } else {
            setHtmlIfChanged(finishPriceNode, '');
          }
        });
      }

      function syncSharedTotals(displayTotal, variant, compareAtPriceOverride) {
        state.pending = false;
        if (window.UMCPurchaseReadiness) window.UMCPurchaseReadiness.refresh();
        const nextVariantId = variant?.id || null;
        const nextVariantPrice = variant?.price || 0;
        const nextCompareAtPrice = compareAtPriceOverride || variant?.compare_at_price || 0;
        const unchanged =
          state.displayTotal === displayTotal &&
          state.variantId === nextVariantId &&
          state.variantPrice === nextVariantPrice &&
          state.compareAtPrice === nextCompareAtPrice;
        if (unchanged) return;

        state.displayTotal = displayTotal;
        state.variant = variant || null;
        state.variantId = nextVariantId;
        state.variantPrice = nextVariantPrice;
        state.compareAtPrice = nextCompareAtPrice;
        perfCounters.syncSharedTotalsDispatches += 1;

        document.dispatchEvent(new CustomEvent('pdp:pricing-updated', {
          detail: {
            experimentActive: true,
            displayTotal: displayTotal,
            variant: variant,
            compareAtPrice: state.compareAtPrice
          }
        }));
      }

      function sanitizePdpv3dFinishButtonLabels() {
        const inFinishFirstPricingDifferential =
          htmlEl.classList.contains(triggerClass) &&
          (isFinishFirstMode() || root.classList.contains('pdp-pricing-experiment--finish-first-active'));
        if (!inFinishFirstPricingDifferential) return;

        const stripFromAndPrice = function(text) {
          return String(text || '')
            .replace(/\s*from\s*[$£€]\s?[\d,]+(?:\.\d{2})?\s*$/i, '')
            .replace(/\s*[$£€]\s?[\d,]+(?:\.\d{2})?\s*$/i, '')
            .replace(/\s+/g, ' ')
            .trim();
        };

        document.querySelectorAll('.pdpv3d-finish-btn').forEach(function(button) {
          const inputId = button.getAttribute('data-finish-input-id');
          if (inputId) {
            const linkedInput = document.getElementById(inputId);
            const linkedLabel = linkedInput && getFinishDisplayLabel(linkedInput.value, linkedInput.dataset.displayLabel || linkedInput.value || '');
            if (linkedLabel) {
              if (button.textContent !== linkedLabel) {
                button.textContent = linkedLabel;
              }
              return;
            }
          }

          const currentText = button.textContent || '';
          const cleaned = stripFromAndPrice(currentText);
          if (cleaned && cleaned !== currentText) {
            button.textContent = cleaned;
          }
        });
      }

      function isFrameSlideEligibleBlock(block) {
        if (!block) return false;
        if (block.hidden) return false;
        if (block.getAttribute('aria-hidden') === 'true') return false;
        const style = window.getComputedStyle(block);
        if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
        return true;
      }

      function syncFadeBlockState(block, shouldOpen, dataAttrName) {
        if (!block) return;
        if (dataAttrName) block.setAttribute(dataAttrName, '');
        const FADE_MS = 190;
        const clearCloseTimer = function() {
          if (block.__pdpFadeCloseRaf) {
            window.cancelAnimationFrame(block.__pdpFadeCloseRaf);
            block.__pdpFadeCloseRaf = null;
          }
          if (block.__pdpFadeCloseTimer) {
            window.clearTimeout(block.__pdpFadeCloseTimer);
            block.__pdpFadeCloseTimer = null;
          }
        };

        // Canvas style owns hiding these controls and restoring their prior
        // display. Cancel an old fade that could otherwise clear its hiding.
        if (block.classList.contains('pdp-stretched-canvas-frame-hidden')) {
          clearCloseTimer();
          return;
        }

        const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          clearCloseTimer();
          block.classList.remove('is-closing');
          block.style.display = '';
          block.style.visibility = '';
          block.classList.toggle('is-open', !!shouldOpen && isFrameSlideEligibleBlock(block));
          return;
        }

        if (!shouldOpen) {
          if (block.classList.contains('is-open')) {
            clearCloseTimer();
            const computedDisplay = window.getComputedStyle(block).display;
            if (computedDisplay && computedDisplay !== 'none') {
              block.style.display = computedDisplay;
            }
            block.style.visibility = 'visible';
            block.classList.add('is-closing');
            block.__pdpFadeCloseRaf = window.requestAnimationFrame(function() {
              block.__pdpFadeCloseRaf = null;
              block.classList.remove('is-open');
            });
            block.__pdpFadeCloseTimer = window.setTimeout(function() {
              block.classList.remove('is-closing');
              block.style.display = '';
              block.style.visibility = '';
              block.__pdpFadeCloseTimer = null;
            }, FADE_MS);
            return;
          }
          block.classList.remove('is-open');
          block.classList.remove('is-closing');
          block.style.display = '';
          block.style.visibility = '';
          return;
        }

        clearCloseTimer();
        block.classList.remove('is-closing');
        block.style.display = '';
        block.style.visibility = '';

        if (!isFrameSlideEligibleBlock(block)) return;
        if (block.classList.contains('is-open')) return;

        block.classList.add('is-open');
      }

      function syncFrameColourSlideState(isFramedFinishSelected) {
        const block = searchRoot.querySelector('[data-pdp-pricing-finish-first-finish-section] > .option_frame_colour_new');
        syncFadeBlockState(block, !!isFramedFinishSelected, 'data-pdp-frame-slide');
      }

      function syncHangerFadeState() {
      }

      function syncFinishDependentFadeStates(selectedFinishValue) {
        const isFramedFinishSelected = /\bfram/.test(String(selectedFinishValue || '').trim().toLowerCase());
        syncFrameColourSlideState(isFramedFinishSelected);
        syncHangerFadeState();
      }

      async function renderPricing(eventVariant) {
        const renderRevision = pricingRenderRevision;
        lastVariantConfirmation = null;
        // Visibility can change after every option interaction. Cache it only
        // for this render so repeated eligibility passes do not repeatedly
        // force style calculation for the same option and label.
        visibilityCache = new WeakMap();
        perfCounters.renderPricingCalls += 1;
        const stableEventVariant = getLockedVariantOverride(eventVariant);
        currentVariant = (!hasVariantOptionInteraction && initialUrlVariant)
          ? initialUrlVariant
          : (stableEventVariant || getCurrentVariantFromDom());
        if (!currentVariant) return;
        if (!hasVariantOptionInteraction && !hasFinishOptionInteraction) {
          syncFinishSelectionUiFromVariant(currentVariant);
        }
        syncFinishSelectedClassFromInputs();
        ensureAgedToneProxy();

        if (updateFeaturedSizeButtons() === false) {
          return;
        }

        const selections = getCurrentSelections();
        const selectedSizeValue = getSelectedOptionValue(sizePosition);
        const selectedFinishValue = getSelectedOptionValue(finishPosition);
        const selectedFinishLabel = getSelectedOptionLabel(finishPosition) || selectedFinishValue;
        syncFinishDependentFadeStates(selectedFinishValue);
        const baseVariant = findBaseVariant(selectedSizeValue, selections);

        // The combined summary prices the selected variant directly. Some
        // framed sizes have no purchasable unframed counterpart (including
        // legacy sizes with slightly different metric labels). That must not
        // leave an otherwise valid selection permanently pending.
        if (!isVariantEligible(currentVariant) ||
            (!combineMainProductSummaryLine && !isVariantEligible(baseVariant))) {
          return;
        }

        const basePrice = isVariantEligible(baseVariant) ? baseVariant.price : currentVariant.price;
        const frameDelta = Math.max(0, currentVariant.price - basePrice);
        const addonSelections = await getAddonSelections();
        const limitedEditionItem = getLimitedEditionAddonItem(currentVariant);
        if (limitedEditionItem) {
          addonSelections.items.push(limitedEditionItem);
        }
        state.lastAddonSelections = addonSelections.items.slice();
        const labelPriceMap = await buildToggleCardLabelPrices(currentVariant);
        state.labelAddonPricesByHandle = labelPriceMap;
        renderToggleCardLabelPrices();
        const canUseAllInTotal = !addonSelections.hasUnmapped;
        const addonsTotal = canUseAllInTotal
          ? addonSelections.items.reduce(function(sum, item) {
              return sum + item.price;
            }, 0)
          : 0;
        const compareAtBase =
          currentVariant.compare_at_price > currentVariant.price
            ? currentVariant.compare_at_price
            : currentVariant.price;
        const addonsCompareAtTotal = canUseAllInTotal
          ? addonSelections.items.reduce(function(sum, item) {
              const compareAt = item.compareAtPrice && item.compareAtPrice > item.price
                ? item.compareAtPrice
                : item.price;
              return sum + compareAt;
            }, 0)
          : 0;
        const selectedPseudoSaleActive = pseudoSaleActive || isSelectedFeaturedBandSaleVariant(currentVariant);
        // Limited Edition replaces the main product at checkout, so the sale
        // applies to that complete replacement price. Other add-ons stay separate.
        const limitedEditionProductUplift = canUseAllInTotal && limitedEditionItem ? limitedEditionItem.price : 0;
        const productUnitPrice = currentVariant.price + limitedEditionProductUplift;
        const productPrice = selectedPseudoSaleActive
          ? calculatePseudoSalePrice(productUnitPrice)
          : productUnitPrice;
        // Limited Edition's replacement price already accounts for compare-at.
        const productComparePrice = selectedPseudoSaleActive || limitedEditionItem ? productUnitPrice : compareAtBase;
        // A Google offer for the original variant cannot price its LE replacement.
        const productPricing = window.UMGoogleDiscount && !limitedEditionProductUplift
          ? window.UMGoogleDiscount.resolveVariantPrice(currentVariant, productPrice, productComparePrice)
          : { price: productPrice, comparePrice: productComparePrice };
        const displayTotal = productPricing.price + addonsTotal - limitedEditionProductUplift;
        const displayCompareAtTotal = productPricing.comparePrice +
          (selectedPseudoSaleActive ? addonsTotal : addonsCompareAtTotal) - limitedEditionProductUplift;

        updateSizeLabels();
        const selectedSizeLabel = getSelectedOptionLabel(sizePosition) || selectedSizeValue;
        updateFinishLabels(selectedSizeValue);

        const mainPriceIsOnSale = displayCompareAtTotal > displayTotal;
        setHtmlIfChanged(mainPriceEl, formatMoney(displayTotal));
        mainPriceEl.classList.toggle('on-sale', mainPriceIsOnSale);
        if (mainRegularPriceA11yEl) {
          mainRegularPriceA11yEl.setAttribute('aria-hidden', mainPriceIsOnSale ? 'false' : 'true');
        }
        const salePriceA11yEl = root.querySelector('[data-compare-price-a11y]');
        if (salePriceA11yEl) {
          salePriceA11yEl.setAttribute('aria-hidden', mainPriceIsOnSale ? 'false' : 'true');
        }
        if (mainComparePriceEl && mainComparePriceWrapEl) {
          const compareAtToShow = displayCompareAtTotal;
          const livePrice = displayTotal;

          if (compareAtToShow && compareAtToShow > livePrice) {
            setHtmlIfChanged(mainComparePriceEl, formatMoney(compareAtToShow));
            mainComparePriceWrapEl.classList.remove('hide');
          } else {
            setHtmlIfChanged(mainComparePriceEl, '');
            mainComparePriceWrapEl.classList.add('hide');
          }
        }
        if (pseudoSaleSavingsEl && pseudoSaleSavingsAmountEl && pseudoSaleActive) {
          const mainProductSaving = Math.max(0, productPricing.comparePrice - productPricing.price);
          setHtmlIfChanged(pseudoSaleSavingsAmountEl, mainProductSaving > 0 ? formatSavingsLabel(mainProductSaving) : '');
          pseudoSaleSavingsEl.classList.toggle('hide', mainProductSaving <= 0);
        }
        if (window.UMGoogleDiscount && typeof window.UMGoogleDiscount.syncOfferBadge === 'function') {
          window.UMGoogleDiscount.syncOfferBadge(root, productPricing);
        }
        scheduleMainPriceBadgeLayout();
        htmlEl.classList.remove('pdp-pricing-auto-default-pending');

        const groupedAddons = splitAddonGroups(canUseAllInTotal ? addonSelections.items : []);

        const selectedFinishIsBase =
          isBaseFinish(selectedFinishValue) ||
          handleize(selectedFinishValue) === 'map' ||
          handleize(selectedFinishValue) === 'push-pin-map';
        const frameColourItem = groupedAddons.finish.find(function(item) {
          return isFrameColourHandle(item.propertyHandle) && !!item.selectedValueLabel;
        }) || null;
        const rawFrameColourLabel =
          (frameColourItem && frameColourItem.selectedValueLabel) ||
          normalizeSelectionLabel(getSelectedFrameColourLabelFromDom());
        const frameColourLabel = getLocalizedFrameColourLabel(rawFrameColourLabel);
        const stretchedCanvasActive = !!(window.__PDP_STRETCHED_CANVAS__ && window.__PDP_STRETCHED_CANVAS__.active) ||
          Array.from(searchRoot.querySelectorAll('input[name="properties[Canvas style]"], input[name="properties[Canvas Finish]"]')).some(function(input) {
            return !input.disabled && /^(stretched canvas|stretched)$/i.test(input.value.trim());
          });
        const stretchedCanvasLabel = localizedSummaryLabels.readyToHang || 'Ready to hang';
        const hangerLineItem = groupedAddons.finish.find(function(item) {
          return isHangerPropertyHandle(item.propertyHandle) && hasRenderableLineItem(item);
        }) || null;
        const hangerColourLabel = normalizeSelectionLabel(getSelectedHangerColourLabelFromDom());
        const selectedFinishUsesFrameColour = finishNeedsFrameColourBlock() && !stretchedCanvasActive;
        const selectedFinishIsCanvas = /canvas/i.test(String(selectedFinishValue || ''));
        const frameTypeLabel = selectedFinishIsCanvas
          ? localizedSummaryLabels.floatingFrame
          : localizedSummaryLabels.frame;
        const framedFinishDescription = selectedFinishUsesFrameColour && frameColourLabel
          ? formatLocalizedFrameColour(frameColourLabel, frameTypeLabel)
          : '';
        const overallFramedSize = selectedFinishUsesFrameColour
          ? formatOverallFramedSize(
              [selectedSizeLabel, selectedSizeValue].filter(Boolean).join(' '),
              getCurrentSizeUnitPreference()
            )
          : '';

        const promotedBaseNoun = stretchedCanvasActive
          ? (localizedSummaryLabels.stretchedCanvas || 'Stretched canvas')
          : combineMainProductSummaryLine
          ? resolveCombinedMainProductNoun(summaryBaseNoun, selectedFinishValue, selectedFinishLabel)
          : resolvePromotedBaseNoun(summaryBaseNoun, selectedFinishValue, selectedFinishLabel);
        const multiPieceFinishText = String(selectedFinishValue || '') + ' ' + String(selectedFinishLabel || '');
        const multiPieceSummaryConfig = getActiveMultiPieceConfig(selectedFinishValue, selectedFinishLabel);
        if (multiPieceSummaryConfig) {
          root.dataset.pdpSummaryLayout = 'multi-piece';
          if (summaryCardEl) summaryCardEl.dataset.pdpSummaryLayout = 'multi-piece';
          if (summaryTitleEl) summaryTitleEl.textContent = multiPieceSummaryConfig.summaryTitle;
        } else {
          delete root.dataset.pdpSummaryLayout;
          if (summaryCardEl) delete summaryCardEl.dataset.pdpSummaryLayout;
          if (summaryTitleEl) summaryTitleEl.textContent = defaultSummaryTitle;
        }
        const multiPieceIsFramed = !!multiPieceSummaryConfig && /\bfram/i.test(multiPieceFinishText);
        const multiPieceSizeRaw = multiPieceSummaryConfig
          ? String(selectedSizeLabel || selectedSizeValue || '').trim()
          : '';
        const multiPieceSize = window.UMSizeDisplay && typeof window.UMSizeDisplay.format === 'function'
          ? window.UMSizeDisplay.format(multiPieceSizeRaw)
          : multiPieceSizeRaw;
        const multiPiecePanelDescription = multiPieceSummaryConfig
          ? (multiPieceSummaryConfig.panelDescription ||
            (multiPieceSummaryConfig.pieceCountLabel +
              (multiPieceIsFramed
                ? ' coordinated framed panels'
                : ' coordinated panels \u00b7 Ready to frame')))
          : '';
        if (hasSummaryUi && baseLabelEl) {
          var combinedBaseLabel;
          if (multiPieceSummaryConfig) {
            combinedBaseLabel =
              '<span class="pdp-pricing-summary__multi-piece-title">' + escapeHtml(multiPieceSummaryConfig.productTitle) + '</span>';
          } else {
            combinedBaseLabel = formatSummaryBaseLabel(
              promotedBaseNoun,
              selectedSizeLabel,
              selectedSizeValue,
              selectedFinishValue,
              selectedFinishLabel
            );
          }
          baseLabelEl.innerHTML = combinedBaseLabel;
        }
        if (hasSummaryUi && baseValueEl) {
          baseValueEl.innerHTML = formatMoney(combineMainProductSummaryLine ? currentVariant.price : basePrice);
        }
        if (hasSummaryUi && designRowEl) {
          const preview = searchRoot.querySelector('[data-modern-map-preview], .pdp-mapbox-picker--modern-colours');
          const colour = preview?.querySelector('input[name="properties[Map Colour]"]:checked')?.value || '';
          const layout = preview?.querySelector('select[name="properties[Map Style]"]')?.value || '';
          designRowEl.querySelector('[data-pdp-summary-colour-value]').textContent = colour.trim();
          designRowEl.querySelector('[data-pdp-summary-layout-value]').textContent = layout.trim();
          designRowEl.querySelector('[data-pdp-summary-colour-property]').hidden = !colour.trim();
          designRowEl.querySelector('[data-pdp-summary-layout-property]').hidden = !layout.trim();
          designRowEl.hidden = !colour.trim() && !layout.trim();
        }
        if (hasSummaryUi && variantArtworkRowEl && variantArtworkValueEl) {
          const configuredVariantArtworkPosition = parseInt(
            variantArtworkRowEl.dataset.pdpSummaryVariantArtworkPosition || '0',
            10
          );
          const variantArtworkPosition = configuredVariantArtworkPosition || optionPositions.find(function(position) {
            return position !== sizePosition && position !== finishPosition;
          }) || 0;
          const variantArtworkValue = variantArtworkPosition
            ? (getSelectedOptionLabel(variantArtworkPosition) ||
              getSelectedOptionValue(variantArtworkPosition) ||
              getVariantOptionValue(currentVariant, variantArtworkPosition))
            : '';
          variantArtworkRowEl.hidden = !variantArtworkValue;
          variantArtworkValueEl.textContent = variantArtworkValue || '';
        }
        if (hasSummaryUi && framedDetailEl) {
          const showMultiPieceDetail = !!multiPieceSummaryConfig;
          const showFramedDetail = showMultiPieceDetail ||
            (combineMainProductSummaryLine && (selectedFinishUsesFrameColour || stretchedCanvasActive));
          framedDetailEl.hidden = !showFramedDetail;
          if (showMultiPieceDetail) {
            const multiPieceFrameDescription = multiPieceIsFramed
              ? (frameColourLabel
                ? frameColourLabel + ' ' + multiPieceSummaryConfig.frameNoun
                : multiPieceSummaryConfig.frameNoun.charAt(0).toUpperCase() + multiPieceSummaryConfig.frameNoun.slice(1))
              : '';
            framedDetailEl.innerHTML =
              '<span class="pdp-pricing-summary__multi-piece-line">' + escapeHtml(multiPiecePanelDescription) + '</span>' +
              (multiPieceSize
                ? '<span class="pdp-pricing-summary__multi-piece-line">Combined artwork size: ' + escapeHtml(multiPieceSize) + '</span>'
                : '') +
              (!multiPieceIsFramed && multiPieceSummaryConfig.unframedDetail
                ? '<span class="pdp-pricing-summary__multi-piece-line">' + escapeHtml(multiPieceSummaryConfig.unframedDetail) + '</span>'
                : '') +
              (multiPieceFrameDescription
                ? '<span class="pdp-pricing-summary__multi-piece-line">' +
                  escapeHtml(multiPieceFrameDescription) +
                  ' <span class="pdp-pricing-summary__detail-sep" aria-hidden="true">&middot;</span> ' +
                  'Each panel ready to hang</span>'
                : '');
          } else {
            framedDetailEl.innerHTML = stretchedCanvasActive && showFramedDetail
              ? '<span class="pdp-pricing-summary__framed-line">' + escapeHtml(stretchedCanvasLabel) + '</span>'
              : showFramedDetail
              ? ((framedFinishDescription || overallFramedSize)
                  ? '<span class="pdp-pricing-summary__framed-line">' +
                    (framedFinishDescription
                      ? escapeHtml(framedFinishDescription) +
                        (overallFramedSize
                          ? ' <span class="pdp-pricing-summary__detail-sep" aria-hidden="true">&middot;</span> '
                          : '')
                      : '') +
                    (overallFramedSize
                      ? escapeHtml(localizedSummaryLabels.finishedSize) + ' ' + escapeHtml(overallFramedSize)
                      : '') +
                    '</span>'
                  : '') +
                '<span class="pdp-pricing-summary__framed-line">' +
                  escapeHtml(localizedSummaryLabels.readyToHang) +
                  ' <span class="pdp-pricing-summary__detail-sep" aria-hidden="true">&middot;</span> ' +
                  escapeHtml(localizedSummaryLabels.hardwareFitted) +
                '</span>' + getPushPinsSummaryHtml(selectedFinishUsesFrameColour)
              : '';
          }
        }

        const finishLineItems = [];
        const shouldPromoteFramingLine =
          !combineMainProductSummaryLine &&
          !selectedFinishIsBase &&
          (frameDelta > 0 || !!frameColourLabel) &&
          (/framed/i.test(String(selectedFinishValue || '')) || /canvas/i.test(String(selectedFinishValue || '')));
        const shouldPromoteHangerLine = !combineMainProductSummaryLine && selectedFinishIsBase && !!hangerLineItem;
        const shouldPromoteFinishLine = shouldPromoteFramingLine || shouldPromoteHangerLine;
        var promotedFinishLabel = '';
        var promotedFinishPrice = 0;
        if (shouldPromoteFinishLine) {
          if (shouldPromoteHangerLine) {
            promotedFinishLabel = '<span class="pdp-pricing-summary__base-noun">' + escapeHtml(localizedSummaryLabels.woodenHanger) + '</span>';
            if (hangerColourLabel) {
              promotedFinishLabel += ' <span class="pdp-pricing-summary__sep" aria-hidden="true">&middot;</span> <span class="pdp-pricing-summary__finish-colour">' + escapeHtml(hangerColourLabel) + '</span>';
            }
            promotedFinishPrice = Number(hangerLineItem && hangerLineItem.price || 0);
          } else {
            const isCanvasFinish = /canvas/i.test(String(selectedFinishValue || ''));
            promotedFinishLabel = '<span class="pdp-pricing-summary__base-noun">' +
              escapeHtml(stretchedCanvasActive ? stretchedCanvasLabel : (isCanvasFinish ? localizedSummaryLabels.professionalFloatFrame : localizedSummaryLabels.professionalFraming)) +
              '</span>';
            if (frameColourLabel && !stretchedCanvasActive) {
              promotedFinishLabel += ' <span class="pdp-pricing-summary__sep" aria-hidden="true">&middot;</span> <span class="pdp-pricing-summary__finish-colour">' + escapeHtml(frameColourLabel) + '</span>';
            }
            promotedFinishPrice = frameDelta;
          }
        }
        if (!combineMainProductSummaryLine && !shouldPromoteFramingLine && !selectedFinishIsBase && (frameDelta > 0 || frameColourLabel)) {
          const finishLabelText = stretchedCanvasActive ? stretchedCanvasLabel : (/canvas/i.test(String(selectedFinishValue || '')) ? localizedFramedCanvasLabel : localizedSummaryLabels.framed);
          const finishLabelWithColour = frameColourLabel && !stretchedCanvasActive
            ? (finishLabelText + ' - ' + frameColourLabel)
            : finishLabelText;
          finishLineItems.push({
            label: finishLabelWithColour,
            propertyHandle: 'finish-framing',
            price: frameDelta,
            compareAtPrice: null
          });
        }

        groupedAddons.finish.forEach(function(item) {
          if (isFrameColourHandle(item.propertyHandle)) return;
          if (shouldPromoteHangerLine && isHangerPropertyHandle(item.propertyHandle)) return;
          if (!hasRenderableLineItem(item)) return;
          const isHangerLineItem = isHangerPropertyHandle(item.propertyHandle);
          finishLineItems.push({
            label: isHangerLineItem ? localizedSummaryLabels.woodenHanger : (item.label || localizedSummaryLabels.finish),
            propertyHandle: item.propertyHandle || '',
            price: item.price || 0,
            compareAtPrice: item.compareAtPrice || null,
            selectedValueLabel: isHangerLineItem && hangerColourLabel
              ? hangerColourLabel
              : (item.selectedValueLabel || '')
          });
        });

        const personalisationItems = groupedAddons.personalisation.map(function(item) {
          return {
            label: item.label || localizedSummaryLabels.personalisation,
            propertyHandle: item.propertyHandle || '',
            price: item.price || 0,
            compareAtPrice: item.compareAtPrice || null,
            selectedValueLabel: item.selectedValueLabel || ''
          };
        }).filter(hasRenderableLineItem);
        const mapDetailRows = getMapDetailRows();
        const mapDetailItems = mapDetailRows.length ? [{
          label: localizedSummaryLabels.customMapDetails,
          propertyHandle: 'map-details',
          price: null,
          compareAtPrice: null
        }] : [];
        const flatAddonItems = finishLineItems.concat(personalisationItems, mapDetailItems);

        if (hasSummaryUi && frameRowEl && frameLabelEl && frameValueEl) {
          var promotedAddon = null;
          if (shouldPromoteFinishLine) {
            promotedAddon = {
              labelHtml: promotedFinishLabel,
              price: promotedFinishPrice,
              compareAtPrice: null
            };
          }

          if (promotedAddon) {
            frameRowEl.hidden = false;
            frameRowEl.setAttribute('data-pdp-summary-promoted', 'true');
            if (promotedAddon.labelHtml) {
              frameLabelEl.innerHTML = promotedAddon.labelHtml;
            } else {
              const promotedLabel = getSummaryFlavourLabel(promotedAddon) || localizedSummaryLabels.addOn;
              frameLabelEl.innerHTML = formatSummaryLabelPattern(promotedLabel);
            }

            if (promotedAddon.compareAtPrice && promotedAddon.compareAtPrice > (promotedAddon.price || 0)) {
              frameValueEl.innerHTML =
                '<span class="pdp-pricing-summary__compare">' + formatMoney(promotedAddon.compareAtPrice) + '</span> ' +
                '<span class="pdp-pricing-summary__value">' + formatMoney(promotedAddon.price || 0) + '</span>';
            } else if (Number(promotedAddon.price || 0) <= 0) {
              frameValueEl.innerHTML = '<span class="pdp-pricing-summary__value">' + escapeHtml(localizedSummaryLabels.included) + '</span>';
            } else {
              frameValueEl.innerHTML = (promotedAddon.price || 0) > 0 ? formatMoney(promotedAddon.price || 0) : '';
            }
          } else {
            frameRowEl.hidden = true;
            frameRowEl.removeAttribute('data-pdp-summary-promoted');
            frameLabelEl.textContent = '';
            frameValueEl.innerHTML = '';
          }
        }

        if (hasSummaryUi && finishItemsEl) {
          renderLineItems(finishItemsEl, flatAddonItems);
          finishItemsEl.hidden = flatAddonItems.length === 0;
        }

        if (hasSummaryUi && personalisationRowEl && personalisationValueEl) {
          personalisationRowEl.hidden = true;
          personalisationValueEl.innerHTML = '';
        }
        if (hasSummaryUi && addonsListEl) {
          addonsListEl.hidden = true;
          addonsListEl.innerHTML = '';
        }

        if (hasSummaryUi && totalEl) {
          totalEl.innerHTML = formatMoney(displayTotal);
        }
        if (hasSummaryUi && totalRowEl && totalCompareEl) {
          const totalIsOnSale = displayCompareAtTotal > displayTotal;
          totalRowEl.classList.toggle('pdp-pricing-summary__total--sale', totalIsOnSale);
          totalRowEl.classList.toggle('pdp-pricing-summary__total--pseudo-sale', selectedPseudoSaleActive && totalIsOnSale);
          totalCompareEl.classList.toggle('hidden', !totalIsOnSale);
          totalCompareEl.innerHTML = totalIsOnSale ? formatMoney(displayCompareAtTotal) : '';
          if (totalSaleNameEl) {
            const pseudoSaleSaving = (pseudoSaleActive || productPricing.googleDiscountActive) && totalIsOnSale
              ? Math.max(0, displayCompareAtTotal - displayTotal)
              : 0;
            totalSaleNameEl.hidden = pseudoSaleSaving <= 0;
            totalSaleNameEl.innerHTML = pseudoSaleSaving > 0
              ? (productPricing.googleDiscountActive
                  ? escapeHtml(theme.strings.exclusiveOfferLabel || 'Exclusive offer')
                  : formatSummarySavingsLabel(pseudoSaleSaving))
              : '';
          }
        }
        syncCashbackPlacement();
        sanitizePdpv3dFinishButtonLabels();

        syncSharedTotals(
          displayTotal,
          currentVariant,
          displayCompareAtTotal
        );
        if (renderRevision === pricingRenderRevision && canUseAllInTotal) {
          lastVariantConfirmation = {
            revision: renderRevision,
            key: getVariantConfirmationKey(currentVariant)
          };
        }
        logPerfCounters('renderPricing');
      }

      function getVariantConfirmationKey(variant) {
        if (!variant || !variant.available || !(variant.price > 0)) return null;
        const readiness = window.UMCPurchaseReadiness;
        if (!readiness || !readiness.isReady() || readiness.getMode() !== 'full' || window.__umPdpShareRestoring) return null;
        const domVariant = getCurrentVariantFromDom();
        if (!domVariant || String(domVariant.id) !== String(variant.id)) return null;

        // Read values and DOM flags only: no style calculation or layout reads.
        // Include free choices, saved-design fields and availability, not just price.
        const nodes = new Set([searchRoot, htmlEl, document.body]);
        const controls = Array.from(searchRoot.querySelectorAll('input, select, textarea')).map(function(control) {
          let node = control;
          while (node && node !== searchRoot) {
            nodes.add(node);
            node = node.parentElement;
          }
          return [
            control.name, control.getAttribute('name-disabled'), control.type,
            control.value, control.checked, control.disabled,
            control.options ? Array.from(control.options).map(function(option) {
              return [option.value, option.disabled, option.hidden];
            }) : null
          ];
        });
        const flags = Array.from(nodes).filter(function(node) { return node && node.nodeType === 1; }).map(function(node) {
          // This presentation class catches up on a timer; actual mode is checked above.
          const classes = node === htmlEl
            ? node.className.replace(/\bpdp-purchase-base-mode\b\s*/g, '').trim()
            : node.className;
          return [
            classes, node.getAttribute('style'), node.hidden,
            node.getAttribute('aria-hidden'), node.getAttribute('data-io-more-personalisation-expanded'),
            node.getAttribute('data-io-collapsed-1'), node.getAttribute('data-io-collapsed-2'),
            node.matches('.variant-input') ? node.querySelector('label')?.textContent : null
          ];
        });
        const canvas = window.__PDP_STRETCHED_CANVAS__;
        const quote = window.UMGoogleDiscount
          ? window.UMGoogleDiscount.resolveVariantPrice(variant, variant.price, variant.compare_at_price || 0)
          : null;
        const output = [mainPriceEl, totalEl, baseLabelEl, baseValueEl, frameLabelEl, frameValueEl, finishItemsEl, personalisationValueEl, addonsListEl].map(function(node) {
          return node ? [node.textContent, node.hidden] : null;
        });
        return JSON.stringify([
          variant.id, variant.price, variant.compare_at_price, variant.available,
          getCurrentSizeUnitPreference(), canvas && [canvas.active, canvas.preferred, canvas.label],
          window.Shopify?.currency?.active, quote, controls, flags, output
        ]);
      }

      function shouldSkipVariantConfirmation(variant) {
        if (!lastVariantConfirmation || state.pending || renderRaf !== null || settledRenderTimeout !== null) return false;
        if (lastVariantConfirmation.revision !== pricingRenderRevision) return false;
        if (!variant || String(state.variantId) !== String(variant.id)) return false;
        const key = getVariantConfirmationKey(variant);
        return key !== null && key === lastVariantConfirmation.key;
      }

      function scheduleRender(eventVariant) {
        pricingRenderRevision += 1;
        state.pending = true;
        if (eventVariant) pendingVariant = eventVariant;
        if (renderRaf !== null) return;

        renderRaf = window.requestAnimationFrame(function() {
          // Let the browser paint the native selected/checked state first.
          // Pricing and summary reconciliation can follow immediately without
          // making the user's input wait for the full render pipeline.
          window.setTimeout(function() {
            const variantForRender = pendingVariant;
            pendingVariant = null;
            renderRaf = null;
            renderPricing(variantForRender);
          }, 0);
        });
      }

      function scheduleSettledRender(delay, eventVariant) {
        if (eventVariant) pendingVariant = eventVariant;
        if (settledRenderTimeout) {
          window.clearTimeout(settledRenderTimeout);
        }
        settledRenderTimeout = window.setTimeout(function() {
          settledRenderTimeout = null;
          scheduleRender();
        }, delay);
      }

      function scheduleSettledAddonRender() {
        scheduleRender();
        scheduleSettledRender(140);
        if (settledSanitizeTimeout) {
          window.clearTimeout(settledSanitizeTimeout);
        }
        settledSanitizeTimeout = window.setTimeout(function() {
          settledSanitizeTimeout = null;
          sanitizePdpv3dFinishButtonLabels();
        }, 120);
      }

      function getPushPinsSummaryHtml(isFramed) {
        if (!isFramed || String(productSection?.dataset.productId || '') !== '15113446752640') return '';
        const checkbox = searchRoot.querySelector('.pushpins_checkbox input[type="checkbox"]');
        if (!checkbox || !checkbox.checked || checkbox.matches(':disabled')) return '';

        const styleSelect = searchRoot.querySelector('select[name="properties[Included push pins]"]');
        let styleLabel = '';
        if (styleSelect && !styleSelect.matches(':disabled')) {
          styleLabel = (styleSelect.selectedOptions[0]?.textContent || '').trim();
          if (styleSelect.value === 'Something else (type in the box)') {
            const customStyle = searchRoot.querySelector('input[name="properties[Custom push pin style]"]');
            if (customStyle && !customStyle.matches(':disabled') && customStyle.value.trim()) {
              styleLabel = customStyle.value.trim();
            }
          }
        }
        return '<span class="pdp-pricing-summary__framed-line" data-pdp-summary-push-pins>' +
          escapeHtml(localizedSummaryLabels.pushPinsIncluded) +
          (styleLabel
            ? ' <span class="pdp-pricing-summary__detail-sep" aria-hidden="true">&middot;</span> ' + escapeHtml(styleLabel)
            : '') +
          '</span>';
      }

      function bindInfiniteOptionsListeners() {
        const container = document.getElementById('infiniteoptions-container');
        const targets = [container];

        const movedFrameColourBlock = searchRoot.querySelector('[data-pdp-pricing-finish-first-finish-section] > .option_frame_colour_new');
        if (movedFrameColourBlock) {
          targets.push(movedFrameColourBlock);
        }

        searchRoot.querySelectorAll('[data-pdp-pricing-hanger], .hanger_checkbox, [data-pdp-pricing-hanger-colour], .option_hanger_colour').forEach(function(target) {
          targets.push(target);
        });

        let boundAny = false;

        targets.forEach(function(target, index) {
          if (!target) return;
          const boundKey = index === 0 ? 'pdpPricingBound' : 'pdpPricingFinishFirstBound';
          if (target.dataset[boundKey] === 'true') {
            boundAny = true;
            return;
          }

          target.dataset[boundKey] = 'true';
          target.addEventListener('change', function() {
            scheduleSettledAddonRender();
          }, true);
          target.addEventListener('input', function() {
            scheduleSettledAddonRender();
          }, true);
          target.addEventListener('click', function() {
            scheduleSettledAddonRender();
          }, true);
          boundAny = true;
        });

        return boundAny;
      }

      function waitForInfiniteOptions() {
        if (bindInfiniteOptionsListeners()) {
          restoreActiveSessionFrameColour();
          return;
        }

        const observer = new MutationObserver(function() {
          if (!bindInfiniteOptionsListeners()) return;
          observer.disconnect();
          restoreActiveSessionFrameColour();
          scheduleRender();
        });

        observer.observe(document.body, { childList: true, subtree: true });

        window.setTimeout(function() {
          observer.disconnect();
        }, 8000);
      }

      function bindSuppressionObservers() {
        if (!sizeFieldset || sizeMutationObserver) return;

        sizeMutationObserver = new MutationObserver(function(mutations) {
          if (isSyncingExpandedList) return;
          const suppressionClasses = [
            'disabled',
            'hide-oos-disable',
            'hide-oos-disabled',
            'camouflage-marked-unavailable',
            'pdp-size-option-hidden'
          ];
          const suppressionChanged = mutations.some(function(mutation) {
            if (mutation.type === 'childList') {
              // Text translation can replace nodes inside a size label. Only
              // changes to an option or its input/label affect eligibility.
              return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some(function(node) {
                return node instanceof Element && (
                  node.matches('.variant-input[data-value], label, input') ||
                  !!node.querySelector('.variant-input[data-value], label, input')
                );
              });
            }
            const target = mutation.target;
            const option = target instanceof Element && target.closest('.variant-input[data-value]');
            if (!option || (target !== option && !target.matches('input, label'))) return false;
            if (mutation.attributeName !== 'class') return true;

            const oldClasses = String(mutation.oldValue || '').split(/\s+/);
            return suppressionClasses.some(function(className) {
              const hadClass = oldClasses.indexOf(className) !== -1;
              return hadClass !== target.classList.contains(className);
            });
          });
          if (!suppressionChanged) return;
          finishFirstVariantDebug('size-observer:eligibility-change', function() { return {
            selectedSize: getSelectedOptionValue(sizePosition),
            selectedFinish: getSelectedOptionValue(finishPosition)
          }; });
          scheduleRender();
        });

        sizeMutationObserver.observe(sizeFieldset, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeOldValue: true,
          attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-hidden']
        });
      }

      const hostChangeHandler = function(event) {
        const target = event.target;
        if (!target || !(target instanceof Element)) return;

        if (target.matches('input[name="properties[Map Colour]"], select[name="properties[Map Style]"]')) {
          scheduleRender();
          return;
        }

        if (target.matches('[data-variant-input]')) {
          // Theme/app initialisers dispatch synthetic variant changes while the
          // PDP is booting. On a bare URL those are not shopper intent and must
          // not cancel the preferred Classic + framed default before its first
          // render. Trusted changes still protect a real early interaction.
          const shouldCountAsVariantInteraction =
            event.isTrusted === true ||
            !shouldAutoFramedClassicFromUrl ||
            hasAppliedBareUrlStatementDefault;
          if (shouldCountAsVariantInteraction) {
            hasVariantOptionInteraction = true;
            if (target.dataset.index === 'option' + finishPosition) {
              hasFinishOptionInteraction = true;
            }
          }
          if (event.isTrusted === true) {
            if (target.dataset.index === 'option' + sizePosition) {
              rememberActiveSessionSelection('size', target.value);
            } else if (target.dataset.index === 'option' + finishPosition) {
              rememberActiveSessionSelection('finish', target.value);
            }
          }
          if (target.dataset.index === 'option' + sizePosition) {
            lastKnownSizeValue = target.value || lastKnownSizeValue;
            intendedSizeValue = target.value || intendedSizeValue;
          } else {
            rememberCurrentSizeSelection('before non-size variant change', target);
          }
        }

        const isFinishInput = target.matches('input[type="radio"][name="Finish"]');
        const isFrameColourInput = target.matches('.option_frame_colour_new input[type="radio"][name="properties[Frame colour]"]');
        const isHangerToggleInput = target.matches('.hanger_checkbox input[type="checkbox"]');
        const isHangerColourInput = target.matches('.option_hanger_colour input[type="radio"]');

        if (isFrameColourInput && event.isTrusted === true) {
          rememberActiveSessionSelection('frameColour', target.value);
        }

        if (!isFinishInput && !isFrameColourInput && !isHangerToggleInput && !isHangerColourInput) return;
        if (isFinishInput) {
          syncFinishDependentFadeStates(target.value || '');
        }
        if (isHangerToggleInput || isHangerColourInput) {
          syncHangerFadeState();
        }
        queueRefresh();
        if (isFinishInput) {
          scheduleRender();
          scheduleSettledRender(140);
        }
        if (isHangerToggleInput || isHangerColourInput) {
          scheduleSettledAddonRender();
        }
      };

      const hostClickHandler = function(event) {
        const frameColourLabel = event.target.closest('.option_frame_colour_new label.spb-productoptionswatchwrapper');
        if (frameColourLabel) {
          if (event.isTrusted === true) {
            const frameColourInput = frameColourLabel.querySelector('input[type="radio"][name="properties[Frame colour]"]');
            if (frameColourInput && !frameColourInput.disabled) {
              rememberActiveSessionSelection('frameColour', frameColourInput.value);
            }
          }
          queueRefresh();
          return;
        }

        if (event.isTrusted === true) {
          const variantOption = event.target.closest('.variant-input[data-index]');
          const variantInput = variantOption && variantOption.querySelector('input[data-variant-input][type="radio"]');
          if (variantInput && !variantInput.disabled) {
            if (variantInput.dataset.index === 'option' + sizePosition) {
              rememberActiveSessionSelection('size', variantInput.value);
            } else if (variantInput.dataset.index === 'option' + finishPosition) {
              rememberActiveSessionSelection('finish', variantInput.value);
            }
          }
        }

        if (event.target.closest('[data-pdp-pricing-hanger], .hanger_checkbox, [data-pdp-pricing-hanger-colour], .option_hanger_colour')) {
          queueRefresh();
          scheduleSettledAddonRender();
        }
      };

      document.addEventListener('default-variant-set', function(event) {
        const variant = event.detail?.variant || null;
        if (shouldSkipVariantConfirmation(variant)) return;
        scheduleRender(variant);
      });

      document.addEventListener('variant:change', function(event) {
        scheduleRender(event.detail?.variant || null);
      });

      // Saved-design fields can arrive after the last option change/render.
      window.addEventListener('um:pdp-configuration-restored', function() {
        scheduleRender();
      });

      document.addEventListener('pdp:stretched-canvas-change', function() {
        scheduleRender();
        scheduleSettledRender(140);
      });

      window.addEventListener('um:map-refiner-updated', function() {
        scheduleRender();
      });

      document.addEventListener('click', function(event) {
        if (!event.target.closest('#cm_inch_switch')) return;
        window.requestAnimationFrame(function() {
          updateFeaturedSizeButtons();
          scheduleRender();
        });
      });

      searchRoot.addEventListener('change', hostChangeHandler, true);
      searchRoot.addEventListener('click', hostClickHandler, true);

      waitForFinishFirstLayout();
      waitForInfiniteOptions();
      bindFeaturedSizeEvents();
      bindFinishCardEvents();
      startLabelChurnDiagnostics();
      bindSuppressionObservers();
      queueRefresh();
      sanitizePdpv3dFinishButtonLabels();
      scheduleSettledRender(120);

      let attempts = 0;
      const maxAttempts = 6;
      const retry = function() {
        attempts += 1;
        if (moveDifferentialPricingBlocks()) {
          scheduleFrameColourSync();
          return;
        }
        if (attempts >= maxAttempts) return;
        window.setTimeout(retry, 250);
      };

      window.setTimeout(retry, 120);
      const refreshObserver = new MutationObserver(function(mutations) {
        const now = Date.now();
        if (now < observerCooldownUntil) return;

        for (let index = 0; index < mutations.length; index += 1) {
          const mutation = mutations[index];
          const target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : null;
          if (!target) continue;

          if (mutation.type === 'attributes') {
            if (mutation.attributeName === 'class') {
              const oldValue = mutation.oldValue || '';
              const hadHideClass = /\bhide-oos-disable\b|\bhide-oos-disabled\b/.test(oldValue);
              const hasHideClass = target.classList.contains('hide-oos-disable') || target.classList.contains('hide-oos-disabled');
              if (hadHideClass === hasHideClass) continue;
            }

            if (mutation.attributeName === 'style') {
              const oldValue = mutation.oldValue || '';
              const oldDisplay = /display\s*:\s*none/i.test(oldValue);
              const oldOpacityZero = /opacity\s*:\s*0(?:\D|$)/i.test(oldValue);
              const oldHidden = /visibility\s*:\s*hidden/i.test(oldValue);
              const newDisplay = target.style.display === 'none';
              const newOpacityZero = target.style.opacity === '0';
              const newHidden = target.style.visibility === 'hidden';
              if (
                oldDisplay === newDisplay &&
                oldOpacityZero === newOpacityZero &&
                oldHidden === newHidden
              ) {
                continue;
              }
            }
          }

          if (mutation.type === 'childList') {
            let hasRelevantChildMutation = false;
            const nodeSets = [mutation.addedNodes, mutation.removedNodes];
            for (let setIndex = 0; setIndex < nodeSets.length && !hasRelevantChildMutation; setIndex += 1) {
              const nodes = nodeSets[setIndex];
              for (let nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) {
                const node = nodes[nodeIndex];
                if (!(node instanceof Element)) continue;
                if (
                  node.matches('.option_frame_colour_new, .option_custom_frame_colour_new, .hanger_checkbox, .option_hanger_colour, input[name="properties[Frame colour]"]') ||
                  node.querySelector('.option_frame_colour_new, .option_custom_frame_colour_new, .hanger_checkbox, .option_hanger_colour, input[name="properties[Frame colour]"]')
                ) {
                  hasRelevantChildMutation = true;
                  break;
                }
              }
            }
            if (!hasRelevantChildMutation) continue;

            observerCooldownUntil = Date.now() + 90;
            queueRefresh();
            return;
          }

          if (
            target.matches('.option_frame_colour_new, .option_custom_frame_colour_new, .hanger_checkbox, .option_hanger_colour') ||
            target.closest('.option_frame_colour_new, .option_custom_frame_colour_new, .hanger_checkbox, .option_hanger_colour')
          ) {
            observerCooldownUntil = Date.now() + 90;
            queueRefresh();
            if (
              target.matches('.hanger_checkbox, .option_hanger_colour') ||
              target.closest('.hanger_checkbox, .option_hanger_colour')
            ) {
              scheduleSettledAddonRender();
            }
            return;
          }
        }
      });

      refreshObserver.observe(finishSection, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-hidden', 'aria-checked', 'value']
      });

      const infiniteOptionsRoot = document.getElementById('infiniteoptions-container');
      if (infiniteOptionsRoot && !finishSection.contains(infiniteOptionsRoot)) {
        refreshObserver.observe(infiniteOptionsRoot, {
          subtree: true,
          childList: true
        });
      }

      if (window.ResizeObserver) {
        const mainPriceBadgeResizeObserver = new ResizeObserver(scheduleMainPriceBadgeLayout);
        mainPriceBadgeResizeObserver.observe(root);
      } else {
        window.addEventListener('resize', scheduleMainPriceBadgeLayout, { passive: true });
      }

      scheduleRender(currentVariant);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPdpPricingExperiment, { once: true });
    } else {
      initPdpPricingExperiment();
    }
  })();
